//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase, HttpContext } from '@angular/common/http';
import { skipDefaultErrorHandling } from "@fluxys/common";

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');
export const DEFAULT_API_VERSION: string | undefined = undefined;

@Injectable()
export class AlertConfigurationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param api_version (optional) 
     * @return OK
     */
    getAlertConfigurations(api_version?: string | undefined, httpContext?: HttpContext): Observable<AlertConfigurationDto[]> {
        let url_ = this.baseUrl + "/api/v1/alertconfiguration?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: skipDefaultErrorHandling(true, httpContext),
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAlertConfigurations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAlertConfigurations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlertConfigurationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlertConfigurationDto[]>;
        }));
    }

    protected processGetAlertConfigurations(response: HttpResponseBase): Observable<AlertConfigurationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AlertConfigurationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param alertConfigId (optional) 
     * @param api_version (optional) 
     * @return OK
     */
    getAlertConfiguration(alertConfigId?: number | undefined, api_version?: string | undefined, httpContext?: HttpContext): Observable<AlertConfigurationDto> {
        let url_ = this.baseUrl + "/api/v1/alertconfiguration/get?";
        if (alertConfigId === null)
            throw new Error("The parameter 'alertConfigId' cannot be null.");
        else if (alertConfigId !== undefined)
            url_ += "alertConfigId=" + encodeURIComponent("" + alertConfigId) + "&";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: skipDefaultErrorHandling(true, httpContext),
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAlertConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAlertConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlertConfigurationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlertConfigurationDto>;
        }));
    }

    protected processGetAlertConfiguration(response: HttpResponseBase): Observable<AlertConfigurationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AlertConfigurationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param configurationId (optional) 
     * @param api_version (optional) 
     * @return OK
     */
    deleteAlertConfiguration(configurationId?: number | undefined, api_version?: string | undefined, httpContext?: HttpContext): Observable<number> {
        let url_ = this.baseUrl + "/api/v1/alertconfiguration/delete?";
        if (configurationId === null)
            throw new Error("The parameter 'configurationId' cannot be null.");
        else if (configurationId !== undefined)
            url_ += "configurationId=" + encodeURIComponent("" + configurationId) + "&";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: skipDefaultErrorHandling(true, httpContext),
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAlertConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAlertConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processDeleteAlertConfiguration(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param api_version (optional) 
     * @param body (optional) 
     * @return OK
     */
    saveAlertConfiguration(api_version?: string | undefined, body?: SaveAlertConfigurationRequest | undefined, httpContext?: HttpContext): Observable<AlertConfigurationDto> {
        let url_ = this.baseUrl + "/api/v1/alertconfiguration/save?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: skipDefaultErrorHandling(true, httpContext),
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveAlertConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveAlertConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlertConfigurationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlertConfigurationDto>;
        }));
    }

    protected processSaveAlertConfiguration(response: HttpResponseBase): Observable<AlertConfigurationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AlertConfigurationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param configId (optional) 
     * @param api_version (optional) 
     * @return OK
     */
    disableAlertConfiguration(configId?: number | undefined, api_version?: string | undefined, httpContext?: HttpContext): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/alertconfiguration/disable?";
        if (configId === null)
            throw new Error("The parameter 'configId' cannot be null.");
        else if (configId !== undefined)
            url_ += "configId=" + encodeURIComponent("" + configId) + "&";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: skipDefaultErrorHandling(true, httpContext),
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDisableAlertConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDisableAlertConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDisableAlertConfiguration(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param configId (optional) 
     * @param activationTimestamp (optional) 
     * @param api_version (optional) 
     * @return OK
     */
    enableAlertConfiguration(configId?: number | undefined, activationTimestamp?: Date | undefined, api_version?: string | undefined, httpContext?: HttpContext): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/alertconfiguration/enable?";
        if (configId === null)
            throw new Error("The parameter 'configId' cannot be null.");
        else if (configId !== undefined)
            url_ += "configId=" + encodeURIComponent("" + configId) + "&";
        if (activationTimestamp === null)
            throw new Error("The parameter 'activationTimestamp' cannot be null.");
        else if (activationTimestamp !== undefined)
            url_ += "activationTimestamp=" + encodeURIComponent(activationTimestamp ? "" + activationTimestamp.toISOString() : "") + "&";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: skipDefaultErrorHandling(true, httpContext),
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEnableAlertConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEnableAlertConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEnableAlertConfiguration(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param timestamp (optional) 
     * @param api_version (optional) 
     * @return OK
     */
    getFaultyCounters(timestamp?: Date | undefined, api_version?: string | undefined, httpContext?: HttpContext): Observable<{ [key: string]: AlertCounterCheckResultDto; }> {
        let url_ = this.baseUrl + "/api/v1/alertconfiguration/findfaultycounters?";
        if (timestamp === null)
            throw new Error("The parameter 'timestamp' cannot be null.");
        else if (timestamp !== undefined)
            url_ += "timestamp=" + encodeURIComponent(timestamp ? "" + timestamp.toISOString() : "") + "&";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: skipDefaultErrorHandling(true, httpContext),
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFaultyCounters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFaultyCounters(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<{ [key: string]: AlertCounterCheckResultDto; }>;
                }
            } else
                return _observableThrow(response_) as any as Observable<{ [key: string]: AlertCounterCheckResultDto; }>;
        }));
    }

    protected processGetFaultyCounters(response: HttpResponseBase): Observable<{ [key: string]: AlertCounterCheckResultDto; }> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (<any>result200)![key] = resultData200[key] ? AlertCounterCheckResultDto.fromJS(resultData200[key]) : new AlertCounterCheckResultDto();
                }
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CodeTranslationsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param api_version (optional) 
     * @param body (optional) 
     * @return OK
     */
    list(api_version?: string | undefined, body?: ListCodeTranslationsRequest | undefined, httpContext?: HttpContext): Observable<ListCodeTranslationsResponse> {
        let url_ = this.baseUrl + "/api/v1/codetranslations?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: skipDefaultErrorHandling(true, httpContext),
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListCodeTranslationsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListCodeTranslationsResponse>;
        }));
    }

    protected processList(response: HttpResponseBase): Observable<ListCodeTranslationsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListCodeTranslationsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param api_version (optional) 
     * @return OK
     */
    listPartnerCodeTranslations(api_version?: string | undefined, httpContext?: HttpContext): Observable<ListPartnerCodeTranslationsResponse> {
        let url_ = this.baseUrl + "/api/v1/codetranslations/listpartnercodetranslations?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: skipDefaultErrorHandling(true, httpContext),
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListPartnerCodeTranslations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListPartnerCodeTranslations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListPartnerCodeTranslationsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListPartnerCodeTranslationsResponse>;
        }));
    }

    protected processListPartnerCodeTranslations(response: HttpResponseBase): Observable<ListPartnerCodeTranslationsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListPartnerCodeTranslationsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param api_version (optional) 
     * @param body (optional) 
     * @return OK
     */
    save(api_version?: string | undefined, body?: SaveCodeTranslationsRequest | undefined, httpContext?: HttpContext): Observable<SaveCodeTranslationsResponse> {
        let url_ = this.baseUrl + "/api/v1/codetranslations/save?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: skipDefaultErrorHandling(true, httpContext),
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSave(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSave(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SaveCodeTranslationsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SaveCodeTranslationsResponse>;
        }));
    }

    protected processSave(response: HttpResponseBase): Observable<SaveCodeTranslationsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveCodeTranslationsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CommunicationProfilesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param api_version (optional) 
     * @return OK
     */
    getCommunicationProfiles(api_version?: string | undefined, httpContext?: HttpContext): Observable<ListCommunicationProfileResponse> {
        let url_ = this.baseUrl + "/api/v1/communicationprofiles?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: skipDefaultErrorHandling(true, httpContext),
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCommunicationProfiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCommunicationProfiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListCommunicationProfileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListCommunicationProfileResponse>;
        }));
    }

    protected processGetCommunicationProfiles(response: HttpResponseBase): Observable<ListCommunicationProfileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListCommunicationProfileResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param api_version (optional) 
     * @param body (optional) 
     * @return OK
     */
    getCommunicationProfile(api_version?: string | undefined, body?: GetCommunicationProfileRequest | undefined, httpContext?: HttpContext): Observable<GetCommunicationProfileResponse> {
        let url_ = this.baseUrl + "/api/v1/communicationprofiles/get?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: skipDefaultErrorHandling(true, httpContext),
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCommunicationProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCommunicationProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCommunicationProfileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCommunicationProfileResponse>;
        }));
    }

    protected processGetCommunicationProfile(response: HttpResponseBase): Observable<GetCommunicationProfileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCommunicationProfileResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param api_version (optional) 
     * @param body (optional) 
     * @return OK
     */
    saveCommunicationProfile(api_version?: string | undefined, body?: SaveCommunicationProfileRequest | undefined, httpContext?: HttpContext): Observable<GetCommunicationProfileResponse> {
        let url_ = this.baseUrl + "/api/v1/communicationprofiles/save?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: skipDefaultErrorHandling(true, httpContext),
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveCommunicationProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveCommunicationProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCommunicationProfileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCommunicationProfileResponse>;
        }));
    }

    protected processSaveCommunicationProfile(response: HttpResponseBase): Observable<GetCommunicationProfileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCommunicationProfileResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CoreClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param api_version (optional) 
     * @return OK
     */
    ping(api_version?: string | undefined, httpContext?: HttpContext): Observable<string> {
        let url_ = this.baseUrl + "/api/ping?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: skipDefaultErrorHandling(true, httpContext),
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPing(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPing(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processPing(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CoreDataClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param api_version (optional) 
     * @return OK
     */
    getCoreData(api_version?: string | undefined, httpContext?: HttpContext): Observable<ListCoreDataResponse> {
        let url_ = this.baseUrl + "/api/v1/coredata?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: skipDefaultErrorHandling(true, httpContext),
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCoreData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCoreData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListCoreDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListCoreDataResponse>;
        }));
    }

    protected processGetCoreData(response: HttpResponseBase): Observable<ListCoreDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListCoreDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param api_version (optional) 
     * @return OK
     */
    getPermissions(api_version?: string | undefined, httpContext?: HttpContext): Observable<string[]> {
        let url_ = this.baseUrl + "/api/v1/coredata/permissions?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: skipDefaultErrorHandling(true, httpContext),
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPermissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetPermissions(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param api_version (optional) 
     * @return OK
     */
    listPermissions(api_version?: string | undefined, httpContext?: HttpContext): Observable<ListPermissionsResponse> {
        let url_ = this.baseUrl + "/api/v1/coredata/listpermissions?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: skipDefaultErrorHandling(true, httpContext),
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListPermissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListPermissionsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListPermissionsResponse>;
        }));
    }

    protected processListPermissions(response: HttpResponseBase): Observable<ListPermissionsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListPermissionsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DashboardClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param api_version (optional) 
     * @param body (optional) 
     * @return OK
     */
    listDashboardMessagesStatus(api_version?: string | undefined, body?: ListDashboardMessagesStatusRequest | undefined, httpContext?: HttpContext): Observable<ListDashboardMessagesStatusResponse> {
        let url_ = this.baseUrl + "/api/v1/dashboard/listdashboardmessagesstatus?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: skipDefaultErrorHandling(true, httpContext),
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListDashboardMessagesStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListDashboardMessagesStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListDashboardMessagesStatusResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListDashboardMessagesStatusResponse>;
        }));
    }

    protected processListDashboardMessagesStatus(response: HttpResponseBase): Observable<ListDashboardMessagesStatusResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListDashboardMessagesStatusResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param api_version (optional) 
     * @param body (optional) 
     * @return OK
     */
    listDashboardMessagesFailStatus(api_version?: string | undefined, body?: ListDashboardMessagesStatusRequest | undefined, httpContext?: HttpContext): Observable<ListDashboardMessagesFailStatusResponse> {
        let url_ = this.baseUrl + "/api/v1/dashboard/listdashboardmessagesfailstatus?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: skipDefaultErrorHandling(true, httpContext),
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListDashboardMessagesFailStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListDashboardMessagesFailStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListDashboardMessagesFailStatusResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListDashboardMessagesFailStatusResponse>;
        }));
    }

    protected processListDashboardMessagesFailStatus(response: HttpResponseBase): Observable<ListDashboardMessagesFailStatusResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListDashboardMessagesFailStatusResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param api_version (optional) 
     * @param body (optional) 
     * @return OK
     */
    listDashboardGatewayStatus(api_version?: string | undefined, body?: ListDashboardGatewayStatusRequest | undefined, httpContext?: HttpContext): Observable<ListDashboardGatewayStatusResponse> {
        let url_ = this.baseUrl + "/api/v1/dashboard/listdashboardgatewaystatus?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: skipDefaultErrorHandling(true, httpContext),
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListDashboardGatewayStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListDashboardGatewayStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListDashboardGatewayStatusResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListDashboardGatewayStatusResponse>;
        }));
    }

    protected processListDashboardGatewayStatus(response: HttpResponseBase): Observable<ListDashboardGatewayStatusResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListDashboardGatewayStatusResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param api_version (optional) 
     * @param body (optional) 
     * @return OK
     */
    listDashboardUnknownMessages(api_version?: string | undefined, body?: ListDashboardUnknownMessagesRequest | undefined, httpContext?: HttpContext): Observable<ListDashboardUnknownMessagesResponse> {
        let url_ = this.baseUrl + "/api/v1/dashboard/listdashboardunknownmessages?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: skipDefaultErrorHandling(true, httpContext),
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListDashboardUnknownMessages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListDashboardUnknownMessages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListDashboardUnknownMessagesResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListDashboardUnknownMessagesResponse>;
        }));
    }

    protected processListDashboardUnknownMessages(response: HttpResponseBase): Observable<ListDashboardUnknownMessagesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListDashboardUnknownMessagesResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param api_version (optional) 
     * @return OK
     */
    listDashboardFileTransferStatus(api_version?: string | undefined, httpContext?: HttpContext): Observable<ListDashboardFileTransferStatusResponse> {
        let url_ = this.baseUrl + "/api/v1/dashboard/listdashboardfiletransferstatus?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: skipDefaultErrorHandling(true, httpContext),
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListDashboardFileTransferStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListDashboardFileTransferStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListDashboardFileTransferStatusResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListDashboardFileTransferStatusResponse>;
        }));
    }

    protected processListDashboardFileTransferStatus(response: HttpResponseBase): Observable<ListDashboardFileTransferStatusResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListDashboardFileTransferStatusResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class EntsogClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param api_version (optional) 
     * @return OK
     */
    getAgreementUpdatesOverview(api_version?: string | undefined, httpContext?: HttpContext): Observable<AgreementUpdateOverviewDto[]> {
        let url_ = this.baseUrl + "/api/v1/entsog?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: skipDefaultErrorHandling(true, httpContext),
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAgreementUpdatesOverview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAgreementUpdatesOverview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AgreementUpdateOverviewDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AgreementUpdateOverviewDto[]>;
        }));
    }

    protected processGetAgreementUpdatesOverview(response: HttpResponseBase): Observable<AgreementUpdateOverviewDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AgreementUpdateOverviewDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param agreementUpdateId (optional) 
     * @param api_version (optional) 
     * @return OK
     */
    getAgreementUpdate(agreementUpdateId?: string | undefined, api_version?: string | undefined, httpContext?: HttpContext): Observable<AgreementUpdateDetailDto> {
        let url_ = this.baseUrl + "/api/v1/entsog/get?";
        if (agreementUpdateId === null)
            throw new Error("The parameter 'agreementUpdateId' cannot be null.");
        else if (agreementUpdateId !== undefined)
            url_ += "agreementUpdateId=" + encodeURIComponent("" + agreementUpdateId) + "&";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: skipDefaultErrorHandling(true, httpContext),
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAgreementUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAgreementUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AgreementUpdateDetailDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AgreementUpdateDetailDto>;
        }));
    }

    protected processGetAgreementUpdate(response: HttpResponseBase): Observable<AgreementUpdateDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AgreementUpdateDetailDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param communicationProfileId (optional) 
     * @param agreementReference (optional) 
     * @param api_version (optional) 
     * @return OK
     */
    getActiveMessageSettingsForAgreementReferencePmode(communicationProfileId?: string | undefined, agreementReference?: string | undefined, api_version?: string | undefined, httpContext?: HttpContext): Observable<string[]> {
        let url_ = this.baseUrl + "/api/v1/entsog/getactivemessagesettingsforagreementreferencepmode?";
        if (communicationProfileId === null)
            throw new Error("The parameter 'communicationProfileId' cannot be null.");
        else if (communicationProfileId !== undefined)
            url_ += "communicationProfileId=" + encodeURIComponent("" + communicationProfileId) + "&";
        if (agreementReference === null)
            throw new Error("The parameter 'agreementReference' cannot be null.");
        else if (agreementReference !== undefined)
            url_ += "agreementReference=" + encodeURIComponent("" + agreementReference) + "&";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: skipDefaultErrorHandling(true, httpContext),
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActiveMessageSettingsForAgreementReferencePmode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActiveMessageSettingsForAgreementReferencePmode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetActiveMessageSettingsForAgreementReferencePmode(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param api_version (optional) 
     * @param body (optional) 
     * @return OK
     */
    saveAgreementUpdateDecision(api_version?: string | undefined, body?: SaveAgreementUpdateDecisionRequest | undefined, httpContext?: HttpContext): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/entsog/saveagreementupdatedecision?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: skipDefaultErrorHandling(true, httpContext),
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveAgreementUpdateDecision(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveAgreementUpdateDecision(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSaveAgreementUpdateDecision(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param api_version (optional) 
     * @param body (optional) 
     * @return OK
     */
    saveAgreementTerminationDecision(api_version?: string | undefined, body?: SaveAgreementTerminationDecisionRequest | undefined, httpContext?: HttpContext): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/entsog/saveagreementterminationdecision?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: skipDefaultErrorHandling(true, httpContext),
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveAgreementTerminationDecision(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveAgreementTerminationDecision(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSaveAgreementTerminationDecision(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param api_version (optional) 
     * @param body (optional) 
     * @return OK
     */
    createCertificateRequest(api_version?: string | undefined, body?: CreateAgreementRequest | undefined, httpContext?: HttpContext): Observable<string[]> {
        let url_ = this.baseUrl + "/api/v1/entsog/createcertificaterequest?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: skipDefaultErrorHandling(true, httpContext),
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCertificateRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCertificateRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processCreateCertificateRequest(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param api_version (optional) 
     * @param body (optional) 
     * @return OK
     */
    createAgreementTermination(api_version?: string | undefined, body?: CreateAgreementTerminationRequest | undefined, httpContext?: HttpContext): Observable<string[]> {
        let url_ = this.baseUrl + "/api/v1/entsog/createagreementtermination?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: skipDefaultErrorHandling(true, httpContext),
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAgreementTermination(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAgreementTermination(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processCreateAgreementTermination(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param api_version (optional) 
     * @return OK
     */
    getEntsogAs4CommunicationProfiles(api_version?: string | undefined, httpContext?: HttpContext): Observable<LabelAndValue[]> {
        let url_ = this.baseUrl + "/api/v1/entsog/getentsogas4communicationprofiles?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: skipDefaultErrorHandling(true, httpContext),
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEntsogAs4CommunicationProfiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEntsogAs4CommunicationProfiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LabelAndValue[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LabelAndValue[]>;
        }));
    }

    protected processGetEntsogAs4CommunicationProfiles(response: HttpResponseBase): Observable<LabelAndValue[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LabelAndValue.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param api_version (optional) 
     * @param body (optional) 
     * @return OK
     */
    createMultipleAgreementTerminations(api_version?: string | undefined, body?: CreateMultipleAgreementTerminationsRequest | undefined, httpContext?: HttpContext): Observable<string[]> {
        let url_ = this.baseUrl + "/api/v1/entsog/createmultipleagreementterminations?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: skipDefaultErrorHandling(true, httpContext),
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateMultipleAgreementTerminations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateMultipleAgreementTerminations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processCreateMultipleAgreementTerminations(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class EntsogCommunicationProfileClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param api_version (optional) 
     * @return OK
     */
    listEntsogAs4CommunicationProfiles(api_version?: string | undefined, httpContext?: HttpContext): Observable<ListEntsogCommunicationProfileResponse> {
        let url_ = this.baseUrl + "/api/v1/entsogcommunicationprofile?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: skipDefaultErrorHandling(true, httpContext),
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListEntsogAs4CommunicationProfiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListEntsogAs4CommunicationProfiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListEntsogCommunicationProfileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListEntsogCommunicationProfileResponse>;
        }));
    }

    protected processListEntsogAs4CommunicationProfiles(response: HttpResponseBase): Observable<ListEntsogCommunicationProfileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListEntsogCommunicationProfileResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param api_version (optional) 
     * @param body (optional) 
     * @return OK
     */
    validateMessageSettingsForProcessingMode(api_version?: string | undefined, body?: ValidateMessageSettingProcessingModeRequest | undefined, httpContext?: HttpContext): Observable<ValidateMessageSettingProcessingModeResponse> {
        let url_ = this.baseUrl + "/api/v1/entsogcommunicationprofile/validatemessagesettingsforprocessingmode?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: skipDefaultErrorHandling(true, httpContext),
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateMessageSettingsForProcessingMode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateMessageSettingsForProcessingMode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ValidateMessageSettingProcessingModeResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ValidateMessageSettingProcessingModeResponse>;
        }));
    }

    protected processValidateMessageSettingsForProcessingMode(response: HttpResponseBase): Observable<ValidateMessageSettingProcessingModeResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ValidateMessageSettingProcessingModeResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param api_version (optional) 
     * @param body (optional) 
     * @return OK
     */
    getEntsogAs4CommunicationProfile(api_version?: string | undefined, body?: GetEntsogCommunicationProfileRequest | undefined, httpContext?: HttpContext): Observable<GetEntsogCommunicationProfileResponse> {
        let url_ = this.baseUrl + "/api/v1/entsogcommunicationprofile/get?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: skipDefaultErrorHandling(true, httpContext),
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEntsogAs4CommunicationProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEntsogAs4CommunicationProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEntsogCommunicationProfileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEntsogCommunicationProfileResponse>;
        }));
    }

    protected processGetEntsogAs4CommunicationProfile(response: HttpResponseBase): Observable<GetEntsogCommunicationProfileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEntsogCommunicationProfileResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param api_version (optional) 
     * @param body (optional) 
     * @return OK
     */
    saveEntsogAs4CommunicationProfile(api_version?: string | undefined, body?: SaveEntsogCommunicationProfileRequest | undefined, httpContext?: HttpContext): Observable<GetEntsogCommunicationProfileResponse> {
        let url_ = this.baseUrl + "/api/v1/entsogcommunicationprofile/save?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: skipDefaultErrorHandling(true, httpContext),
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveEntsogAs4CommunicationProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveEntsogAs4CommunicationProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEntsogCommunicationProfileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEntsogCommunicationProfileResponse>;
        }));
    }

    protected processSaveEntsogAs4CommunicationProfile(response: HttpResponseBase): Observable<GetEntsogCommunicationProfileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEntsogCommunicationProfileResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param api_version (optional) 
     * @param body (optional) 
     * @return OK
     */
    getEntsogPartnerCommunicationProfiles(api_version?: string | undefined, body?: GetPartnerEntsogCommunicationProfileRequest | undefined, httpContext?: HttpContext): Observable<GetPartnerEntsogCommunicationProfileResponse> {
        let url_ = this.baseUrl + "/api/v1/entsogcommunicationprofile/getpartnerentsogcommunicationprofiles?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: skipDefaultErrorHandling(true, httpContext),
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEntsogPartnerCommunicationProfiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEntsogPartnerCommunicationProfiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPartnerEntsogCommunicationProfileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPartnerEntsogCommunicationProfileResponse>;
        }));
    }

    protected processGetEntsogPartnerCommunicationProfiles(response: HttpResponseBase): Observable<GetPartnerEntsogCommunicationProfileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPartnerEntsogCommunicationProfileResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MessageIdentificationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param api_version (optional) 
     * @param body (optional) 
     * @return OK
     */
    listMessageIdentificationSettings(api_version?: string | undefined, body?: ListMessageIdentificationSettingsRequest | undefined, httpContext?: HttpContext): Observable<ListMessageIdentificationSettingsResponse> {
        let url_ = this.baseUrl + "/api/v1/messageidentification/listmessageidentificationsettings?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: skipDefaultErrorHandling(true, httpContext),
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListMessageIdentificationSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListMessageIdentificationSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListMessageIdentificationSettingsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListMessageIdentificationSettingsResponse>;
        }));
    }

    protected processListMessageIdentificationSettings(response: HttpResponseBase): Observable<ListMessageIdentificationSettingsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListMessageIdentificationSettingsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param api_version (optional) 
     * @param body (optional) 
     * @return OK
     */
    saveMessageIdentificationSetting(api_version?: string | undefined, body?: MessageIdentificationSettingDto | undefined, httpContext?: HttpContext): Observable<number> {
        let url_ = this.baseUrl + "/api/v1/messageidentification/savemessageidentificationsetting?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: skipDefaultErrorHandling(true, httpContext),
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveMessageIdentificationSetting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveMessageIdentificationSetting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processSaveMessageIdentificationSetting(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param api_version (optional) 
     * @param body (optional) 
     * @return OK
     */
    saveMessageIdentificationContext(api_version?: string | undefined, body?: MessageIdentificationContextDto | undefined, httpContext?: HttpContext): Observable<number> {
        let url_ = this.baseUrl + "/api/v1/messageidentification/savemessageidentificationcontext?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: skipDefaultErrorHandling(true, httpContext),
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveMessageIdentificationContext(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveMessageIdentificationContext(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processSaveMessageIdentificationContext(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param api_version (optional) 
     * @param body (optional) 
     * @return OK
     */
    saveMessageIdentificationDetail(api_version?: string | undefined, body?: MessageIdentificationDetailDto | undefined, httpContext?: HttpContext): Observable<number> {
        let url_ = this.baseUrl + "/api/v1/messageidentification/savemessageidentificationdetail?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: skipDefaultErrorHandling(true, httpContext),
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveMessageIdentificationDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveMessageIdentificationDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processSaveMessageIdentificationDetail(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MessagesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @param messageIdentifier (optional) 
     * @param api_version (optional) 
     * @return OK
     */
    getConnectMessage(id?: string | undefined, messageIdentifier?: string | undefined, api_version?: string | undefined, httpContext?: HttpContext): Observable<GetMessageDetailResult> {
        let url_ = this.baseUrl + "/api/v1/messages/get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (messageIdentifier === null)
            throw new Error("The parameter 'messageIdentifier' cannot be null.");
        else if (messageIdentifier !== undefined)
            url_ += "messageIdentifier=" + encodeURIComponent("" + messageIdentifier) + "&";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: skipDefaultErrorHandling(true, httpContext),
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConnectMessage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConnectMessage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMessageDetailResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMessageDetailResult>;
        }));
    }

    protected processGetConnectMessage(response: HttpResponseBase): Observable<GetMessageDetailResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMessageDetailResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param api_version (optional) 
     * @param body (optional) 
     * @return OK
     */
    getAllRelationsForMessage(api_version?: string | undefined, body?: string[] | undefined, httpContext?: HttpContext): Observable<ConnectMessageRelationDto[]> {
        let url_ = this.baseUrl + "/api/v1/messages/getconnectmessagerelations?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: skipDefaultErrorHandling(true, httpContext),
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllRelationsForMessage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllRelationsForMessage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConnectMessageRelationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConnectMessageRelationDto[]>;
        }));
    }

    protected processGetAllRelationsForMessage(response: HttpResponseBase): Observable<ConnectMessageRelationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConnectMessageRelationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param api_version (optional) 
     * @param body (optional) 
     * @return OK
     */
    listConnectMessages(api_version?: string | undefined, body?: ListMessagesRequest | undefined, httpContext?: HttpContext): Observable<ListMessagesResponse> {
        let url_ = this.baseUrl + "/api/v1/messages?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: skipDefaultErrorHandling(true, httpContext),
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListConnectMessages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListConnectMessages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListMessagesResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListMessagesResponse>;
        }));
    }

    protected processListConnectMessages(response: HttpResponseBase): Observable<ListMessagesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListMessagesResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param api_version (optional) 
     * @param body (optional) 
     * @return OK
     */
    sendMessage(api_version?: string | undefined, body?: SendMessageRequest | undefined, httpContext?: HttpContext): Observable<SendMessageResponse> {
        let url_ = this.baseUrl + "/api/v1/messages/sendmessage?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: skipDefaultErrorHandling(true, httpContext),
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendMessage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendMessage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SendMessageResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SendMessageResponse>;
        }));
    }

    protected processSendMessage(response: HttpResponseBase): Observable<SendMessageResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SendMessageResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param nbrMessages (optional) 
     * @param api_version (optional) 
     * @param body (optional) 
     * @return OK
     */
    sendLoadTestMessage(nbrMessages?: number | undefined, api_version?: string | undefined, body?: SendMessageRequest | undefined, httpContext?: HttpContext): Observable<SendLodTestMessageResponse> {
        let url_ = this.baseUrl + "/api/v1/messages/sendlodtestmessage?";
        if (nbrMessages === null)
            throw new Error("The parameter 'nbrMessages' cannot be null.");
        else if (nbrMessages !== undefined)
            url_ += "nbrMessages=" + encodeURIComponent("" + nbrMessages) + "&";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: skipDefaultErrorHandling(true, httpContext),
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendLoadTestMessage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendLoadTestMessage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SendLodTestMessageResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SendLodTestMessageResponse>;
        }));
    }

    protected processSendLoadTestMessage(response: HttpResponseBase): Observable<SendLodTestMessageResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SendLodTestMessageResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param api_version (optional) 
     * @param body (optional) 
     * @return OK
     */
    sendTestMessage(api_version?: string | undefined, body?: SendTestMessageRequest | undefined, httpContext?: HttpContext): Observable<SendMessageResponse> {
        let url_ = this.baseUrl + "/api/v1/messages/sendtestmessage?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: skipDefaultErrorHandling(true, httpContext),
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendTestMessage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendTestMessage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SendMessageResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SendMessageResponse>;
        }));
    }

    protected processSendTestMessage(response: HttpResponseBase): Observable<SendMessageResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SendMessageResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param api_version (optional) 
     * @param body (optional) 
     * @return OK
     */
    resendMessage(api_version?: string | undefined, body?: ResendMessageRequest | undefined, httpContext?: HttpContext): Observable<ResendMessageResponse> {
        let url_ = this.baseUrl + "/api/v1/messages/resendmessage?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: skipDefaultErrorHandling(true, httpContext),
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResendMessage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResendMessage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResendMessageResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResendMessageResponse>;
        }));
    }

    protected processResendMessage(response: HttpResponseBase): Observable<ResendMessageResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResendMessageResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param api_version (optional) 
     * @param body (optional) 
     * @return OK
     */
    reprocessMessage(api_version?: string | undefined, body?: ReprocessMessageRequest | undefined, httpContext?: HttpContext): Observable<ReprocessMessageResponse> {
        let url_ = this.baseUrl + "/api/v1/messages/reprocessmessage?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: skipDefaultErrorHandling(true, httpContext),
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReprocessMessage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReprocessMessage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReprocessMessageResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReprocessMessageResponse>;
        }));
    }

    protected processReprocessMessage(response: HttpResponseBase): Observable<ReprocessMessageResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReprocessMessageResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param api_version (optional) 
     * @param body (optional) 
     * @return OK
     */
    downloadMessage(api_version?: string | undefined, body?: DownloadMessageRequest | undefined, httpContext?: HttpContext): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/messages/downloadmessage?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: skipDefaultErrorHandling(true, httpContext),
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadMessage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadMessage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadMessage(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param api_version (optional) 
     * @param body (optional) 
     * @return OK
     */
    downloadMessageFormat(api_version?: string | undefined, body?: DownloadMessageFormatRequest | undefined, httpContext?: HttpContext): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/messages/downloadmessageformat?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: skipDefaultErrorHandling(true, httpContext),
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadMessageFormat(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadMessageFormat(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadMessageFormat(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param stage (optional) 
     * @param api_version (optional) 
     * @return OK
     */
    moveFromSingleToAggregatedFolder(stage?: MapStage | undefined, api_version?: string | undefined, httpContext?: HttpContext): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/messages/movefromsingletoaggregatedfolder?";
        if (stage === null)
            throw new Error("The parameter 'stage' cannot be null.");
        else if (stage !== undefined)
            url_ += "stage=" + encodeURIComponent("" + stage) + "&";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: skipDefaultErrorHandling(true, httpContext),
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveFromSingleToAggregatedFolder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveFromSingleToAggregatedFolder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processMoveFromSingleToAggregatedFolder(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param api_version (optional) 
     * @param body (optional) 
     * @return OK
     */
    moveFromSingleToAggregatedFolderOrdered(api_version?: string | undefined, body?: ListMessagesRequest | undefined, httpContext?: HttpContext): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/messages/movefromsingletoaggregatedfolderfiltered?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: skipDefaultErrorHandling(true, httpContext),
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveFromSingleToAggregatedFolderOrdered(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveFromSingleToAggregatedFolderOrdered(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processMoveFromSingleToAggregatedFolderOrdered(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param api_version (optional) 
     * @return OK
     */
    moveFromAggregatedToSingleFolder(api_version?: string | undefined, httpContext?: HttpContext): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/messages/movefromaggregatedtosinglefolder?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: skipDefaultErrorHandling(true, httpContext),
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveFromAggregatedToSingleFolder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveFromAggregatedToSingleFolder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processMoveFromAggregatedToSingleFolder(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param api_version (optional) 
     * @return OK
     */
    deleteSymLinks(api_version?: string | undefined, httpContext?: HttpContext): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/messages/deletesymlinks?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: skipDefaultErrorHandling(true, httpContext),
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteSymLinks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteSymLinks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteSymLinks(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param mapStage (optional) 
     * @param api_version (optional) 
     * @return OK
     */
    fileCountInSingleFolder(mapStage?: MapStage | undefined, api_version?: string | undefined, httpContext?: HttpContext): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/messages/filecountinsinglefolder?";
        if (mapStage === null)
            throw new Error("The parameter 'mapStage' cannot be null.");
        else if (mapStage !== undefined)
            url_ += "mapStage=" + encodeURIComponent("" + mapStage) + "&";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: skipDefaultErrorHandling(true, httpContext),
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFileCountInSingleFolder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFileCountInSingleFolder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processFileCountInSingleFolder(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param mapStage (optional) 
     * @param api_version (optional) 
     * @return OK
     */
    fileCountInAggregatedFolder(mapStage?: MapStage | undefined, api_version?: string | undefined, httpContext?: HttpContext): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/messages/filecountinaggregatedfolder?";
        if (mapStage === null)
            throw new Error("The parameter 'mapStage' cannot be null.");
        else if (mapStage !== undefined)
            url_ += "mapStage=" + encodeURIComponent("" + mapStage) + "&";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: skipDefaultErrorHandling(true, httpContext),
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFileCountInAggregatedFolder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFileCountInAggregatedFolder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processFileCountInAggregatedFolder(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class MessageSettingsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param api_version (optional) 
     * @return OK
     */
    listMessageSettings(api_version?: string | undefined, httpContext?: HttpContext): Observable<ListMessageSettingsResponse> {
        let url_ = this.baseUrl + "/api/v1/messagesettings?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: skipDefaultErrorHandling(true, httpContext),
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListMessageSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListMessageSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListMessageSettingsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListMessageSettingsResponse>;
        }));
    }

    protected processListMessageSettings(response: HttpResponseBase): Observable<ListMessageSettingsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListMessageSettingsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param api_version (optional) 
     * @param body (optional) 
     * @return OK
     */
    getMessageSetting(api_version?: string | undefined, body?: GetMessageSettingDetailRequest | undefined, httpContext?: HttpContext): Observable<GetMessageSettingDetailResponse> {
        let url_ = this.baseUrl + "/api/v1/messagesettings/get?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: skipDefaultErrorHandling(true, httpContext),
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMessageSetting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMessageSetting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMessageSettingDetailResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMessageSettingDetailResponse>;
        }));
    }

    protected processGetMessageSetting(response: HttpResponseBase): Observable<GetMessageSettingDetailResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMessageSettingDetailResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param api_version (optional) 
     * @param body (optional) 
     * @return OK
     */
    saveMessageSetting(api_version?: string | undefined, body?: SaveMessageSettingDetailRequest | undefined, httpContext?: HttpContext): Observable<SaveMessageSettingDetailResponse> {
        let url_ = this.baseUrl + "/api/v1/messagesettings/save?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: skipDefaultErrorHandling(true, httpContext),
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveMessageSetting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveMessageSetting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SaveMessageSettingDetailResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SaveMessageSettingDetailResponse>;
        }));
    }

    protected processSaveMessageSetting(response: HttpResponseBase): Observable<SaveMessageSettingDetailResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveMessageSettingDetailResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PartnersClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param api_version (optional) 
     * @return OK
     */
    getPartners(api_version?: string | undefined, httpContext?: HttpContext): Observable<PartnerListItemDto[]> {
        let url_ = this.baseUrl + "/api/v1/partners?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: skipDefaultErrorHandling(true, httpContext),
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPartners(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPartners(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PartnerListItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PartnerListItemDto[]>;
        }));
    }

    protected processGetPartners(response: HttpResponseBase): Observable<PartnerListItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PartnerListItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param api_version (optional) 
     * @param body (optional) 
     * @return OK
     */
    getPartner(api_version?: string | undefined, body?: GetPartnerDetailRequest | undefined, httpContext?: HttpContext): Observable<PartnerDto> {
        let url_ = this.baseUrl + "/api/v1/partners/get?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: skipDefaultErrorHandling(true, httpContext),
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPartner(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPartner(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PartnerDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PartnerDto>;
        }));
    }

    protected processGetPartner(response: HttpResponseBase): Observable<PartnerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PartnerDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param api_version (optional) 
     * @param body (optional) 
     * @return OK
     */
    savePartner(api_version?: string | undefined, body?: SavePartnerDetailRequest | undefined, httpContext?: HttpContext): Observable<SavePartnerDetailResponse> {
        let url_ = this.baseUrl + "/api/v1/partners/save?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: skipDefaultErrorHandling(true, httpContext),
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSavePartner(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSavePartner(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SavePartnerDetailResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SavePartnerDetailResponse>;
        }));
    }

    protected processSavePartner(response: HttpResponseBase): Observable<SavePartnerDetailResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SavePartnerDetailResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param api_version (optional) 
     * @return OK
     */
    getExistingConnectCodes(api_version?: string | undefined, httpContext?: HttpContext): Observable<string[]> {
        let url_ = this.baseUrl + "/api/v1/partners/getexistingconnectcodes?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: skipDefaultErrorHandling(true, httpContext),
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExistingConnectCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExistingConnectCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetExistingConnectCodes(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param api_version (optional) 
     * @return OK
     */
    getExistingPartnerNames(api_version?: string | undefined, httpContext?: HttpContext): Observable<string[]> {
        let url_ = this.baseUrl + "/api/v1/partners/getexistingpartnernames?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: skipDefaultErrorHandling(true, httpContext),
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExistingPartnerNames(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExistingPartnerNames(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetExistingPartnerNames(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param api_version (optional) 
     * @param body (optional) 
     * @return OK
     */
    checkActiveMessageSettings(api_version?: string | undefined, body?: CheckActiveMessageSettingsRequest | undefined, httpContext?: HttpContext): Observable<boolean> {
        let url_ = this.baseUrl + "/api/v1/partners/checkactivemessagesettings?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: skipDefaultErrorHandling(true, httpContext),
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckActiveMessageSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckActiveMessageSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckActiveMessageSettings(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param api_version (optional) 
     * @param body (optional) 
     * @return OK
     */
    checkActiveCommunicationProfiles(api_version?: string | undefined, body?: CheckActiveCommunicationProfilesRequest | undefined, httpContext?: HttpContext): Observable<boolean> {
        let url_ = this.baseUrl + "/api/v1/partners/checkactivecommunicationprofiles?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: skipDefaultErrorHandling(true, httpContext),
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckActiveCommunicationProfiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckActiveCommunicationProfiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckActiveCommunicationProfiles(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SecretsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param api_version (optional) 
     * @param body (optional) 
     * @return OK
     */
    saveSecret(api_version?: string | undefined, body?: SaveSecretRequest | undefined, httpContext?: HttpContext): Observable<SaveSecretResponse> {
        let url_ = this.baseUrl + "/api/v1/secrets/save?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: skipDefaultErrorHandling(true, httpContext),
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveSecret(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveSecret(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SaveSecretResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SaveSecretResponse>;
        }));
    }

    protected processSaveSecret(response: HttpResponseBase): Observable<SaveSecretResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveSecretResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param api_version (optional) 
     * @return OK
     */
    getCertificate(id?: string | undefined, api_version?: string | undefined, httpContext?: HttpContext): Observable<GetSecretResponse> {
        let url_ = this.baseUrl + "/api/v1/secrets/get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: skipDefaultErrorHandling(true, httpContext),
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCertificate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCertificate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSecretResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSecretResponse>;
        }));
    }

    protected processGetCertificate(response: HttpResponseBase): Observable<GetSecretResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSecretResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param secretIds (optional) 
     * @param partnerId (optional) 
     * @param api_version (optional) 
     * @return OK
     */
    listCertificate(secretIds?: string[] | undefined, partnerId?: string | undefined, api_version?: string | undefined, httpContext?: HttpContext): Observable<ListSecretResponse> {
        let url_ = this.baseUrl + "/api/v1/secrets?";
        if (secretIds === null)
            throw new Error("The parameter 'secretIds' cannot be null.");
        else if (secretIds !== undefined)
            secretIds && secretIds.forEach(item => { url_ += "SecretIds=" + encodeURIComponent("" + item) + "&"; });
        if (partnerId === null)
            throw new Error("The parameter 'partnerId' cannot be null.");
        else if (partnerId !== undefined)
            url_ += "PartnerId=" + encodeURIComponent("" + partnerId) + "&";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: skipDefaultErrorHandling(true, httpContext),
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListCertificate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListCertificate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListSecretResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListSecretResponse>;
        }));
    }

    protected processListCertificate(response: HttpResponseBase): Observable<ListSecretResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListSecretResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param api_version (optional) 
     * @return OK
     */
    listExpiringSecrets(api_version?: string | undefined, httpContext?: HttpContext): Observable<ListExpiringSecretsResponse> {
        let url_ = this.baseUrl + "/api/v1/secrets/expiring?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: skipDefaultErrorHandling(true, httpContext),
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListExpiringSecrets(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListExpiringSecrets(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListExpiringSecretsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListExpiringSecretsResponse>;
        }));
    }

    protected processListExpiringSecrets(response: HttpResponseBase): Observable<ListExpiringSecretsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListExpiringSecretsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param api_version (optional) 
     * @param body (optional) 
     * @param file (optional) 
     * @param isForEntsogPublicCertificate (optional) 
     * @return OK
     */
    parseCertificate(api_version?: string | undefined, body?: Body | undefined, file?: FileParameter | undefined, isForEntsogPublicCertificate?: boolean | undefined, httpContext?: HttpContext): Observable<ParseCertificateResponse> {
        let url_ = this.baseUrl + "/api/v1/secrets/parse?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        if (isForEntsogPublicCertificate === null || isForEntsogPublicCertificate === undefined)
            throw new Error("The parameter 'isForEntsogPublicCertificate' cannot be null.");
        else
            content_.append("IsForEntsogPublicCertificate", isForEntsogPublicCertificate.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: skipDefaultErrorHandling(true, httpContext),
            headers: new HttpHeaders({
                "Content-Type": "multipart/form-data",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processParseCertificate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processParseCertificate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParseCertificateResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParseCertificateResponse>;
        }));
    }

    protected processParseCertificate(response: HttpResponseBase): Observable<ParseCertificateResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ParseCertificateResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param secretName (optional) 
     * @param api_version (optional) 
     * @return OK
     */
    parsePrivateCertificate(secretName?: string | undefined, api_version?: string | undefined, httpContext?: HttpContext): Observable<ParseCertificateResponse> {
        let url_ = this.baseUrl + "/api/v1/secrets/parseprivate?";
        if (secretName === null)
            throw new Error("The parameter 'secretName' cannot be null.");
        else if (secretName !== undefined)
            url_ += "secretName=" + encodeURIComponent("" + secretName) + "&";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: skipDefaultErrorHandling(true, httpContext),
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processParsePrivateCertificate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processParsePrivateCertificate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParseCertificateResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParseCertificateResponse>;
        }));
    }

    protected processParsePrivateCertificate(response: HttpResponseBase): Observable<ParseCertificateResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ParseCertificateResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param api_version (optional) 
     * @param body (optional) 
     * @return OK
     */
    deleteCertificate(api_version?: string | undefined, body?: DeleteSecretRequest | undefined, httpContext?: HttpContext): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/secrets/delete?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: skipDefaultErrorHandling(true, httpContext),
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCertificate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCertificate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteCertificate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param secretId (optional) 
     * @param api_version (optional) 
     * @return OK
     */
    downloadSecret(secretId?: string | undefined, api_version?: string | undefined, httpContext?: HttpContext): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/secrets/content?";
        if (secretId === null)
            throw new Error("The parameter 'secretId' cannot be null.");
        else if (secretId !== undefined)
            url_ += "secretId=" + encodeURIComponent("" + secretId) + "&";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: skipDefaultErrorHandling(true, httpContext),
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadSecret(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadSecret(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadSecret(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TenantsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param api_version (optional) 
     * @return OK
     */
    getTenants(tenantIds: string[], api_version?: string | undefined, httpContext?: HttpContext): Observable<GetTenantsResponse> {
        let url_ = this.baseUrl + "/api/v1/tenants/get?";
        if (tenantIds === undefined || tenantIds === null)
            throw new Error("The parameter 'tenantIds' must be defined and cannot be null.");
        else
            tenantIds && tenantIds.forEach(item => { url_ += "TenantIds=" + encodeURIComponent("" + item) + "&"; });
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            context: skipDefaultErrorHandling(true, httpContext),
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenants(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenants(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTenantsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTenantsResponse>;
        }));
    }

    protected processGetTenants(response: HttpResponseBase): Observable<GetTenantsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTenantsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param api_version (optional) 
     * @param body (optional) 
     * @return OK
     */
    setMaintenanceModes(api_version?: string | undefined, body?: TenantsMaintenanceRequest | undefined, httpContext?: HttpContext): Observable<TenantsMaintenanceResponse> {
        let url_ = this.baseUrl + "/api/v1/tenants/setmaintenancemode?";
        if (api_version === null)
            throw new Error("The parameter 'api_version' cannot be null.");
        else if (api_version !== undefined)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            context: skipDefaultErrorHandling(true, httpContext),
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetMaintenanceModes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetMaintenanceModes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantsMaintenanceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantsMaintenanceResponse>;
        }));
    }

    protected processSetMaintenanceModes(response: HttpResponseBase): Observable<TenantsMaintenanceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantsMaintenanceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class GetMessageDetailResult implements IGetMessageDetailResult {
    connectMessageDetailDto?: ConnectMessageDetailDto | undefined;
    originalFormat?: string | undefined;
    transformedFormat?: string | undefined;
    htmlDto?: HtmlDto | undefined;
    contentDto?: GenericContentDto | undefined;

    constructor(data?: IGetMessageDetailResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.connectMessageDetailDto = _data["connectMessageDetailDto"] ? ConnectMessageDetailDto.fromJS(_data["connectMessageDetailDto"]) : <any>undefined;
            this.originalFormat = _data["originalFormat"];
            this.transformedFormat = _data["transformedFormat"];
            this.htmlDto = _data["htmlDto"] ? HtmlDto.fromJS(_data["htmlDto"]) : <any>undefined;
            this.contentDto = _data["contentDto"] ? GenericContentDto.fromJS(_data["contentDto"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetMessageDetailResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetMessageDetailResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["connectMessageDetailDto"] = this.connectMessageDetailDto ? this.connectMessageDetailDto.toJSON() : <any>undefined;
        data["originalFormat"] = this.originalFormat;
        data["transformedFormat"] = this.transformedFormat;
        data["htmlDto"] = this.htmlDto ? this.htmlDto.toJSON() : <any>undefined;
        data["contentDto"] = this.contentDto ? this.contentDto.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetMessageDetailResult {
    connectMessageDetailDto?: ConnectMessageDetailDto | undefined;
    originalFormat?: string | undefined;
    transformedFormat?: string | undefined;
    htmlDto?: HtmlDto | undefined;
    contentDto?: GenericContentDto | undefined;
}

export class ListDashboardMessagesStatusResponse implements IListDashboardMessagesStatusResponse {
    dashboardMessageStatusListItemDtos!: DashboardMessageStatusListItemDto[];
    amqpTenantStatusListItemDtos!: AmqpTenantStatusListItemDto[];

    constructor(data?: IListDashboardMessagesStatusResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.dashboardMessageStatusListItemDtos = [];
            this.amqpTenantStatusListItemDtos = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["dashboardMessageStatusListItemDtos"])) {
                this.dashboardMessageStatusListItemDtos = [] as any;
                for (let item of _data["dashboardMessageStatusListItemDtos"])
                    this.dashboardMessageStatusListItemDtos!.push(DashboardMessageStatusListItemDto.fromJS(item));
            }
            if (Array.isArray(_data["amqpTenantStatusListItemDtos"])) {
                this.amqpTenantStatusListItemDtos = [] as any;
                for (let item of _data["amqpTenantStatusListItemDtos"])
                    this.amqpTenantStatusListItemDtos!.push(AmqpTenantStatusListItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListDashboardMessagesStatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ListDashboardMessagesStatusResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.dashboardMessageStatusListItemDtos)) {
            data["dashboardMessageStatusListItemDtos"] = [];
            for (let item of this.dashboardMessageStatusListItemDtos)
                data["dashboardMessageStatusListItemDtos"].push(item.toJSON());
        }
        if (Array.isArray(this.amqpTenantStatusListItemDtos)) {
            data["amqpTenantStatusListItemDtos"] = [];
            for (let item of this.amqpTenantStatusListItemDtos)
                data["amqpTenantStatusListItemDtos"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListDashboardMessagesStatusResponse {
    dashboardMessageStatusListItemDtos: DashboardMessageStatusListItemDto[];
    amqpTenantStatusListItemDtos: AmqpTenantStatusListItemDto[];
}

export class AgreementUpdateDetailDto implements IAgreementUpdateDetailDto {
    partnerCommunicationProfileId!: string;
    agreementUpdateId!: string;
    agreementReferenceId!: string;
    status?: string | undefined;
    requestMessageConnectMessageId?: string | undefined;
    responseMessageConnectMessageId?: string | undefined;
    requestMessageContent?: string | undefined;
    responseMessageContent?: string | undefined;
    requestTimestamp?: Date;
    responseTimestamp?: Date | undefined;
    expirationTimestamp?: Date | undefined;
    hasDecision?: boolean;
    senderCode?: string | undefined;
    receiverCode?: string | undefined;
    currentAgreementReference?: string | undefined;

    constructor(data?: IAgreementUpdateDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partnerCommunicationProfileId = _data["partnerCommunicationProfileId"];
            this.agreementUpdateId = _data["agreementUpdateId"];
            this.agreementReferenceId = _data["agreementReferenceId"];
            this.status = _data["status"];
            this.requestMessageConnectMessageId = _data["requestMessageConnectMessageId"];
            this.responseMessageConnectMessageId = _data["responseMessageConnectMessageId"];
            this.requestMessageContent = _data["requestMessageContent"];
            this.responseMessageContent = _data["responseMessageContent"];
            this.requestTimestamp = _data["requestTimestamp"] ? new Date(_data["requestTimestamp"].toString()) : <any>undefined;
            this.responseTimestamp = _data["responseTimestamp"] ? new Date(_data["responseTimestamp"].toString()) : <any>undefined;
            this.expirationTimestamp = _data["expirationTimestamp"] ? new Date(_data["expirationTimestamp"].toString()) : <any>undefined;
            this.hasDecision = _data["hasDecision"];
            this.senderCode = _data["senderCode"];
            this.receiverCode = _data["receiverCode"];
            this.currentAgreementReference = _data["currentAgreementReference"];
        }
    }

    static fromJS(data: any): AgreementUpdateDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgreementUpdateDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partnerCommunicationProfileId"] = this.partnerCommunicationProfileId;
        data["agreementUpdateId"] = this.agreementUpdateId;
        data["agreementReferenceId"] = this.agreementReferenceId;
        data["status"] = this.status;
        data["requestMessageConnectMessageId"] = this.requestMessageConnectMessageId;
        data["responseMessageConnectMessageId"] = this.responseMessageConnectMessageId;
        data["requestMessageContent"] = this.requestMessageContent;
        data["responseMessageContent"] = this.responseMessageContent;
        data["requestTimestamp"] = this.requestTimestamp ? this.requestTimestamp.toISOString() : <any>undefined;
        data["responseTimestamp"] = this.responseTimestamp ? this.responseTimestamp.toISOString() : <any>undefined;
        data["expirationTimestamp"] = this.expirationTimestamp ? this.expirationTimestamp.toISOString() : <any>undefined;
        data["hasDecision"] = this.hasDecision;
        data["senderCode"] = this.senderCode;
        data["receiverCode"] = this.receiverCode;
        data["currentAgreementReference"] = this.currentAgreementReference;
        return data;
    }
}

export interface IAgreementUpdateDetailDto {
    partnerCommunicationProfileId: string;
    agreementUpdateId: string;
    agreementReferenceId: string;
    status?: string | undefined;
    requestMessageConnectMessageId?: string | undefined;
    responseMessageConnectMessageId?: string | undefined;
    requestMessageContent?: string | undefined;
    responseMessageContent?: string | undefined;
    requestTimestamp?: Date;
    responseTimestamp?: Date | undefined;
    expirationTimestamp?: Date | undefined;
    hasDecision?: boolean;
    senderCode?: string | undefined;
    receiverCode?: string | undefined;
    currentAgreementReference?: string | undefined;
}

export class LabelAndValue implements ILabelAndValue {
    label!: string;
    value!: string;

    constructor(data?: ILabelAndValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): LabelAndValue {
        data = typeof data === 'object' ? data : {};
        let result = new LabelAndValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["value"] = this.value;
        return data;
    }
}

export interface ILabelAndValue {
    label: string;
    value: string;
}

export class MessageIdentificationSettingDataDto implements IMessageIdentificationSettingDataDto {
    id!: string;
    messageTypeCode!: string;
    format!: string;
    versionStrategyType!: string;

    constructor(data?: IMessageIdentificationSettingDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.messageTypeCode = _data["messageTypeCode"];
            this.format = _data["format"];
            this.versionStrategyType = _data["versionStrategyType"];
        }
    }

    static fromJS(data: any): MessageIdentificationSettingDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new MessageIdentificationSettingDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["messageTypeCode"] = this.messageTypeCode;
        data["format"] = this.format;
        data["versionStrategyType"] = this.versionStrategyType;
        return data;
    }
}

export interface IMessageIdentificationSettingDataDto {
    id: string;
    messageTypeCode: string;
    format: string;
    versionStrategyType: string;
}

export class MessageTypeSpecificationCoreDataDto implements IMessageTypeSpecificationCoreDataDto {
    messageTypeCode!: string;
    messageFormatCode!: string;
    messageStandardCode!: string;
    version!: string;
    id!: string;

    constructor(data?: IMessageTypeSpecificationCoreDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messageTypeCode = _data["messageTypeCode"];
            this.messageFormatCode = _data["messageFormatCode"];
            this.messageStandardCode = _data["messageStandardCode"];
            this.version = _data["version"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MessageTypeSpecificationCoreDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new MessageTypeSpecificationCoreDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messageTypeCode"] = this.messageTypeCode;
        data["messageFormatCode"] = this.messageFormatCode;
        data["messageStandardCode"] = this.messageStandardCode;
        data["version"] = this.version;
        data["id"] = this.id;
        return data;
    }
}

export interface IMessageTypeSpecificationCoreDataDto {
    messageTypeCode: string;
    messageFormatCode: string;
    messageStandardCode: string;
    version: string;
    id: string;
}

export class ListCoreDataResponse implements IListCoreDataResponse {
    messageStatusCoreDataDtos!: MessageStatusDto[];
    messageTypeCoreDataDtos!: MessageTypeDto[];
    partnerCoreDataDtos!: PartnerListItemDto[];
    communicationProfileCoreDataDtos!: CommunicationProfileListItemDto[];
    communicationProtocolCoreDataDtos!: CommunicationProtocolDto[];
    messageTypeSpecificationCoreDataDtos!: MessageTypeSpecificationCoreDataDto[];
    directions!: string[];
    codingTypes!: string[];
    externalProtocolCodes!: string[];
    datePeriodCoreDataDtos!: DatePeriodDto[];
    tenantCoreDataDtos!: TenantListItemDto[];
    retryStrategyCoreDataDtos!: RetryStrategyCoreDataDto[];
    messageEnvelopeCoreDataDtos!: MessageEnvelopeDto[];
    transportTypeCoreDataDtos!: TransportTypeDto[];
    signatureAlgorithms!: string[];
    hashAlgorithms!: string[];
    encryptionAlgorithms!: LabelAndValue[];
    securityTokenFormats!: LabelAndValue[];
    contentTypes!: LabelAndValue[];
    secretType!: string[];
    secretSubType!: string[];
    secretUsage!: string[];
    messageIdentificationSettingDataDtos!: MessageIdentificationSettingDataDto[];
    sslModes!: LabelAndValue[];
    soapImplementationType!: string[];
    soapClientCredentialType!: string[];
    soapSecurityModeType!: string[];
    communicationPartnerCoreDataDtos!: PartnerListItemDto[];

    constructor(data?: IListCoreDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messageStatusCoreDataDtos = [];
            this.messageTypeCoreDataDtos = [];
            this.partnerCoreDataDtos = [];
            this.communicationProfileCoreDataDtos = [];
            this.communicationProtocolCoreDataDtos = [];
            this.messageTypeSpecificationCoreDataDtos = [];
            this.directions = [];
            this.codingTypes = [];
            this.externalProtocolCodes = [];
            this.datePeriodCoreDataDtos = [];
            this.tenantCoreDataDtos = [];
            this.retryStrategyCoreDataDtos = [];
            this.messageEnvelopeCoreDataDtos = [];
            this.transportTypeCoreDataDtos = [];
            this.signatureAlgorithms = [];
            this.hashAlgorithms = [];
            this.encryptionAlgorithms = [];
            this.securityTokenFormats = [];
            this.contentTypes = [];
            this.secretType = [];
            this.secretSubType = [];
            this.secretUsage = [];
            this.messageIdentificationSettingDataDtos = [];
            this.sslModes = [];
            this.soapImplementationType = [];
            this.soapClientCredentialType = [];
            this.soapSecurityModeType = [];
            this.communicationPartnerCoreDataDtos = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messageStatusCoreDataDtos"])) {
                this.messageStatusCoreDataDtos = [] as any;
                for (let item of _data["messageStatusCoreDataDtos"])
                    this.messageStatusCoreDataDtos!.push(MessageStatusDto.fromJS(item));
            }
            if (Array.isArray(_data["messageTypeCoreDataDtos"])) {
                this.messageTypeCoreDataDtos = [] as any;
                for (let item of _data["messageTypeCoreDataDtos"])
                    this.messageTypeCoreDataDtos!.push(MessageTypeDto.fromJS(item));
            }
            if (Array.isArray(_data["partnerCoreDataDtos"])) {
                this.partnerCoreDataDtos = [] as any;
                for (let item of _data["partnerCoreDataDtos"])
                    this.partnerCoreDataDtos!.push(PartnerListItemDto.fromJS(item));
            }
            if (Array.isArray(_data["communicationProfileCoreDataDtos"])) {
                this.communicationProfileCoreDataDtos = [] as any;
                for (let item of _data["communicationProfileCoreDataDtos"])
                    this.communicationProfileCoreDataDtos!.push(CommunicationProfileListItemDto.fromJS(item));
            }
            if (Array.isArray(_data["communicationProtocolCoreDataDtos"])) {
                this.communicationProtocolCoreDataDtos = [] as any;
                for (let item of _data["communicationProtocolCoreDataDtos"])
                    this.communicationProtocolCoreDataDtos!.push(CommunicationProtocolDto.fromJS(item));
            }
            if (Array.isArray(_data["messageTypeSpecificationCoreDataDtos"])) {
                this.messageTypeSpecificationCoreDataDtos = [] as any;
                for (let item of _data["messageTypeSpecificationCoreDataDtos"])
                    this.messageTypeSpecificationCoreDataDtos!.push(MessageTypeSpecificationCoreDataDto.fromJS(item));
            }
            if (Array.isArray(_data["directions"])) {
                this.directions = [] as any;
                for (let item of _data["directions"])
                    this.directions!.push(item);
            }
            if (Array.isArray(_data["codingTypes"])) {
                this.codingTypes = [] as any;
                for (let item of _data["codingTypes"])
                    this.codingTypes!.push(item);
            }
            if (Array.isArray(_data["externalProtocolCodes"])) {
                this.externalProtocolCodes = [] as any;
                for (let item of _data["externalProtocolCodes"])
                    this.externalProtocolCodes!.push(item);
            }
            if (Array.isArray(_data["datePeriodCoreDataDtos"])) {
                this.datePeriodCoreDataDtos = [] as any;
                for (let item of _data["datePeriodCoreDataDtos"])
                    this.datePeriodCoreDataDtos!.push(DatePeriodDto.fromJS(item));
            }
            if (Array.isArray(_data["tenantCoreDataDtos"])) {
                this.tenantCoreDataDtos = [] as any;
                for (let item of _data["tenantCoreDataDtos"])
                    this.tenantCoreDataDtos!.push(TenantListItemDto.fromJS(item));
            }
            if (Array.isArray(_data["retryStrategyCoreDataDtos"])) {
                this.retryStrategyCoreDataDtos = [] as any;
                for (let item of _data["retryStrategyCoreDataDtos"])
                    this.retryStrategyCoreDataDtos!.push(RetryStrategyCoreDataDto.fromJS(item));
            }
            if (Array.isArray(_data["messageEnvelopeCoreDataDtos"])) {
                this.messageEnvelopeCoreDataDtos = [] as any;
                for (let item of _data["messageEnvelopeCoreDataDtos"])
                    this.messageEnvelopeCoreDataDtos!.push(MessageEnvelopeDto.fromJS(item));
            }
            if (Array.isArray(_data["transportTypeCoreDataDtos"])) {
                this.transportTypeCoreDataDtos = [] as any;
                for (let item of _data["transportTypeCoreDataDtos"])
                    this.transportTypeCoreDataDtos!.push(TransportTypeDto.fromJS(item));
            }
            if (Array.isArray(_data["signatureAlgorithms"])) {
                this.signatureAlgorithms = [] as any;
                for (let item of _data["signatureAlgorithms"])
                    this.signatureAlgorithms!.push(item);
            }
            if (Array.isArray(_data["hashAlgorithms"])) {
                this.hashAlgorithms = [] as any;
                for (let item of _data["hashAlgorithms"])
                    this.hashAlgorithms!.push(item);
            }
            if (Array.isArray(_data["encryptionAlgorithms"])) {
                this.encryptionAlgorithms = [] as any;
                for (let item of _data["encryptionAlgorithms"])
                    this.encryptionAlgorithms!.push(LabelAndValue.fromJS(item));
            }
            if (Array.isArray(_data["securityTokenFormats"])) {
                this.securityTokenFormats = [] as any;
                for (let item of _data["securityTokenFormats"])
                    this.securityTokenFormats!.push(LabelAndValue.fromJS(item));
            }
            if (Array.isArray(_data["contentTypes"])) {
                this.contentTypes = [] as any;
                for (let item of _data["contentTypes"])
                    this.contentTypes!.push(LabelAndValue.fromJS(item));
            }
            if (Array.isArray(_data["secretType"])) {
                this.secretType = [] as any;
                for (let item of _data["secretType"])
                    this.secretType!.push(item);
            }
            if (Array.isArray(_data["secretSubType"])) {
                this.secretSubType = [] as any;
                for (let item of _data["secretSubType"])
                    this.secretSubType!.push(item);
            }
            if (Array.isArray(_data["secretUsage"])) {
                this.secretUsage = [] as any;
                for (let item of _data["secretUsage"])
                    this.secretUsage!.push(item);
            }
            if (Array.isArray(_data["messageIdentificationSettingDataDtos"])) {
                this.messageIdentificationSettingDataDtos = [] as any;
                for (let item of _data["messageIdentificationSettingDataDtos"])
                    this.messageIdentificationSettingDataDtos!.push(MessageIdentificationSettingDataDto.fromJS(item));
            }
            if (Array.isArray(_data["sslModes"])) {
                this.sslModes = [] as any;
                for (let item of _data["sslModes"])
                    this.sslModes!.push(LabelAndValue.fromJS(item));
            }
            if (Array.isArray(_data["soapImplementationType"])) {
                this.soapImplementationType = [] as any;
                for (let item of _data["soapImplementationType"])
                    this.soapImplementationType!.push(item);
            }
            if (Array.isArray(_data["soapClientCredentialType"])) {
                this.soapClientCredentialType = [] as any;
                for (let item of _data["soapClientCredentialType"])
                    this.soapClientCredentialType!.push(item);
            }
            if (Array.isArray(_data["soapSecurityModeType"])) {
                this.soapSecurityModeType = [] as any;
                for (let item of _data["soapSecurityModeType"])
                    this.soapSecurityModeType!.push(item);
            }
            if (Array.isArray(_data["communicationPartnerCoreDataDtos"])) {
                this.communicationPartnerCoreDataDtos = [] as any;
                for (let item of _data["communicationPartnerCoreDataDtos"])
                    this.communicationPartnerCoreDataDtos!.push(PartnerListItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListCoreDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ListCoreDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messageStatusCoreDataDtos)) {
            data["messageStatusCoreDataDtos"] = [];
            for (let item of this.messageStatusCoreDataDtos)
                data["messageStatusCoreDataDtos"].push(item.toJSON());
        }
        if (Array.isArray(this.messageTypeCoreDataDtos)) {
            data["messageTypeCoreDataDtos"] = [];
            for (let item of this.messageTypeCoreDataDtos)
                data["messageTypeCoreDataDtos"].push(item.toJSON());
        }
        if (Array.isArray(this.partnerCoreDataDtos)) {
            data["partnerCoreDataDtos"] = [];
            for (let item of this.partnerCoreDataDtos)
                data["partnerCoreDataDtos"].push(item.toJSON());
        }
        if (Array.isArray(this.communicationProfileCoreDataDtos)) {
            data["communicationProfileCoreDataDtos"] = [];
            for (let item of this.communicationProfileCoreDataDtos)
                data["communicationProfileCoreDataDtos"].push(item.toJSON());
        }
        if (Array.isArray(this.communicationProtocolCoreDataDtos)) {
            data["communicationProtocolCoreDataDtos"] = [];
            for (let item of this.communicationProtocolCoreDataDtos)
                data["communicationProtocolCoreDataDtos"].push(item.toJSON());
        }
        if (Array.isArray(this.messageTypeSpecificationCoreDataDtos)) {
            data["messageTypeSpecificationCoreDataDtos"] = [];
            for (let item of this.messageTypeSpecificationCoreDataDtos)
                data["messageTypeSpecificationCoreDataDtos"].push(item.toJSON());
        }
        if (Array.isArray(this.directions)) {
            data["directions"] = [];
            for (let item of this.directions)
                data["directions"].push(item);
        }
        if (Array.isArray(this.codingTypes)) {
            data["codingTypes"] = [];
            for (let item of this.codingTypes)
                data["codingTypes"].push(item);
        }
        if (Array.isArray(this.externalProtocolCodes)) {
            data["externalProtocolCodes"] = [];
            for (let item of this.externalProtocolCodes)
                data["externalProtocolCodes"].push(item);
        }
        if (Array.isArray(this.datePeriodCoreDataDtos)) {
            data["datePeriodCoreDataDtos"] = [];
            for (let item of this.datePeriodCoreDataDtos)
                data["datePeriodCoreDataDtos"].push(item.toJSON());
        }
        if (Array.isArray(this.tenantCoreDataDtos)) {
            data["tenantCoreDataDtos"] = [];
            for (let item of this.tenantCoreDataDtos)
                data["tenantCoreDataDtos"].push(item.toJSON());
        }
        if (Array.isArray(this.retryStrategyCoreDataDtos)) {
            data["retryStrategyCoreDataDtos"] = [];
            for (let item of this.retryStrategyCoreDataDtos)
                data["retryStrategyCoreDataDtos"].push(item.toJSON());
        }
        if (Array.isArray(this.messageEnvelopeCoreDataDtos)) {
            data["messageEnvelopeCoreDataDtos"] = [];
            for (let item of this.messageEnvelopeCoreDataDtos)
                data["messageEnvelopeCoreDataDtos"].push(item.toJSON());
        }
        if (Array.isArray(this.transportTypeCoreDataDtos)) {
            data["transportTypeCoreDataDtos"] = [];
            for (let item of this.transportTypeCoreDataDtos)
                data["transportTypeCoreDataDtos"].push(item.toJSON());
        }
        if (Array.isArray(this.signatureAlgorithms)) {
            data["signatureAlgorithms"] = [];
            for (let item of this.signatureAlgorithms)
                data["signatureAlgorithms"].push(item);
        }
        if (Array.isArray(this.hashAlgorithms)) {
            data["hashAlgorithms"] = [];
            for (let item of this.hashAlgorithms)
                data["hashAlgorithms"].push(item);
        }
        if (Array.isArray(this.encryptionAlgorithms)) {
            data["encryptionAlgorithms"] = [];
            for (let item of this.encryptionAlgorithms)
                data["encryptionAlgorithms"].push(item.toJSON());
        }
        if (Array.isArray(this.securityTokenFormats)) {
            data["securityTokenFormats"] = [];
            for (let item of this.securityTokenFormats)
                data["securityTokenFormats"].push(item.toJSON());
        }
        if (Array.isArray(this.contentTypes)) {
            data["contentTypes"] = [];
            for (let item of this.contentTypes)
                data["contentTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.secretType)) {
            data["secretType"] = [];
            for (let item of this.secretType)
                data["secretType"].push(item);
        }
        if (Array.isArray(this.secretSubType)) {
            data["secretSubType"] = [];
            for (let item of this.secretSubType)
                data["secretSubType"].push(item);
        }
        if (Array.isArray(this.secretUsage)) {
            data["secretUsage"] = [];
            for (let item of this.secretUsage)
                data["secretUsage"].push(item);
        }
        if (Array.isArray(this.messageIdentificationSettingDataDtos)) {
            data["messageIdentificationSettingDataDtos"] = [];
            for (let item of this.messageIdentificationSettingDataDtos)
                data["messageIdentificationSettingDataDtos"].push(item.toJSON());
        }
        if (Array.isArray(this.sslModes)) {
            data["sslModes"] = [];
            for (let item of this.sslModes)
                data["sslModes"].push(item.toJSON());
        }
        if (Array.isArray(this.soapImplementationType)) {
            data["soapImplementationType"] = [];
            for (let item of this.soapImplementationType)
                data["soapImplementationType"].push(item);
        }
        if (Array.isArray(this.soapClientCredentialType)) {
            data["soapClientCredentialType"] = [];
            for (let item of this.soapClientCredentialType)
                data["soapClientCredentialType"].push(item);
        }
        if (Array.isArray(this.soapSecurityModeType)) {
            data["soapSecurityModeType"] = [];
            for (let item of this.soapSecurityModeType)
                data["soapSecurityModeType"].push(item);
        }
        if (Array.isArray(this.communicationPartnerCoreDataDtos)) {
            data["communicationPartnerCoreDataDtos"] = [];
            for (let item of this.communicationPartnerCoreDataDtos)
                data["communicationPartnerCoreDataDtos"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListCoreDataResponse {
    messageStatusCoreDataDtos: MessageStatusDto[];
    messageTypeCoreDataDtos: MessageTypeDto[];
    partnerCoreDataDtos: PartnerListItemDto[];
    communicationProfileCoreDataDtos: CommunicationProfileListItemDto[];
    communicationProtocolCoreDataDtos: CommunicationProtocolDto[];
    messageTypeSpecificationCoreDataDtos: MessageTypeSpecificationCoreDataDto[];
    directions: string[];
    codingTypes: string[];
    externalProtocolCodes: string[];
    datePeriodCoreDataDtos: DatePeriodDto[];
    tenantCoreDataDtos: TenantListItemDto[];
    retryStrategyCoreDataDtos: RetryStrategyCoreDataDto[];
    messageEnvelopeCoreDataDtos: MessageEnvelopeDto[];
    transportTypeCoreDataDtos: TransportTypeDto[];
    signatureAlgorithms: string[];
    hashAlgorithms: string[];
    encryptionAlgorithms: LabelAndValue[];
    securityTokenFormats: LabelAndValue[];
    contentTypes: LabelAndValue[];
    secretType: string[];
    secretSubType: string[];
    secretUsage: string[];
    messageIdentificationSettingDataDtos: MessageIdentificationSettingDataDto[];
    sslModes: LabelAndValue[];
    soapImplementationType: string[];
    soapClientCredentialType: string[];
    soapSecurityModeType: string[];
    communicationPartnerCoreDataDtos: PartnerListItemDto[];
}

export class RetryStrategyCoreDataDto implements IRetryStrategyCoreDataDto {
    name!: string;
    description!: string;
    id!: string;

    constructor(data?: IRetryStrategyCoreDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RetryStrategyCoreDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new RetryStrategyCoreDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["id"] = this.id;
        return data;
    }
}

export interface IRetryStrategyCoreDataDto {
    name: string;
    description: string;
    id: string;
}

export class DownloadMessageDto implements IDownloadMessageDto {
    connectMessageId!: string;
    direction?: string | undefined;
    tenant?: string | undefined;
    senderInternalCode?: string | undefined;
    receiverInternalCode?: string | undefined;
    type?: string | undefined;

    constructor(data?: IDownloadMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.connectMessageId = _data["connectMessageId"];
            this.direction = _data["direction"];
            this.tenant = _data["tenant"];
            this.senderInternalCode = _data["senderInternalCode"];
            this.receiverInternalCode = _data["receiverInternalCode"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): DownloadMessageDto {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadMessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["connectMessageId"] = this.connectMessageId;
        data["direction"] = this.direction;
        data["tenant"] = this.tenant;
        data["senderInternalCode"] = this.senderInternalCode;
        data["receiverInternalCode"] = this.receiverInternalCode;
        data["type"] = this.type;
        return data;
    }
}

export interface IDownloadMessageDto {
    connectMessageId: string;
    direction?: string | undefined;
    tenant?: string | undefined;
    senderInternalCode?: string | undefined;
    receiverInternalCode?: string | undefined;
    type?: string | undefined;
}

export class Content implements IContent {
    indentationLevel?: number;
    title?: string;
    header?: { [key: string]: string; };
    fields?: { [key: string]: string; }[];

    constructor(data?: IContent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.indentationLevel = _data["indentationLevel"];
            this.title = _data["title"];
            if (_data["header"]) {
                this.header = {} as any;
                for (let key in _data["header"]) {
                    if (_data["header"].hasOwnProperty(key))
                        (<any>this.header)![key] = _data["header"][key];
                }
            }
            if (Array.isArray(_data["fields"])) {
                this.fields = [] as any;
                for (let item of _data["fields"])
                    this.fields!.push(item);
            }
        }
    }

    static fromJS(data: any): Content {
        data = typeof data === 'object' ? data : {};
        let result = new Content();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["indentationLevel"] = this.indentationLevel;
        data["title"] = this.title;
        if (this.header) {
            data["header"] = {};
            for (let key in this.header) {
                if (this.header.hasOwnProperty(key))
                    (<any>data["header"])[key] = (<any>this.header)[key];
            }
        }
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item);
        }
        return data;
    }
}

export interface IContent {
    indentationLevel?: number;
    title?: string;
    header?: { [key: string]: string; };
    fields?: { [key: string]: string; }[];
}

export class GenericContentDto implements IGenericContentDto {
    header?: { [key: string]: string; } | undefined;
    contentItems?: Content[] | undefined;

    constructor(data?: IGenericContentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["header"]) {
                this.header = {} as any;
                for (let key in _data["header"]) {
                    if (_data["header"].hasOwnProperty(key))
                        (<any>this.header)![key] = _data["header"][key];
                }
            }
            if (Array.isArray(_data["contentItems"])) {
                this.contentItems = [] as any;
                for (let item of _data["contentItems"])
                    this.contentItems!.push(Content.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GenericContentDto {
        data = typeof data === 'object' ? data : {};
        let result = new GenericContentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.header) {
            data["header"] = {};
            for (let key in this.header) {
                if (this.header.hasOwnProperty(key))
                    (<any>data["header"])[key] = (<any>this.header)[key];
            }
        }
        if (Array.isArray(this.contentItems)) {
            data["contentItems"] = [];
            for (let item of this.contentItems)
                data["contentItems"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGenericContentDto {
    header?: { [key: string]: string; } | undefined;
    contentItems?: Content[] | undefined;
}

export class HtmlConnectionPointAllocationDto implements IHtmlConnectionPointAllocationDto {
    accountName?: string | undefined;
    accountType?: string | undefined;
    connectionPointInternalCode?: string | undefined;
    connectionPointName?: string | undefined;
    quantityTypeCode?: string | undefined;
    from?: string | undefined;
    to?: string | undefined;
    direction?: string | undefined;
    quantity?: string | undefined;
    unit?: string | undefined;
    minQuantity?: string | undefined;
    maxQuantity?: string | undefined;
    status?: string | undefined;

    constructor(data?: IHtmlConnectionPointAllocationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountName = _data["accountName"];
            this.accountType = _data["accountType"];
            this.connectionPointInternalCode = _data["connectionPointInternalCode"];
            this.connectionPointName = _data["connectionPointName"];
            this.quantityTypeCode = _data["quantityTypeCode"];
            this.from = _data["from"];
            this.to = _data["to"];
            this.direction = _data["direction"];
            this.quantity = _data["quantity"];
            this.unit = _data["unit"];
            this.minQuantity = _data["minQuantity"];
            this.maxQuantity = _data["maxQuantity"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): HtmlConnectionPointAllocationDto {
        data = typeof data === 'object' ? data : {};
        let result = new HtmlConnectionPointAllocationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountName"] = this.accountName;
        data["accountType"] = this.accountType;
        data["connectionPointInternalCode"] = this.connectionPointInternalCode;
        data["connectionPointName"] = this.connectionPointName;
        data["quantityTypeCode"] = this.quantityTypeCode;
        data["from"] = this.from;
        data["to"] = this.to;
        data["direction"] = this.direction;
        data["quantity"] = this.quantity;
        data["unit"] = this.unit;
        data["minQuantity"] = this.minQuantity;
        data["maxQuantity"] = this.maxQuantity;
        data["status"] = this.status;
        return data;
    }
}

export interface IHtmlConnectionPointAllocationDto {
    accountName?: string | undefined;
    accountType?: string | undefined;
    connectionPointInternalCode?: string | undefined;
    connectionPointName?: string | undefined;
    quantityTypeCode?: string | undefined;
    from?: string | undefined;
    to?: string | undefined;
    direction?: string | undefined;
    quantity?: string | undefined;
    unit?: string | undefined;
    minQuantity?: string | undefined;
    maxQuantity?: string | undefined;
    status?: string | undefined;
}

export class AcknowledgementReferenceDto implements IAcknowledgementReferenceDto {
    originalMessageType?: string | undefined;
    originalTimestamp?: Date | undefined;
    status?: string | undefined;

    constructor(data?: IAcknowledgementReferenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.originalMessageType = _data["originalMessageType"];
            this.originalTimestamp = _data["originalTimestamp"] ? new Date(_data["originalTimestamp"].toString()) : <any>undefined;
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): AcknowledgementReferenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new AcknowledgementReferenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["originalMessageType"] = this.originalMessageType;
        data["originalTimestamp"] = this.originalTimestamp ? this.originalTimestamp.toISOString() : <any>undefined;
        data["status"] = this.status;
        return data;
    }
}

export interface IAcknowledgementReferenceDto {
    originalMessageType?: string | undefined;
    originalTimestamp?: Date | undefined;
    status?: string | undefined;
}

export class HtmlConnectionPointNominationDto implements IHtmlConnectionPointNominationDto {
    connectionPointInternalCode?: string | undefined;
    nominationTypeCode?: string | undefined;
    internalShipper?: string | undefined;
    externalShipper?: string | undefined;
    status?: string | undefined;
    from?: string | undefined;
    to?: string | undefined;
    direction?: string | undefined;
    quantity?: string | undefined;
    unit?: string | undefined;

    constructor(data?: IHtmlConnectionPointNominationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.connectionPointInternalCode = _data["connectionPointInternalCode"];
            this.nominationTypeCode = _data["nominationTypeCode"];
            this.internalShipper = _data["internalShipper"];
            this.externalShipper = _data["externalShipper"];
            this.status = _data["status"];
            this.from = _data["from"];
            this.to = _data["to"];
            this.direction = _data["direction"];
            this.quantity = _data["quantity"];
            this.unit = _data["unit"];
        }
    }

    static fromJS(data: any): HtmlConnectionPointNominationDto {
        data = typeof data === 'object' ? data : {};
        let result = new HtmlConnectionPointNominationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["connectionPointInternalCode"] = this.connectionPointInternalCode;
        data["nominationTypeCode"] = this.nominationTypeCode;
        data["internalShipper"] = this.internalShipper;
        data["externalShipper"] = this.externalShipper;
        data["status"] = this.status;
        data["from"] = this.from;
        data["to"] = this.to;
        data["direction"] = this.direction;
        data["quantity"] = this.quantity;
        data["unit"] = this.unit;
        return data;
    }
}

export interface IHtmlConnectionPointNominationDto {
    connectionPointInternalCode?: string | undefined;
    nominationTypeCode?: string | undefined;
    internalShipper?: string | undefined;
    externalShipper?: string | undefined;
    status?: string | undefined;
    from?: string | undefined;
    to?: string | undefined;
    direction?: string | undefined;
    quantity?: string | undefined;
    unit?: string | undefined;
}

export class Bid implements IBid {
    id?: string | undefined;
    direction?: string | undefined;
    leadTime?: string | undefined;
    deliveryPeriod?: string | undefined;
    price?: string | undefined;
    quantity?: string | undefined;

    constructor(data?: IBid) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.direction = _data["direction"];
            this.leadTime = _data["leadTime"];
            this.deliveryPeriod = _data["deliveryPeriod"];
            this.price = _data["price"];
            this.quantity = _data["quantity"];
        }
    }

    static fromJS(data: any): Bid {
        data = typeof data === 'object' ? data : {};
        let result = new Bid();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["direction"] = this.direction;
        data["leadTime"] = this.leadTime;
        data["deliveryPeriod"] = this.deliveryPeriod;
        data["price"] = this.price;
        data["quantity"] = this.quantity;
        return data;
    }
}

export interface IBid {
    id?: string | undefined;
    direction?: string | undefined;
    leadTime?: string | undefined;
    deliveryPeriod?: string | undefined;
    price?: string | undefined;
    quantity?: string | undefined;
}

export class HtmlConnectionPointBiddocDto implements IHtmlConnectionPointBiddocDto {
    internalCode?: string | undefined;
    currency?: string | undefined;
    unit?: string | undefined;
    bids?: Bid[] | undefined;

    constructor(data?: IHtmlConnectionPointBiddocDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.internalCode = _data["internalCode"];
            this.currency = _data["currency"];
            this.unit = _data["unit"];
            if (Array.isArray(_data["bids"])) {
                this.bids = [] as any;
                for (let item of _data["bids"])
                    this.bids!.push(Bid.fromJS(item));
            }
        }
    }

    static fromJS(data: any): HtmlConnectionPointBiddocDto {
        data = typeof data === 'object' ? data : {};
        let result = new HtmlConnectionPointBiddocDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["internalCode"] = this.internalCode;
        data["currency"] = this.currency;
        data["unit"] = this.unit;
        if (Array.isArray(this.bids)) {
            data["bids"] = [];
            for (let item of this.bids)
                data["bids"].push(item.toJSON());
        }
        return data;
    }
}

export interface IHtmlConnectionPointBiddocDto {
    internalCode?: string | undefined;
    currency?: string | undefined;
    unit?: string | undefined;
    bids?: Bid[] | undefined;
}

export class HtmlConnectionPointDto implements IHtmlConnectionPointDto {
    internalCode?: string | undefined;
    from?: string | undefined;
    to?: string | undefined;
    direction?: string | undefined;
    firmTechnical?: string | undefined;
    firmTechnicalUnit?: string | undefined;
    firmBooked?: string | undefined;
    firmBookedUnit?: string | undefined;
    firmAvailable?: string | undefined;
    firmAvailableUnit?: string | undefined;
    interruptibleTotal?: string | undefined;
    interruptibleTotalUnit?: string | undefined;
    interruptibleBooked?: string | undefined;
    interruptibleBookedUnit?: string | undefined;
    interruptibleAvailable?: string | undefined;
    interruptibleAvailableUnit?: string | undefined;
    aggregated?: string | undefined;
    aggregatedUnit?: string | undefined;
    dayAheadUIOLI?: string | undefined;
    dayAheadUIOLIUnit?: string | undefined;
    grossCalorific?: string | undefined;
    grossCalorificUnit?: string | undefined;
    interruptibleBookedCapacity?: string | undefined;
    interruptibleBookedCapacityUnit?: string | undefined;
    interruptedCapacity?: string | undefined;
    interruptedCapacityUnit?: string | undefined;
    interruptedCapacityPercentage?: string | undefined;
    interruptedCapacityPercentageUnit?: string | undefined;
    auctionPeriod?: string | undefined;
    capacityPeriod?: string | undefined;
    currencyUnit?: string | undefined;
    clearedPrice?: string | undefined;
    reservePrice?: string | undefined;
    auctionPremium?: string | undefined;
    allocationProcess?: string | undefined;
    type?: string | undefined;
    status?: string | undefined;

    constructor(data?: IHtmlConnectionPointDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.internalCode = _data["internalCode"];
            this.from = _data["from"];
            this.to = _data["to"];
            this.direction = _data["direction"];
            this.firmTechnical = _data["firmTechnical"];
            this.firmTechnicalUnit = _data["firmTechnicalUnit"];
            this.firmBooked = _data["firmBooked"];
            this.firmBookedUnit = _data["firmBookedUnit"];
            this.firmAvailable = _data["firmAvailable"];
            this.firmAvailableUnit = _data["firmAvailableUnit"];
            this.interruptibleTotal = _data["interruptibleTotal"];
            this.interruptibleTotalUnit = _data["interruptibleTotalUnit"];
            this.interruptibleBooked = _data["interruptibleBooked"];
            this.interruptibleBookedUnit = _data["interruptibleBookedUnit"];
            this.interruptibleAvailable = _data["interruptibleAvailable"];
            this.interruptibleAvailableUnit = _data["interruptibleAvailableUnit"];
            this.aggregated = _data["aggregated"];
            this.aggregatedUnit = _data["aggregatedUnit"];
            this.dayAheadUIOLI = _data["dayAheadUIOLI"];
            this.dayAheadUIOLIUnit = _data["dayAheadUIOLIUnit"];
            this.grossCalorific = _data["grossCalorific"];
            this.grossCalorificUnit = _data["grossCalorificUnit"];
            this.interruptibleBookedCapacity = _data["interruptibleBookedCapacity"];
            this.interruptibleBookedCapacityUnit = _data["interruptibleBookedCapacityUnit"];
            this.interruptedCapacity = _data["interruptedCapacity"];
            this.interruptedCapacityUnit = _data["interruptedCapacityUnit"];
            this.interruptedCapacityPercentage = _data["interruptedCapacityPercentage"];
            this.interruptedCapacityPercentageUnit = _data["interruptedCapacityPercentageUnit"];
            this.auctionPeriod = _data["auctionPeriod"];
            this.capacityPeriod = _data["capacityPeriod"];
            this.currencyUnit = _data["currencyUnit"];
            this.clearedPrice = _data["clearedPrice"];
            this.reservePrice = _data["reservePrice"];
            this.auctionPremium = _data["auctionPremium"];
            this.allocationProcess = _data["allocationProcess"];
            this.type = _data["type"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): HtmlConnectionPointDto {
        data = typeof data === 'object' ? data : {};
        let result = new HtmlConnectionPointDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["internalCode"] = this.internalCode;
        data["from"] = this.from;
        data["to"] = this.to;
        data["direction"] = this.direction;
        data["firmTechnical"] = this.firmTechnical;
        data["firmTechnicalUnit"] = this.firmTechnicalUnit;
        data["firmBooked"] = this.firmBooked;
        data["firmBookedUnit"] = this.firmBookedUnit;
        data["firmAvailable"] = this.firmAvailable;
        data["firmAvailableUnit"] = this.firmAvailableUnit;
        data["interruptibleTotal"] = this.interruptibleTotal;
        data["interruptibleTotalUnit"] = this.interruptibleTotalUnit;
        data["interruptibleBooked"] = this.interruptibleBooked;
        data["interruptibleBookedUnit"] = this.interruptibleBookedUnit;
        data["interruptibleAvailable"] = this.interruptibleAvailable;
        data["interruptibleAvailableUnit"] = this.interruptibleAvailableUnit;
        data["aggregated"] = this.aggregated;
        data["aggregatedUnit"] = this.aggregatedUnit;
        data["dayAheadUIOLI"] = this.dayAheadUIOLI;
        data["dayAheadUIOLIUnit"] = this.dayAheadUIOLIUnit;
        data["grossCalorific"] = this.grossCalorific;
        data["grossCalorificUnit"] = this.grossCalorificUnit;
        data["interruptibleBookedCapacity"] = this.interruptibleBookedCapacity;
        data["interruptibleBookedCapacityUnit"] = this.interruptibleBookedCapacityUnit;
        data["interruptedCapacity"] = this.interruptedCapacity;
        data["interruptedCapacityUnit"] = this.interruptedCapacityUnit;
        data["interruptedCapacityPercentage"] = this.interruptedCapacityPercentage;
        data["interruptedCapacityPercentageUnit"] = this.interruptedCapacityPercentageUnit;
        data["auctionPeriod"] = this.auctionPeriod;
        data["capacityPeriod"] = this.capacityPeriod;
        data["currencyUnit"] = this.currencyUnit;
        data["clearedPrice"] = this.clearedPrice;
        data["reservePrice"] = this.reservePrice;
        data["auctionPremium"] = this.auctionPremium;
        data["allocationProcess"] = this.allocationProcess;
        data["type"] = this.type;
        data["status"] = this.status;
        return data;
    }
}

export interface IHtmlConnectionPointDto {
    internalCode?: string | undefined;
    from?: string | undefined;
    to?: string | undefined;
    direction?: string | undefined;
    firmTechnical?: string | undefined;
    firmTechnicalUnit?: string | undefined;
    firmBooked?: string | undefined;
    firmBookedUnit?: string | undefined;
    firmAvailable?: string | undefined;
    firmAvailableUnit?: string | undefined;
    interruptibleTotal?: string | undefined;
    interruptibleTotalUnit?: string | undefined;
    interruptibleBooked?: string | undefined;
    interruptibleBookedUnit?: string | undefined;
    interruptibleAvailable?: string | undefined;
    interruptibleAvailableUnit?: string | undefined;
    aggregated?: string | undefined;
    aggregatedUnit?: string | undefined;
    dayAheadUIOLI?: string | undefined;
    dayAheadUIOLIUnit?: string | undefined;
    grossCalorific?: string | undefined;
    grossCalorificUnit?: string | undefined;
    interruptibleBookedCapacity?: string | undefined;
    interruptibleBookedCapacityUnit?: string | undefined;
    interruptedCapacity?: string | undefined;
    interruptedCapacityUnit?: string | undefined;
    interruptedCapacityPercentage?: string | undefined;
    interruptedCapacityPercentageUnit?: string | undefined;
    auctionPeriod?: string | undefined;
    capacityPeriod?: string | undefined;
    currencyUnit?: string | undefined;
    clearedPrice?: string | undefined;
    reservePrice?: string | undefined;
    auctionPremium?: string | undefined;
    allocationProcess?: string | undefined;
    type?: string | undefined;
    status?: string | undefined;
}

export class HtmlContentDto implements IHtmlContentDto {
    acknowledgementReferenceDto?: AcknowledgementReferenceDto | undefined;
    htmlConnectionPointDtos?: HtmlConnectionPointDto[] | undefined;
    htmlConnectionPointNominationDtos?: HtmlConnectionPointNominationDto[] | undefined;
    htmlConnectionPointAllocationDtos?: HtmlConnectionPointAllocationDto[] | undefined;
    htmlConnectionPointBiddocDtos?: HtmlConnectionPointBiddocDto[] | undefined;
    cmsClientProductionSwitchDtos?: CmsClientProductionSwitchDto[] | undefined;
    cmsAcknowledgementReferenceDto?: CmsAcknowledgementReferenceDto | undefined;

    constructor(data?: IHtmlContentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.acknowledgementReferenceDto = _data["acknowledgementReferenceDto"] ? AcknowledgementReferenceDto.fromJS(_data["acknowledgementReferenceDto"]) : <any>undefined;
            if (Array.isArray(_data["htmlConnectionPointDtos"])) {
                this.htmlConnectionPointDtos = [] as any;
                for (let item of _data["htmlConnectionPointDtos"])
                    this.htmlConnectionPointDtos!.push(HtmlConnectionPointDto.fromJS(item));
            }
            if (Array.isArray(_data["htmlConnectionPointNominationDtos"])) {
                this.htmlConnectionPointNominationDtos = [] as any;
                for (let item of _data["htmlConnectionPointNominationDtos"])
                    this.htmlConnectionPointNominationDtos!.push(HtmlConnectionPointNominationDto.fromJS(item));
            }
            if (Array.isArray(_data["htmlConnectionPointAllocationDtos"])) {
                this.htmlConnectionPointAllocationDtos = [] as any;
                for (let item of _data["htmlConnectionPointAllocationDtos"])
                    this.htmlConnectionPointAllocationDtos!.push(HtmlConnectionPointAllocationDto.fromJS(item));
            }
            if (Array.isArray(_data["htmlConnectionPointBiddocDtos"])) {
                this.htmlConnectionPointBiddocDtos = [] as any;
                for (let item of _data["htmlConnectionPointBiddocDtos"])
                    this.htmlConnectionPointBiddocDtos!.push(HtmlConnectionPointBiddocDto.fromJS(item));
            }
            if (Array.isArray(_data["cmsClientProductionSwitchDtos"])) {
                this.cmsClientProductionSwitchDtos = [] as any;
                for (let item of _data["cmsClientProductionSwitchDtos"])
                    this.cmsClientProductionSwitchDtos!.push(CmsClientProductionSwitchDto.fromJS(item));
            }
            this.cmsAcknowledgementReferenceDto = _data["cmsAcknowledgementReferenceDto"] ? CmsAcknowledgementReferenceDto.fromJS(_data["cmsAcknowledgementReferenceDto"]) : <any>undefined;
        }
    }

    static fromJS(data: any): HtmlContentDto {
        data = typeof data === 'object' ? data : {};
        let result = new HtmlContentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["acknowledgementReferenceDto"] = this.acknowledgementReferenceDto ? this.acknowledgementReferenceDto.toJSON() : <any>undefined;
        if (Array.isArray(this.htmlConnectionPointDtos)) {
            data["htmlConnectionPointDtos"] = [];
            for (let item of this.htmlConnectionPointDtos)
                data["htmlConnectionPointDtos"].push(item.toJSON());
        }
        if (Array.isArray(this.htmlConnectionPointNominationDtos)) {
            data["htmlConnectionPointNominationDtos"] = [];
            for (let item of this.htmlConnectionPointNominationDtos)
                data["htmlConnectionPointNominationDtos"].push(item.toJSON());
        }
        if (Array.isArray(this.htmlConnectionPointAllocationDtos)) {
            data["htmlConnectionPointAllocationDtos"] = [];
            for (let item of this.htmlConnectionPointAllocationDtos)
                data["htmlConnectionPointAllocationDtos"].push(item.toJSON());
        }
        if (Array.isArray(this.htmlConnectionPointBiddocDtos)) {
            data["htmlConnectionPointBiddocDtos"] = [];
            for (let item of this.htmlConnectionPointBiddocDtos)
                data["htmlConnectionPointBiddocDtos"].push(item.toJSON());
        }
        if (Array.isArray(this.cmsClientProductionSwitchDtos)) {
            data["cmsClientProductionSwitchDtos"] = [];
            for (let item of this.cmsClientProductionSwitchDtos)
                data["cmsClientProductionSwitchDtos"].push(item.toJSON());
        }
        data["cmsAcknowledgementReferenceDto"] = this.cmsAcknowledgementReferenceDto ? this.cmsAcknowledgementReferenceDto.toJSON() : <any>undefined;
        return data;
    }
}

export interface IHtmlContentDto {
    acknowledgementReferenceDto?: AcknowledgementReferenceDto | undefined;
    htmlConnectionPointDtos?: HtmlConnectionPointDto[] | undefined;
    htmlConnectionPointNominationDtos?: HtmlConnectionPointNominationDto[] | undefined;
    htmlConnectionPointAllocationDtos?: HtmlConnectionPointAllocationDto[] | undefined;
    htmlConnectionPointBiddocDtos?: HtmlConnectionPointBiddocDto[] | undefined;
    cmsClientProductionSwitchDtos?: CmsClientProductionSwitchDto[] | undefined;
    cmsAcknowledgementReferenceDto?: CmsAcknowledgementReferenceDto | undefined;
}

export class CmsClientProductionSwitchDto implements ICmsClientProductionSwitchDto {
    period?: string | undefined;
    arsEan?: string | undefined;
    direction?: string | undefined;
    messageGuid?: string | undefined;
    rlpEan?: string | undefined;
    shipperEan?: string | undefined;
    rlpMeas?: string | undefined;
    rlpName?: string | undefined;

    constructor(data?: ICmsClientProductionSwitchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.period = _data["period"];
            this.arsEan = _data["arsEan"];
            this.direction = _data["direction"];
            this.messageGuid = _data["messageGuid"];
            this.rlpEan = _data["rlpEan"];
            this.shipperEan = _data["shipperEan"];
            this.rlpMeas = _data["rlpMeas"];
            this.rlpName = _data["rlpName"];
        }
    }

    static fromJS(data: any): CmsClientProductionSwitchDto {
        data = typeof data === 'object' ? data : {};
        let result = new CmsClientProductionSwitchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["period"] = this.period;
        data["arsEan"] = this.arsEan;
        data["direction"] = this.direction;
        data["messageGuid"] = this.messageGuid;
        data["rlpEan"] = this.rlpEan;
        data["shipperEan"] = this.shipperEan;
        data["rlpMeas"] = this.rlpMeas;
        data["rlpName"] = this.rlpName;
        return data;
    }
}

export interface ICmsClientProductionSwitchDto {
    period?: string | undefined;
    arsEan?: string | undefined;
    direction?: string | undefined;
    messageGuid?: string | undefined;
    rlpEan?: string | undefined;
    shipperEan?: string | undefined;
    rlpMeas?: string | undefined;
    rlpName?: string | undefined;
}

export class CmsAcknowledgementReferenceDto implements ICmsAcknowledgementReferenceDto {
    originalMessageType?: string | undefined;
    originalTimestamp?: Date;
    status?: string | undefined;
    statuses?: StatusDetailDto[] | undefined;

    constructor(data?: ICmsAcknowledgementReferenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.originalMessageType = _data["originalMessageType"];
            this.originalTimestamp = _data["originalTimestamp"] ? new Date(_data["originalTimestamp"].toString()) : <any>undefined;
            this.status = _data["status"];
            if (Array.isArray(_data["statuses"])) {
                this.statuses = [] as any;
                for (let item of _data["statuses"])
                    this.statuses!.push(StatusDetailDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CmsAcknowledgementReferenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CmsAcknowledgementReferenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["originalMessageType"] = this.originalMessageType;
        data["originalTimestamp"] = this.originalTimestamp ? this.originalTimestamp.toISOString() : <any>undefined;
        data["status"] = this.status;
        if (Array.isArray(this.statuses)) {
            data["statuses"] = [];
            for (let item of this.statuses)
                data["statuses"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICmsAcknowledgementReferenceDto {
    originalMessageType?: string | undefined;
    originalTimestamp?: Date;
    status?: string | undefined;
    statuses?: StatusDetailDto[] | undefined;
}

export class StatusDetailDto implements IStatusDetailDto {
    errorCode?: string | undefined;
    errorDescription?: string | undefined;

    constructor(data?: IStatusDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.errorCode = _data["errorCode"];
            this.errorDescription = _data["errorDescription"];
        }
    }

    static fromJS(data: any): StatusDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new StatusDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorCode"] = this.errorCode;
        data["errorDescription"] = this.errorDescription;
        return data;
    }
}

export interface IStatusDetailDto {
    errorCode?: string | undefined;
    errorDescription?: string | undefined;
}

export class HtmlDto implements IHtmlDto {
    htmlMessageHeaderDto?: HtmlMessageHeaderDto | undefined;
    htmlContentDto?: HtmlContentDto | undefined;

    constructor(data?: IHtmlDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.htmlMessageHeaderDto = _data["htmlMessageHeaderDto"] ? HtmlMessageHeaderDto.fromJS(_data["htmlMessageHeaderDto"]) : <any>undefined;
            this.htmlContentDto = _data["htmlContentDto"] ? HtmlContentDto.fromJS(_data["htmlContentDto"]) : <any>undefined;
        }
    }

    static fromJS(data: any): HtmlDto {
        data = typeof data === 'object' ? data : {};
        let result = new HtmlDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["htmlMessageHeaderDto"] = this.htmlMessageHeaderDto ? this.htmlMessageHeaderDto.toJSON() : <any>undefined;
        data["htmlContentDto"] = this.htmlContentDto ? this.htmlContentDto.toJSON() : <any>undefined;
        return data;
    }
}

export interface IHtmlDto {
    htmlMessageHeaderDto?: HtmlMessageHeaderDto | undefined;
    htmlContentDto?: HtmlContentDto | undefined;
}

export class HtmlMessageHeaderDto implements IHtmlMessageHeaderDto {
    sender?: string | undefined;
    comSender?: string | undefined;
    receiver?: string | undefined;
    comReceiver?: string | undefined;
    documentId?: string | undefined;
    contractReference?: string | undefined;
    documentVersion?: string | undefined;
    referenceId?: string | undefined;
    referenceVersion?: string | undefined;
    period?: string | undefined;
    dataGridOperator?: string | undefined;
    splitLast?: string | undefined;
    splitNumber?: string | undefined;

    constructor(data?: IHtmlMessageHeaderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sender = _data["sender"];
            this.comSender = _data["comSender"];
            this.receiver = _data["receiver"];
            this.comReceiver = _data["comReceiver"];
            this.documentId = _data["documentId"];
            this.contractReference = _data["contractReference"];
            this.documentVersion = _data["documentVersion"];
            this.referenceId = _data["referenceId"];
            this.referenceVersion = _data["referenceVersion"];
            this.period = _data["period"];
            this.dataGridOperator = _data["dataGridOperator"];
            this.splitLast = _data["splitLast"];
            this.splitNumber = _data["splitNumber"];
        }
    }

    static fromJS(data: any): HtmlMessageHeaderDto {
        data = typeof data === 'object' ? data : {};
        let result = new HtmlMessageHeaderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sender"] = this.sender;
        data["comSender"] = this.comSender;
        data["receiver"] = this.receiver;
        data["comReceiver"] = this.comReceiver;
        data["documentId"] = this.documentId;
        data["contractReference"] = this.contractReference;
        data["documentVersion"] = this.documentVersion;
        data["referenceId"] = this.referenceId;
        data["referenceVersion"] = this.referenceVersion;
        data["period"] = this.period;
        data["dataGridOperator"] = this.dataGridOperator;
        data["splitLast"] = this.splitLast;
        data["splitNumber"] = this.splitNumber;
        return data;
    }
}

export interface IHtmlMessageHeaderDto {
    sender?: string | undefined;
    comSender?: string | undefined;
    receiver?: string | undefined;
    comReceiver?: string | undefined;
    documentId?: string | undefined;
    contractReference?: string | undefined;
    documentVersion?: string | undefined;
    referenceId?: string | undefined;
    referenceVersion?: string | undefined;
    period?: string | undefined;
    dataGridOperator?: string | undefined;
    splitLast?: string | undefined;
    splitNumber?: string | undefined;
}

export class ReprocessMessageDto implements IReprocessMessageDto {
    connectMessageId!: string;
    tenant?: string | undefined;
    direction?: string | undefined;

    constructor(data?: IReprocessMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.connectMessageId = _data["connectMessageId"];
            this.tenant = _data["tenant"];
            this.direction = _data["direction"];
        }
    }

    static fromJS(data: any): ReprocessMessageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReprocessMessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["connectMessageId"] = this.connectMessageId;
        data["tenant"] = this.tenant;
        data["direction"] = this.direction;
        return data;
    }
}

export interface IReprocessMessageDto {
    connectMessageId: string;
    tenant?: string | undefined;
    direction?: string | undefined;
}

export class DownloadMessageFormatRequest implements IDownloadMessageFormatRequest {
    id!: string;
    mapStage?: MapStage;
    isArchived?: boolean;

    constructor(data?: IDownloadMessageFormatRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.mapStage = _data["mapStage"];
            this.isArchived = _data["isArchived"];
        }
    }

    static fromJS(data: any): DownloadMessageFormatRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadMessageFormatRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["mapStage"] = this.mapStage;
        data["isArchived"] = this.isArchived;
        return data;
    }
}

export interface IDownloadMessageFormatRequest {
    id: string;
    mapStage?: MapStage;
    isArchived?: boolean;
}

export class DownloadMessageRequest implements IDownloadMessageRequest {
    downloadMessageDtos!: DownloadMessageDto[];

    constructor(data?: IDownloadMessageRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.downloadMessageDtos = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["downloadMessageDtos"])) {
                this.downloadMessageDtos = [] as any;
                for (let item of _data["downloadMessageDtos"])
                    this.downloadMessageDtos!.push(DownloadMessageDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DownloadMessageRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadMessageRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.downloadMessageDtos)) {
            data["downloadMessageDtos"] = [];
            for (let item of this.downloadMessageDtos)
                data["downloadMessageDtos"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDownloadMessageRequest {
    downloadMessageDtos: DownloadMessageDto[];
}

export class ReprocessMessageRequest implements IReprocessMessageRequest {
    reprocessMessageDtos!: ReprocessMessageDto[];

    constructor(data?: IReprocessMessageRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.reprocessMessageDtos = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["reprocessMessageDtos"])) {
                this.reprocessMessageDtos = [] as any;
                for (let item of _data["reprocessMessageDtos"])
                    this.reprocessMessageDtos!.push(ReprocessMessageDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ReprocessMessageRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ReprocessMessageRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.reprocessMessageDtos)) {
            data["reprocessMessageDtos"] = [];
            for (let item of this.reprocessMessageDtos)
                data["reprocessMessageDtos"].push(item.toJSON());
        }
        return data;
    }
}

export interface IReprocessMessageRequest {
    reprocessMessageDtos: ReprocessMessageDto[];
}

export class ResendMessageRequest implements IResendMessageRequest {
    resendMessageDtos!: ResendMessageDto[];

    constructor(data?: IResendMessageRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.resendMessageDtos = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["resendMessageDtos"])) {
                this.resendMessageDtos = [] as any;
                for (let item of _data["resendMessageDtos"])
                    this.resendMessageDtos!.push(ResendMessageDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResendMessageRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ResendMessageRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.resendMessageDtos)) {
            data["resendMessageDtos"] = [];
            for (let item of this.resendMessageDtos)
                data["resendMessageDtos"].push(item.toJSON());
        }
        return data;
    }
}

export interface IResendMessageRequest {
    resendMessageDtos: ResendMessageDto[];
}

export class SendMessageRequest implements ISendMessageRequest {
    direction?: Direction;
    tenant?: string | undefined;
    fileContent!: string;
    fileName?: string | undefined;

    constructor(data?: ISendMessageRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.direction = _data["direction"];
            this.tenant = _data["tenant"];
            this.fileContent = _data["fileContent"];
            this.fileName = _data["fileName"];
        }
    }

    static fromJS(data: any): SendMessageRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SendMessageRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["direction"] = this.direction;
        data["tenant"] = this.tenant;
        data["fileContent"] = this.fileContent;
        data["fileName"] = this.fileName;
        return data;
    }
}

export interface ISendMessageRequest {
    direction?: Direction;
    tenant?: string | undefined;
    fileContent: string;
    fileName?: string | undefined;
}

export class SendTestMessageRequest implements ISendTestMessageRequest {
    direction?: Direction;
    tenant?: string | undefined;
    fileContent!: string;
    externalProtocolCode?: ExternalProtocolCode;
    communicationProfileId!: string;
    communicationPartnerId?: string | undefined;
    processingModeId?: string | undefined;
    isPModeTestMessage?: boolean;
    withPModeTestFields?: boolean;
    connectMessageId?: number;

    constructor(data?: ISendTestMessageRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.direction = _data["direction"];
            this.tenant = _data["tenant"];
            this.fileContent = _data["fileContent"];
            this.externalProtocolCode = _data["externalProtocolCode"];
            this.communicationProfileId = _data["communicationProfileId"];
            this.communicationPartnerId = _data["communicationPartnerId"];
            this.processingModeId = _data["processingModeId"];
            this.isPModeTestMessage = _data["isPModeTestMessage"];
            this.withPModeTestFields = _data["withPModeTestFields"];
            this.connectMessageId = _data["connectMessageId"];
        }
    }

    static fromJS(data: any): SendTestMessageRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SendTestMessageRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["direction"] = this.direction;
        data["tenant"] = this.tenant;
        data["fileContent"] = this.fileContent;
        data["externalProtocolCode"] = this.externalProtocolCode;
        data["communicationProfileId"] = this.communicationProfileId;
        data["communicationPartnerId"] = this.communicationPartnerId;
        data["processingModeId"] = this.processingModeId;
        data["isPModeTestMessage"] = this.isPModeTestMessage;
        data["withPModeTestFields"] = this.withPModeTestFields;
        data["connectMessageId"] = this.connectMessageId;
        return data;
    }
}

export interface ISendTestMessageRequest {
    direction?: Direction;
    tenant?: string | undefined;
    fileContent: string;
    externalProtocolCode?: ExternalProtocolCode;
    communicationProfileId: string;
    communicationPartnerId?: string | undefined;
    processingModeId?: string | undefined;
    isPModeTestMessage?: boolean;
    withPModeTestFields?: boolean;
    connectMessageId?: number;
}

export class ResendMessageDto implements IResendMessageDto {
    connectMessageId!: string;
    tenant!: string;

    constructor(data?: IResendMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.connectMessageId = _data["connectMessageId"];
            this.tenant = _data["tenant"];
        }
    }

    static fromJS(data: any): ResendMessageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResendMessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["connectMessageId"] = this.connectMessageId;
        data["tenant"] = this.tenant;
        return data;
    }
}

export interface IResendMessageDto {
    connectMessageId: string;
    tenant: string;
}

export class SendLodTestMessageResponse implements ISendLodTestMessageResponse {
    messageIds!: SendLodTestMessageResponseDto[];
    responseMessage?: string | undefined;

    constructor(data?: ISendLodTestMessageResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messageIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messageIds"])) {
                this.messageIds = [] as any;
                for (let item of _data["messageIds"])
                    this.messageIds!.push(SendLodTestMessageResponseDto.fromJS(item));
            }
            this.responseMessage = _data["responseMessage"];
        }
    }

    static fromJS(data: any): SendLodTestMessageResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SendLodTestMessageResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messageIds)) {
            data["messageIds"] = [];
            for (let item of this.messageIds)
                data["messageIds"].push(item.toJSON());
        }
        data["responseMessage"] = this.responseMessage;
        return data;
    }
}

export interface ISendLodTestMessageResponse {
    messageIds: SendLodTestMessageResponseDto[];
    responseMessage?: string | undefined;
}

export class SendLodTestMessageResponseDto implements ISendLodTestMessageResponseDto {
    connectMessageId!: string;
    messageIdentifier?: string;

    constructor(data?: ISendLodTestMessageResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.connectMessageId = _data["connectMessageId"];
            this.messageIdentifier = _data["messageIdentifier"];
        }
    }

    static fromJS(data: any): SendLodTestMessageResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new SendLodTestMessageResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["connectMessageId"] = this.connectMessageId;
        data["messageIdentifier"] = this.messageIdentifier;
        return data;
    }
}

export interface ISendLodTestMessageResponseDto {
    connectMessageId: string;
    messageIdentifier?: string;
}

export class SendMessageResponse implements ISendMessageResponse {
    connectMessageId?: string | undefined;
    messageIdentifier?: string | undefined;
    status?: string | undefined;
    responseMessage?: string | undefined;

    constructor(data?: ISendMessageResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.connectMessageId = _data["connectMessageId"];
            this.messageIdentifier = _data["messageIdentifier"];
            this.status = _data["status"];
            this.responseMessage = _data["responseMessage"];
        }
    }

    static fromJS(data: any): SendMessageResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SendMessageResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["connectMessageId"] = this.connectMessageId;
        data["messageIdentifier"] = this.messageIdentifier;
        data["status"] = this.status;
        data["responseMessage"] = this.responseMessage;
        return data;
    }
}

export interface ISendMessageResponse {
    connectMessageId?: string | undefined;
    messageIdentifier?: string | undefined;
    status?: string | undefined;
    responseMessage?: string | undefined;
}

export class PermissionDto implements IPermissionDto {
    permissionName!: string;
    tenantRange?: DimensionRange | undefined;
    tenantValues!: string[];
    correspondentRange?: DimensionRange | undefined;
    correspondentValues!: string[];

    constructor(data?: IPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.tenantValues = [];
            this.correspondentValues = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.permissionName = _data["permissionName"];
            this.tenantRange = _data["tenantRange"];
            if (Array.isArray(_data["tenantValues"])) {
                this.tenantValues = [] as any;
                for (let item of _data["tenantValues"])
                    this.tenantValues!.push(item);
            }
            this.correspondentRange = _data["correspondentRange"];
            if (Array.isArray(_data["correspondentValues"])) {
                this.correspondentValues = [] as any;
                for (let item of _data["correspondentValues"])
                    this.correspondentValues!.push(item);
            }
        }
    }

    static fromJS(data: any): PermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["permissionName"] = this.permissionName;
        data["tenantRange"] = this.tenantRange;
        if (Array.isArray(this.tenantValues)) {
            data["tenantValues"] = [];
            for (let item of this.tenantValues)
                data["tenantValues"].push(item);
        }
        data["correspondentRange"] = this.correspondentRange;
        if (Array.isArray(this.correspondentValues)) {
            data["correspondentValues"] = [];
            for (let item of this.correspondentValues)
                data["correspondentValues"].push(item);
        }
        return data;
    }
}

export interface IPermissionDto {
    permissionName: string;
    tenantRange?: DimensionRange | undefined;
    tenantValues: string[];
    correspondentRange?: DimensionRange | undefined;
    correspondentValues: string[];
}

export class ListPermissionsResponse implements IListPermissionsResponse {
    permissionsListItemDtos!: PermissionDto[];
    userRoles!: string[];

    constructor(data?: IListPermissionsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.permissionsListItemDtos = [];
            this.userRoles = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["permissionsListItemDtos"])) {
                this.permissionsListItemDtos = [] as any;
                for (let item of _data["permissionsListItemDtos"])
                    this.permissionsListItemDtos!.push(PermissionDto.fromJS(item));
            }
            if (Array.isArray(_data["userRoles"])) {
                this.userRoles = [] as any;
                for (let item of _data["userRoles"])
                    this.userRoles!.push(item);
            }
        }
    }

    static fromJS(data: any): ListPermissionsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ListPermissionsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.permissionsListItemDtos)) {
            data["permissionsListItemDtos"] = [];
            for (let item of this.permissionsListItemDtos)
                data["permissionsListItemDtos"].push(item.toJSON());
        }
        if (Array.isArray(this.userRoles)) {
            data["userRoles"] = [];
            for (let item of this.userRoles)
                data["userRoles"].push(item);
        }
        return data;
    }
}

export interface IListPermissionsResponse {
    permissionsListItemDtos: PermissionDto[];
    userRoles: string[];
}

export class GatewayTenantsDto implements IGatewayTenantsDto {
    gateway!: string;
    tenants!: TenantDto[];

    constructor(data?: IGatewayTenantsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.tenants = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gateway = _data["gateway"];
            if (Array.isArray(_data["tenants"])) {
                this.tenants = [] as any;
                for (let item of _data["tenants"])
                    this.tenants!.push(TenantDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GatewayTenantsDto {
        data = typeof data === 'object' ? data : {};
        let result = new GatewayTenantsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gateway"] = this.gateway;
        if (Array.isArray(this.tenants)) {
            data["tenants"] = [];
            for (let item of this.tenants)
                data["tenants"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGatewayTenantsDto {
    gateway: string;
    tenants: TenantDto[];
}

export class GatewayTenantsMaintenanceDto implements IGatewayTenantsMaintenanceDto {
    gateway!: string;
    success?: boolean;

    constructor(data?: IGatewayTenantsMaintenanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gateway = _data["gateway"];
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): GatewayTenantsMaintenanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new GatewayTenantsMaintenanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gateway"] = this.gateway;
        data["success"] = this.success;
        return data;
    }
}

export interface IGatewayTenantsMaintenanceDto {
    gateway: string;
    success?: boolean;
}

export class GetTenantsResponse implements IGetTenantsResponse {
    gatewayTenants!: GatewayTenantsDto[];

    constructor(data?: IGetTenantsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.gatewayTenants = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["gatewayTenants"])) {
                this.gatewayTenants = [] as any;
                for (let item of _data["gatewayTenants"])
                    this.gatewayTenants!.push(GatewayTenantsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTenantsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTenantsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.gatewayTenants)) {
            data["gatewayTenants"] = [];
            for (let item of this.gatewayTenants)
                data["gatewayTenants"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetTenantsResponse {
    gatewayTenants: GatewayTenantsDto[];
}

export class TenantsMaintenanceRequest implements ITenantsMaintenanceRequest {
    tenantIds!: string[];
    maintenanceMode?: boolean;

    constructor(data?: ITenantsMaintenanceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.tenantIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["tenantIds"])) {
                this.tenantIds = [] as any;
                for (let item of _data["tenantIds"])
                    this.tenantIds!.push(item);
            }
            this.maintenanceMode = _data["maintenanceMode"];
        }
    }

    static fromJS(data: any): TenantsMaintenanceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TenantsMaintenanceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tenantIds)) {
            data["tenantIds"] = [];
            for (let item of this.tenantIds)
                data["tenantIds"].push(item);
        }
        data["maintenanceMode"] = this.maintenanceMode;
        return data;
    }
}

export interface ITenantsMaintenanceRequest {
    tenantIds: string[];
    maintenanceMode?: boolean;
}

export class TenantsMaintenanceResponse implements ITenantsMaintenanceResponse {
    tenantsMaintenanceSuccess!: GatewayTenantsMaintenanceDto[];

    constructor(data?: ITenantsMaintenanceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.tenantsMaintenanceSuccess = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["tenantsMaintenanceSuccess"])) {
                this.tenantsMaintenanceSuccess = [] as any;
                for (let item of _data["tenantsMaintenanceSuccess"])
                    this.tenantsMaintenanceSuccess!.push(GatewayTenantsMaintenanceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TenantsMaintenanceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TenantsMaintenanceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tenantsMaintenanceSuccess)) {
            data["tenantsMaintenanceSuccess"] = [];
            for (let item of this.tenantsMaintenanceSuccess)
                data["tenantsMaintenanceSuccess"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITenantsMaintenanceResponse {
    tenantsMaintenanceSuccess: GatewayTenantsMaintenanceDto[];
}

export class CreateAgreementRequest implements ICreateAgreementRequest {
    newCertificateFile?: string | undefined;
    respondBy?: Date | undefined;
    activateBy?: Date | undefined;
    expireBy?: Date | undefined;
    reason?: string | undefined;
    entsogCommunicationProfile!: EntsogCommunicationProfile[];

    constructor(data?: ICreateAgreementRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.entsogCommunicationProfile = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newCertificateFile = _data["newCertificateFile"];
            this.respondBy = _data["respondBy"] ? new Date(_data["respondBy"].toString()) : <any>undefined;
            this.activateBy = _data["activateBy"] ? new Date(_data["activateBy"].toString()) : <any>undefined;
            this.expireBy = _data["expireBy"] ? new Date(_data["expireBy"].toString()) : <any>undefined;
            this.reason = _data["reason"];
            if (Array.isArray(_data["entsogCommunicationProfile"])) {
                this.entsogCommunicationProfile = [] as any;
                for (let item of _data["entsogCommunicationProfile"])
                    this.entsogCommunicationProfile!.push(EntsogCommunicationProfile.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateAgreementRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAgreementRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newCertificateFile"] = this.newCertificateFile;
        data["respondBy"] = this.respondBy ? this.respondBy.toISOString() : <any>undefined;
        data["activateBy"] = this.activateBy ? this.activateBy.toISOString() : <any>undefined;
        data["expireBy"] = this.expireBy ? this.expireBy.toISOString() : <any>undefined;
        data["reason"] = this.reason;
        if (Array.isArray(this.entsogCommunicationProfile)) {
            data["entsogCommunicationProfile"] = [];
            for (let item of this.entsogCommunicationProfile)
                data["entsogCommunicationProfile"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateAgreementRequest {
    newCertificateFile?: string | undefined;
    respondBy?: Date | undefined;
    activateBy?: Date | undefined;
    expireBy?: Date | undefined;
    reason?: string | undefined;
    entsogCommunicationProfile: EntsogCommunicationProfile[];
}

export class CreateAgreementTerminationRequest implements ICreateAgreementTerminationRequest {
    respondBy?: Date | undefined;
    terminateBy?: Date | undefined;
    reason?: string | undefined;
    processingModeId!: string;
    receiverCommunicationProfileId!: string;

    constructor(data?: ICreateAgreementTerminationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.respondBy = _data["respondBy"] ? new Date(_data["respondBy"].toString()) : <any>undefined;
            this.terminateBy = _data["terminateBy"] ? new Date(_data["terminateBy"].toString()) : <any>undefined;
            this.reason = _data["reason"];
            this.processingModeId = _data["processingModeId"];
            this.receiverCommunicationProfileId = _data["receiverCommunicationProfileId"];
        }
    }

    static fromJS(data: any): CreateAgreementTerminationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAgreementTerminationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["respondBy"] = this.respondBy ? this.respondBy.toISOString() : <any>undefined;
        data["terminateBy"] = this.terminateBy ? this.terminateBy.toISOString() : <any>undefined;
        data["reason"] = this.reason;
        data["processingModeId"] = this.processingModeId;
        data["receiverCommunicationProfileId"] = this.receiverCommunicationProfileId;
        return data;
    }
}

export interface ICreateAgreementTerminationRequest {
    respondBy?: Date | undefined;
    terminateBy?: Date | undefined;
    reason?: string | undefined;
    processingModeId: string;
    receiverCommunicationProfileId: string;
}

export class CreateMultipleAgreementTerminationsRequest implements ICreateMultipleAgreementTerminationsRequest {
    respondBy?: Date | undefined;
    terminateBy?: Date | undefined;
    reason?: string | undefined;
    communicationProfileIds!: string[];

    constructor(data?: ICreateMultipleAgreementTerminationsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.communicationProfileIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.respondBy = _data["respondBy"] ? new Date(_data["respondBy"].toString()) : <any>undefined;
            this.terminateBy = _data["terminateBy"] ? new Date(_data["terminateBy"].toString()) : <any>undefined;
            this.reason = _data["reason"];
            if (Array.isArray(_data["communicationProfileIds"])) {
                this.communicationProfileIds = [] as any;
                for (let item of _data["communicationProfileIds"])
                    this.communicationProfileIds!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateMultipleAgreementTerminationsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMultipleAgreementTerminationsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["respondBy"] = this.respondBy ? this.respondBy.toISOString() : <any>undefined;
        data["terminateBy"] = this.terminateBy ? this.terminateBy.toISOString() : <any>undefined;
        data["reason"] = this.reason;
        if (Array.isArray(this.communicationProfileIds)) {
            data["communicationProfileIds"] = [];
            for (let item of this.communicationProfileIds)
                data["communicationProfileIds"].push(item);
        }
        return data;
    }
}

export interface ICreateMultipleAgreementTerminationsRequest {
    respondBy?: Date | undefined;
    terminateBy?: Date | undefined;
    reason?: string | undefined;
    communicationProfileIds: string[];
}

export class EntsogCommunicationProfile implements IEntsogCommunicationProfile {
    communicationProfileId!: string;
    processingModeId?: string | undefined;

    constructor(data?: IEntsogCommunicationProfile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.communicationProfileId = _data["communicationProfileId"];
            this.processingModeId = _data["processingModeId"];
        }
    }

    static fromJS(data: any): EntsogCommunicationProfile {
        data = typeof data === 'object' ? data : {};
        let result = new EntsogCommunicationProfile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["communicationProfileId"] = this.communicationProfileId;
        data["processingModeId"] = this.processingModeId;
        return data;
    }
}

export interface IEntsogCommunicationProfile {
    communicationProfileId: string;
    processingModeId?: string | undefined;
}

export class ValidateMessageSettingProcessingModeRequest implements IValidateMessageSettingProcessingModeRequest {
    entsogCommunicationProfileId?: string | undefined;
    requestedProcessingModeIds?: string[] | undefined;

    constructor(data?: IValidateMessageSettingProcessingModeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entsogCommunicationProfileId = _data["entsogCommunicationProfileId"];
            if (Array.isArray(_data["requestedProcessingModeIds"])) {
                this.requestedProcessingModeIds = [] as any;
                for (let item of _data["requestedProcessingModeIds"])
                    this.requestedProcessingModeIds!.push(item);
            }
        }
    }

    static fromJS(data: any): ValidateMessageSettingProcessingModeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateMessageSettingProcessingModeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entsogCommunicationProfileId"] = this.entsogCommunicationProfileId;
        if (Array.isArray(this.requestedProcessingModeIds)) {
            data["requestedProcessingModeIds"] = [];
            for (let item of this.requestedProcessingModeIds)
                data["requestedProcessingModeIds"].push(item);
        }
        return data;
    }
}

export interface IValidateMessageSettingProcessingModeRequest {
    entsogCommunicationProfileId?: string | undefined;
    requestedProcessingModeIds?: string[] | undefined;
}

export class ValidateMessageSettingProcessingModeResponse implements IValidateMessageSettingProcessingModeResponse {
    linkedMessageSettingIds?: string[] | undefined;

    constructor(data?: IValidateMessageSettingProcessingModeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["linkedMessageSettingIds"])) {
                this.linkedMessageSettingIds = [] as any;
                for (let item of _data["linkedMessageSettingIds"])
                    this.linkedMessageSettingIds!.push(item);
            }
        }
    }

    static fromJS(data: any): ValidateMessageSettingProcessingModeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateMessageSettingProcessingModeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.linkedMessageSettingIds)) {
            data["linkedMessageSettingIds"] = [];
            for (let item of this.linkedMessageSettingIds)
                data["linkedMessageSettingIds"].push(item);
        }
        return data;
    }
}

export interface IValidateMessageSettingProcessingModeResponse {
    linkedMessageSettingIds?: string[] | undefined;
}

export class SaveAgreementTerminationDecisionRequest implements ISaveAgreementTerminationDecisionRequest {
    agreementRequestId!: string;
    isAccepted?: boolean;
    errorCode?: string | undefined;
    errorDescription?: string | undefined;

    constructor(data?: ISaveAgreementTerminationDecisionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.agreementRequestId = _data["agreementRequestId"];
            this.isAccepted = _data["isAccepted"];
            this.errorCode = _data["errorCode"];
            this.errorDescription = _data["errorDescription"];
        }
    }

    static fromJS(data: any): SaveAgreementTerminationDecisionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveAgreementTerminationDecisionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agreementRequestId"] = this.agreementRequestId;
        data["isAccepted"] = this.isAccepted;
        data["errorCode"] = this.errorCode;
        data["errorDescription"] = this.errorDescription;
        return data;
    }
}

export interface ISaveAgreementTerminationDecisionRequest {
    agreementRequestId: string;
    isAccepted?: boolean;
    errorCode?: string | undefined;
    errorDescription?: string | undefined;
}

export class SaveAgreementUpdateDecisionRequest implements ISaveAgreementUpdateDecisionRequest {
    agreementReferenceId!: string;
    isAccepted?: boolean;
    errorCode?: string | undefined;
    errorDescription?: string | undefined;

    constructor(data?: ISaveAgreementUpdateDecisionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.agreementReferenceId = _data["agreementReferenceId"];
            this.isAccepted = _data["isAccepted"];
            this.errorCode = _data["errorCode"];
            this.errorDescription = _data["errorDescription"];
        }
    }

    static fromJS(data: any): SaveAgreementUpdateDecisionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveAgreementUpdateDecisionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agreementReferenceId"] = this.agreementReferenceId;
        data["isAccepted"] = this.isAccepted;
        data["errorCode"] = this.errorCode;
        data["errorDescription"] = this.errorDescription;
        return data;
    }
}

export interface ISaveAgreementUpdateDecisionRequest {
    agreementReferenceId: string;
    isAccepted?: boolean;
    errorCode?: string | undefined;
    errorDescription?: string | undefined;
}

export class DashboardFileTransferStatusDto implements IDashboardFileTransferStatusDto {
    communicationProfileTransferId!: string;
    hostUri!: string;
    userName!: string;
    protocolType!: string;
    communicationProfileFileTransferStatusType?: CommunicationProfileFileTransferStatusType;
    description!: string;

    constructor(data?: IDashboardFileTransferStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.communicationProfileTransferId = _data["communicationProfileTransferId"];
            this.hostUri = _data["hostUri"];
            this.userName = _data["userName"];
            this.protocolType = _data["protocolType"];
            this.communicationProfileFileTransferStatusType = _data["communicationProfileFileTransferStatusType"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): DashboardFileTransferStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardFileTransferStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["communicationProfileTransferId"] = this.communicationProfileTransferId;
        data["hostUri"] = this.hostUri;
        data["userName"] = this.userName;
        data["protocolType"] = this.protocolType;
        data["communicationProfileFileTransferStatusType"] = this.communicationProfileFileTransferStatusType;
        data["description"] = this.description;
        return data;
    }
}

export interface IDashboardFileTransferStatusDto {
    communicationProfileTransferId: string;
    hostUri: string;
    userName: string;
    protocolType: string;
    communicationProfileFileTransferStatusType?: CommunicationProfileFileTransferStatusType;
    description: string;
}

export class ListDashboardFileTransferStatusResponse implements IListDashboardFileTransferStatusResponse {
    dashboardFileTransferStatusDtos?: DashboardFileTransferStatusDto[] | undefined;

    constructor(data?: IListDashboardFileTransferStatusResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["dashboardFileTransferStatusDtos"])) {
                this.dashboardFileTransferStatusDtos = [] as any;
                for (let item of _data["dashboardFileTransferStatusDtos"])
                    this.dashboardFileTransferStatusDtos!.push(DashboardFileTransferStatusDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListDashboardFileTransferStatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ListDashboardFileTransferStatusResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.dashboardFileTransferStatusDtos)) {
            data["dashboardFileTransferStatusDtos"] = [];
            for (let item of this.dashboardFileTransferStatusDtos)
                data["dashboardFileTransferStatusDtos"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListDashboardFileTransferStatusResponse {
    dashboardFileTransferStatusDtos?: DashboardFileTransferStatusDto[] | undefined;
}

export class AmqpTenantStatusListItemDto implements IAmqpTenantStatusListItemDto {
    tenant?: string | undefined;
    isHealthy?: boolean;
    eventDetail?: string | undefined;

    constructor(data?: IAmqpTenantStatusListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenant = _data["tenant"];
            this.isHealthy = _data["isHealthy"];
            this.eventDetail = _data["eventDetail"];
        }
    }

    static fromJS(data: any): AmqpTenantStatusListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new AmqpTenantStatusListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenant"] = this.tenant;
        data["isHealthy"] = this.isHealthy;
        data["eventDetail"] = this.eventDetail;
        return data;
    }
}

export interface IAmqpTenantStatusListItemDto {
    tenant?: string | undefined;
    isHealthy?: boolean;
    eventDetail?: string | undefined;
}

export class As4ConfigurationOverrideDto implements IAs4ConfigurationOverrideDto {
    id?: string | undefined;
    key?: string | undefined;
    value?: string | undefined;

    constructor(data?: IAs4ConfigurationOverrideDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): As4ConfigurationOverrideDto {
        data = typeof data === 'object' ? data : {};
        let result = new As4ConfigurationOverrideDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }
}

export interface IAs4ConfigurationOverrideDto {
    id?: string | undefined;
    key?: string | undefined;
    value?: string | undefined;
}

export enum ContentType {
    None = "None",
    ApplicationEdiX12 = "ApplicationEdiX12",
    ApplicationOctetStream = "ApplicationOctetStream",
    ApplicationXml = "ApplicationXml",
}

export class EntsogCommunicationProfileDto implements IEntsogCommunicationProfileDto {
    id?: string | undefined;
    communicationPartnerId?: string | undefined;
    backupCommunicationProfileId?: string | undefined;
    name?: string | undefined;
    validationDates?: ValidityDatesDto | undefined;
    retryStrategyId?: string | undefined;
    processingModes?: ProcessingModeDto[] | undefined;

    constructor(data?: IEntsogCommunicationProfileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.communicationPartnerId = _data["communicationPartnerId"];
            this.backupCommunicationProfileId = _data["backupCommunicationProfileId"];
            this.name = _data["name"];
            this.validationDates = _data["validationDates"] ? ValidityDatesDto.fromJS(_data["validationDates"]) : <any>undefined;
            this.retryStrategyId = _data["retryStrategyId"];
            if (Array.isArray(_data["processingModes"])) {
                this.processingModes = [] as any;
                for (let item of _data["processingModes"])
                    this.processingModes!.push(ProcessingModeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EntsogCommunicationProfileDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntsogCommunicationProfileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["communicationPartnerId"] = this.communicationPartnerId;
        data["backupCommunicationProfileId"] = this.backupCommunicationProfileId;
        data["name"] = this.name;
        data["validationDates"] = this.validationDates ? this.validationDates.toJSON() : <any>undefined;
        data["retryStrategyId"] = this.retryStrategyId;
        if (Array.isArray(this.processingModes)) {
            data["processingModes"] = [];
            for (let item of this.processingModes)
                data["processingModes"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEntsogCommunicationProfileDto {
    id?: string | undefined;
    communicationPartnerId?: string | undefined;
    backupCommunicationProfileId?: string | undefined;
    name?: string | undefined;
    validationDates?: ValidityDatesDto | undefined;
    retryStrategyId?: string | undefined;
    processingModes?: ProcessingModeDto[] | undefined;
}

export class EntsogCommunicationProfileListItemDto implements IEntsogCommunicationProfileListItemDto {
    id?: string | undefined;
    communicationPartnerId?: string | undefined;
    communicationProtocolCode?: string | undefined;
    name?: string | undefined;
    validityDates?: ValidityDatesDto | undefined;
    isActive?: boolean;
    processingModeDtos?: ProcessingModeDto[] | undefined;

    constructor(data?: IEntsogCommunicationProfileListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.communicationPartnerId = _data["communicationPartnerId"];
            this.communicationProtocolCode = _data["communicationProtocolCode"];
            this.name = _data["name"];
            this.validityDates = _data["validityDates"] ? ValidityDatesDto.fromJS(_data["validityDates"]) : <any>undefined;
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["processingModeDtos"])) {
                this.processingModeDtos = [] as any;
                for (let item of _data["processingModeDtos"])
                    this.processingModeDtos!.push(ProcessingModeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EntsogCommunicationProfileListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntsogCommunicationProfileListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["communicationPartnerId"] = this.communicationPartnerId;
        data["communicationProtocolCode"] = this.communicationProtocolCode;
        data["name"] = this.name;
        data["validityDates"] = this.validityDates ? this.validityDates.toJSON() : <any>undefined;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.processingModeDtos)) {
            data["processingModeDtos"] = [];
            for (let item of this.processingModeDtos)
                data["processingModeDtos"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEntsogCommunicationProfileListItemDto {
    id?: string | undefined;
    communicationPartnerId?: string | undefined;
    communicationProtocolCode?: string | undefined;
    name?: string | undefined;
    validityDates?: ValidityDatesDto | undefined;
    isActive?: boolean;
    processingModeDtos?: ProcessingModeDto[] | undefined;
}

export class EntsogPartnerCommunicationProfileDto implements IEntsogPartnerCommunicationProfileDto {
    id?: string | undefined;
    name?: string | undefined;

    constructor(data?: IEntsogPartnerCommunicationProfileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): EntsogPartnerCommunicationProfileDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntsogPartnerCommunicationProfileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IEntsogPartnerCommunicationProfileDto {
    id?: string | undefined;
    name?: string | undefined;
}

export class EntsogSecretFunctionalityDto implements IEntsogSecretFunctionalityDto {
    id?: string | undefined;
    processingModeId?: string | undefined;
    secretId?: string | undefined;
    secretUsage?: SecretUsage;
    name?: string | undefined;
    secretType?: SecretType | undefined;
    secretSubType?: SecretSubType | undefined;
    validityDates?: ValidityDatesDto | undefined;

    constructor(data?: IEntsogSecretFunctionalityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.processingModeId = _data["processingModeId"];
            this.secretId = _data["secretId"];
            this.secretUsage = _data["secretUsage"];
            this.name = _data["name"];
            this.secretType = _data["secretType"];
            this.secretSubType = _data["secretSubType"];
            this.validityDates = _data["validityDates"] ? ValidityDatesDto.fromJS(_data["validityDates"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EntsogSecretFunctionalityDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntsogSecretFunctionalityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["processingModeId"] = this.processingModeId;
        data["secretId"] = this.secretId;
        data["secretUsage"] = this.secretUsage;
        data["name"] = this.name;
        data["secretType"] = this.secretType;
        data["secretSubType"] = this.secretSubType;
        data["validityDates"] = this.validityDates ? this.validityDates.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEntsogSecretFunctionalityDto {
    id?: string | undefined;
    processingModeId?: string | undefined;
    secretId?: string | undefined;
    secretUsage?: SecretUsage;
    name?: string | undefined;
    secretType?: SecretType | undefined;
    secretSubType?: SecretSubType | undefined;
    validityDates?: ValidityDatesDto | undefined;
}

export class GetEntsogCommunicationProfileRequest implements IGetEntsogCommunicationProfileRequest {
    id?: string | undefined;

    constructor(data?: IGetEntsogCommunicationProfileRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetEntsogCommunicationProfileRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetEntsogCommunicationProfileRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IGetEntsogCommunicationProfileRequest {
    id?: string | undefined;
}

export class GetEntsogCommunicationProfileResponse implements IGetEntsogCommunicationProfileResponse {
    entsogCommunicationProfileDto?: EntsogCommunicationProfileDto | undefined;

    constructor(data?: IGetEntsogCommunicationProfileResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entsogCommunicationProfileDto = _data["entsogCommunicationProfileDto"] ? EntsogCommunicationProfileDto.fromJS(_data["entsogCommunicationProfileDto"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetEntsogCommunicationProfileResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetEntsogCommunicationProfileResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entsogCommunicationProfileDto"] = this.entsogCommunicationProfileDto ? this.entsogCommunicationProfileDto.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetEntsogCommunicationProfileResponse {
    entsogCommunicationProfileDto?: EntsogCommunicationProfileDto | undefined;
}

export class GetPartnerEntsogCommunicationProfileRequest implements IGetPartnerEntsogCommunicationProfileRequest {
    partnerId?: string | undefined;
    partnerLinkedMessageSettings?: number[] | undefined;

    constructor(data?: IGetPartnerEntsogCommunicationProfileRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partnerId = _data["partnerId"];
            if (Array.isArray(_data["partnerLinkedMessageSettings"])) {
                this.partnerLinkedMessageSettings = [] as any;
                for (let item of _data["partnerLinkedMessageSettings"])
                    this.partnerLinkedMessageSettings!.push(item);
            }
        }
    }

    static fromJS(data: any): GetPartnerEntsogCommunicationProfileRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetPartnerEntsogCommunicationProfileRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partnerId"] = this.partnerId;
        if (Array.isArray(this.partnerLinkedMessageSettings)) {
            data["partnerLinkedMessageSettings"] = [];
            for (let item of this.partnerLinkedMessageSettings)
                data["partnerLinkedMessageSettings"].push(item);
        }
        return data;
    }
}

export interface IGetPartnerEntsogCommunicationProfileRequest {
    partnerId?: string | undefined;
    partnerLinkedMessageSettings?: number[] | undefined;
}

export class GetPartnerEntsogCommunicationProfileResponse implements IGetPartnerEntsogCommunicationProfileResponse {
    entsogPartnerCommunicationProfileDtos?: EntsogPartnerCommunicationProfileDto[] | undefined;

    constructor(data?: IGetPartnerEntsogCommunicationProfileResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["entsogPartnerCommunicationProfileDtos"])) {
                this.entsogPartnerCommunicationProfileDtos = [] as any;
                for (let item of _data["entsogPartnerCommunicationProfileDtos"])
                    this.entsogPartnerCommunicationProfileDtos!.push(EntsogPartnerCommunicationProfileDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPartnerEntsogCommunicationProfileResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPartnerEntsogCommunicationProfileResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.entsogPartnerCommunicationProfileDtos)) {
            data["entsogPartnerCommunicationProfileDtos"] = [];
            for (let item of this.entsogPartnerCommunicationProfileDtos)
                data["entsogPartnerCommunicationProfileDtos"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetPartnerEntsogCommunicationProfileResponse {
    entsogPartnerCommunicationProfileDtos?: EntsogPartnerCommunicationProfileDto[] | undefined;
}

export class ListEntsogCommunicationProfileResponse implements IListEntsogCommunicationProfileResponse {
    entsogCommunicationProfileListItemDtos?: EntsogCommunicationProfileListItemDto[] | undefined;

    constructor(data?: IListEntsogCommunicationProfileResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["entsogCommunicationProfileListItemDtos"])) {
                this.entsogCommunicationProfileListItemDtos = [] as any;
                for (let item of _data["entsogCommunicationProfileListItemDtos"])
                    this.entsogCommunicationProfileListItemDtos!.push(EntsogCommunicationProfileListItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListEntsogCommunicationProfileResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ListEntsogCommunicationProfileResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.entsogCommunicationProfileListItemDtos)) {
            data["entsogCommunicationProfileListItemDtos"] = [];
            for (let item of this.entsogCommunicationProfileListItemDtos)
                data["entsogCommunicationProfileListItemDtos"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListEntsogCommunicationProfileResponse {
    entsogCommunicationProfileListItemDtos?: EntsogCommunicationProfileListItemDto[] | undefined;
}

export class ProcessingModeDto implements IProcessingModeDto {
    id?: string | undefined;
    processingModeVersion?: ProcessingModeVersion;
    description?: string | undefined;
    deliveryUri?: string | undefined;
    selfAs4Reference?: string | undefined;
    partnerAs4Reference?: string | undefined;
    senderRole?: string | undefined;
    receiverRole?: string | undefined;
    serviceName?: string | undefined;
    serviceType?: string | undefined;
    serviceAction?: string | undefined;
    documentType?: string | undefined;
    contentType?: ContentType;
    receiverIdType?: string | undefined;
    senderIdType?: string | undefined;
    agreementReference?: string | undefined;
    useForSending?: boolean;
    validityDates?: ValidityDatesDto | undefined;
    secretFunctionalities?: EntsogSecretFunctionalityDto[] | undefined;
    as4ConfigurationOverrides?: As4ConfigurationOverrideDto[] | undefined;

    constructor(data?: IProcessingModeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.processingModeVersion = _data["processingModeVersion"];
            this.description = _data["description"];
            this.deliveryUri = _data["deliveryUri"];
            this.selfAs4Reference = _data["selfAs4Reference"];
            this.partnerAs4Reference = _data["partnerAs4Reference"];
            this.senderRole = _data["senderRole"];
            this.receiverRole = _data["receiverRole"];
            this.serviceName = _data["serviceName"];
            this.serviceType = _data["serviceType"];
            this.serviceAction = _data["serviceAction"];
            this.documentType = _data["documentType"];
            this.contentType = _data["contentType"];
            this.receiverIdType = _data["receiverIdType"];
            this.senderIdType = _data["senderIdType"];
            this.agreementReference = _data["agreementReference"];
            this.useForSending = _data["useForSending"];
            this.validityDates = _data["validityDates"] ? ValidityDatesDto.fromJS(_data["validityDates"]) : <any>undefined;
            if (Array.isArray(_data["secretFunctionalities"])) {
                this.secretFunctionalities = [] as any;
                for (let item of _data["secretFunctionalities"])
                    this.secretFunctionalities!.push(EntsogSecretFunctionalityDto.fromJS(item));
            }
            if (Array.isArray(_data["as4ConfigurationOverrides"])) {
                this.as4ConfigurationOverrides = [] as any;
                for (let item of _data["as4ConfigurationOverrides"])
                    this.as4ConfigurationOverrides!.push(As4ConfigurationOverrideDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProcessingModeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessingModeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["processingModeVersion"] = this.processingModeVersion;
        data["description"] = this.description;
        data["deliveryUri"] = this.deliveryUri;
        data["selfAs4Reference"] = this.selfAs4Reference;
        data["partnerAs4Reference"] = this.partnerAs4Reference;
        data["senderRole"] = this.senderRole;
        data["receiverRole"] = this.receiverRole;
        data["serviceName"] = this.serviceName;
        data["serviceType"] = this.serviceType;
        data["serviceAction"] = this.serviceAction;
        data["documentType"] = this.documentType;
        data["contentType"] = this.contentType;
        data["receiverIdType"] = this.receiverIdType;
        data["senderIdType"] = this.senderIdType;
        data["agreementReference"] = this.agreementReference;
        data["useForSending"] = this.useForSending;
        data["validityDates"] = this.validityDates ? this.validityDates.toJSON() : <any>undefined;
        if (Array.isArray(this.secretFunctionalities)) {
            data["secretFunctionalities"] = [];
            for (let item of this.secretFunctionalities)
                data["secretFunctionalities"].push(item.toJSON());
        }
        if (Array.isArray(this.as4ConfigurationOverrides)) {
            data["as4ConfigurationOverrides"] = [];
            for (let item of this.as4ConfigurationOverrides)
                data["as4ConfigurationOverrides"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProcessingModeDto {
    id?: string | undefined;
    processingModeVersion?: ProcessingModeVersion;
    description?: string | undefined;
    deliveryUri?: string | undefined;
    selfAs4Reference?: string | undefined;
    partnerAs4Reference?: string | undefined;
    senderRole?: string | undefined;
    receiverRole?: string | undefined;
    serviceName?: string | undefined;
    serviceType?: string | undefined;
    serviceAction?: string | undefined;
    documentType?: string | undefined;
    contentType?: ContentType;
    receiverIdType?: string | undefined;
    senderIdType?: string | undefined;
    agreementReference?: string | undefined;
    useForSending?: boolean;
    validityDates?: ValidityDatesDto | undefined;
    secretFunctionalities?: EntsogSecretFunctionalityDto[] | undefined;
    as4ConfigurationOverrides?: As4ConfigurationOverrideDto[] | undefined;
}

export enum ProcessingModeVersion {
    EntsogV36 = "EntsogV36",
    EntsogV4 = "EntsogV4",
    BDEW = "BDEW",
    Delivery = "Delivery",
    DeliveryV2 = "DeliveryV2",
}

export class SaveEntsogCommunicationProfileRequest implements ISaveEntsogCommunicationProfileRequest {
    entsogCommunicationProfileDto?: EntsogCommunicationProfileDto | undefined;

    constructor(data?: ISaveEntsogCommunicationProfileRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entsogCommunicationProfileDto = _data["entsogCommunicationProfileDto"] ? EntsogCommunicationProfileDto.fromJS(_data["entsogCommunicationProfileDto"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SaveEntsogCommunicationProfileRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveEntsogCommunicationProfileRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entsogCommunicationProfileDto"] = this.entsogCommunicationProfileDto ? this.entsogCommunicationProfileDto.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISaveEntsogCommunicationProfileRequest {
    entsogCommunicationProfileDto?: EntsogCommunicationProfileDto | undefined;
}

export enum SecretSubType {
    Private = "Private",
    Public = "Public",
}

export enum SecretType {
    PGP = "PGP",
    SSH = "SSH",
    Certificate = "Certificate",
    EDDSA = "EDDSA",
    ECDSA = "ECDSA",
}

export enum SecretUsage {
    Authentication = "Authentication",
    Encryption = "Encryption",
}

export class ValidityDatesDto implements IValidityDatesDto {
    from?: Date;
    to?: Date;

    constructor(data?: IValidityDatesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"] ? new Date(_data["from"].toString()) : <any>undefined;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ValidityDatesDto {
        data = typeof data === 'object' ? data : {};
        let result = new ValidityDatesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        return data;
    }
}

export interface IValidityDatesDto {
    from?: Date;
    to?: Date;
}

export enum ActionType {
    Email = "Email",
}

export class AgreementUpdateOverviewDto implements IAgreementUpdateOverviewDto {
    agreementUpdateId?: string | undefined;
    timestamp?: Date;
    requestor?: string | undefined;
    recipient?: string | undefined;
    status?: string | undefined;
    type?: string | undefined;

    constructor(data?: IAgreementUpdateOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.agreementUpdateId = _data["agreementUpdateId"];
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : <any>undefined;
            this.requestor = _data["requestor"];
            this.recipient = _data["recipient"];
            this.status = _data["status"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): AgreementUpdateOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgreementUpdateOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agreementUpdateId"] = this.agreementUpdateId;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        data["requestor"] = this.requestor;
        data["recipient"] = this.recipient;
        data["status"] = this.status;
        data["type"] = this.type;
        return data;
    }
}

export interface IAgreementUpdateOverviewDto {
    agreementUpdateId?: string | undefined;
    timestamp?: Date;
    requestor?: string | undefined;
    recipient?: string | undefined;
    status?: string | undefined;
    type?: string | undefined;
}

export class AlertActionDto implements IAlertActionDto {
    id?: string | undefined;
    actionType!: ActionType;
    percentage?: number;

    constructor(data?: IAlertActionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.actionType = _data["actionType"];
            this.percentage = _data["percentage"];
        }
    }

    static fromJS(data: any): AlertActionDto {
        data = typeof data === 'object' ? data : {};
        let result = new AlertActionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["actionType"] = this.actionType;
        data["percentage"] = this.percentage;
        return data;
    }
}

export interface IAlertActionDto {
    id?: string | undefined;
    actionType: ActionType;
    percentage?: number;
}

export class AlertConfigurationDto implements IAlertConfigurationDto {
    id?: string | undefined;
    numberOfAllowedMessages?: number;
    cycle!: PeriodCycle;
    status!: ConfigurationStatus;
    description?: string | undefined;
    tenantCode!: string;
    activationTimestamp?: Date;
    resetTimestamp?: Date;
    alertActions?: AlertActionDto[] | undefined;

    constructor(data?: IAlertConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.numberOfAllowedMessages = _data["numberOfAllowedMessages"];
            this.cycle = _data["cycle"];
            this.status = _data["status"];
            this.description = _data["description"];
            this.tenantCode = _data["tenantCode"];
            this.activationTimestamp = _data["activationTimestamp"] ? new Date(_data["activationTimestamp"].toString()) : <any>undefined;
            this.resetTimestamp = _data["resetTimestamp"] ? new Date(_data["resetTimestamp"].toString()) : <any>undefined;
            if (Array.isArray(_data["alertActions"])) {
                this.alertActions = [] as any;
                for (let item of _data["alertActions"])
                    this.alertActions!.push(AlertActionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AlertConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new AlertConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["numberOfAllowedMessages"] = this.numberOfAllowedMessages;
        data["cycle"] = this.cycle;
        data["status"] = this.status;
        data["description"] = this.description;
        data["tenantCode"] = this.tenantCode;
        data["activationTimestamp"] = this.activationTimestamp ? this.activationTimestamp.toISOString() : <any>undefined;
        data["resetTimestamp"] = this.resetTimestamp ? this.resetTimestamp.toISOString() : <any>undefined;
        if (Array.isArray(this.alertActions)) {
            data["alertActions"] = [];
            for (let item of this.alertActions)
                data["alertActions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAlertConfigurationDto {
    id?: string | undefined;
    numberOfAllowedMessages?: number;
    cycle: PeriodCycle;
    status: ConfigurationStatus;
    description?: string | undefined;
    tenantCode: string;
    activationTimestamp?: Date;
    resetTimestamp?: Date;
    alertActions?: AlertActionDto[] | undefined;
}

export class AlertCounterCheckResultDto implements IAlertCounterCheckResultDto {
    id?: string | undefined;
    counterCount?: number;
    messagesCount?: number;

    constructor(data?: IAlertCounterCheckResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.counterCount = _data["counterCount"];
            this.messagesCount = _data["messagesCount"];
        }
    }

    static fromJS(data: any): AlertCounterCheckResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AlertCounterCheckResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["counterCount"] = this.counterCount;
        data["messagesCount"] = this.messagesCount;
        return data;
    }
}

export interface IAlertCounterCheckResultDto {
    id?: string | undefined;
    counterCount?: number;
    messagesCount?: number;
}

export class AuditEventCategoryDto implements IAuditEventCategoryDto {
    categoryName?: string | undefined;
    auditEvents?: AuditEventDto[] | undefined;

    constructor(data?: IAuditEventCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.categoryName = _data["categoryName"];
            if (Array.isArray(_data["auditEvents"])) {
                this.auditEvents = [] as any;
                for (let item of _data["auditEvents"])
                    this.auditEvents!.push(AuditEventDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AuditEventCategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuditEventCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categoryName"] = this.categoryName;
        if (Array.isArray(this.auditEvents)) {
            data["auditEvents"] = [];
            for (let item of this.auditEvents)
                data["auditEvents"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAuditEventCategoryDto {
    categoryName?: string | undefined;
    auditEvents?: AuditEventDto[] | undefined;
}

export class AuditEventDto implements IAuditEventDto {
    connectMessageId?: string | undefined;
    auditType?: string | undefined;
    errorType?: string | undefined;
    audit?: string | undefined;
    eventDetail?: string | undefined;
    origin?: string | undefined;
    auditDateTime?: Date;
    id?: string | undefined;

    constructor(data?: IAuditEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.connectMessageId = _data["connectMessageId"];
            this.auditType = _data["auditType"];
            this.errorType = _data["errorType"];
            this.audit = _data["audit"];
            this.eventDetail = _data["eventDetail"];
            this.origin = _data["origin"];
            this.auditDateTime = _data["auditDateTime"] ? new Date(_data["auditDateTime"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AuditEventDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuditEventDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["connectMessageId"] = this.connectMessageId;
        data["auditType"] = this.auditType;
        data["errorType"] = this.errorType;
        data["audit"] = this.audit;
        data["eventDetail"] = this.eventDetail;
        data["origin"] = this.origin;
        data["auditDateTime"] = this.auditDateTime ? this.auditDateTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IAuditEventDto {
    connectMessageId?: string | undefined;
    auditType?: string | undefined;
    errorType?: string | undefined;
    audit?: string | undefined;
    eventDetail?: string | undefined;
    origin?: string | undefined;
    auditDateTime?: Date;
    id?: string | undefined;
}

export enum ConfigurationStatus {
    Active = "Active",
    Inactive = "Inactive",
}

export class ConnectMessageDetailDto implements IConnectMessageDetailDto {
    messageIdentifier?: string;
    tenant?: string | undefined;
    messageSettingId?: string | undefined;
    timestamp?: Date;
    senderInternalCode?: string | undefined;
    receiverInternalCode?: string | undefined;
    direction?: string | undefined;
    type?: string | undefined;
    statusCode?: string | undefined;
    status?: string | undefined;
    externalProtocol?: string | undefined;
    communicationSenderCode?: string | undefined;
    communicationReceiverCode?: string | undefined;
    notificationTo?: string | undefined;
    notificationToDiscriminator?: string | undefined;
    externalReference?: string | undefined;
    fileName?: string | undefined;
    generatedExternalReference?: string | undefined;
    auditEventDtos?: AuditEventDto[] | undefined;
    auditEventCategoriesDtos?: AuditEventCategoryDto[] | undefined;
    connectMessageRelationDtos?: ConnectMessageRelationDto[] | undefined;
    createdOn?: Date;
    id?: string | undefined;
    communicationProfileExcluded?: boolean;
    applicationContext?: string | undefined;
    validFrom?: Date | undefined;
    validTo?: Date | undefined;
    messageTypeSpecification?: string | undefined;
    isArchived?: boolean;

    constructor(data?: IConnectMessageDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messageIdentifier = _data["messageIdentifier"];
            this.tenant = _data["tenant"];
            this.messageSettingId = _data["messageSettingId"];
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : <any>undefined;
            this.senderInternalCode = _data["senderInternalCode"];
            this.receiverInternalCode = _data["receiverInternalCode"];
            this.direction = _data["direction"];
            this.type = _data["type"];
            this.statusCode = _data["statusCode"];
            this.status = _data["status"];
            this.externalProtocol = _data["externalProtocol"];
            this.communicationSenderCode = _data["communicationSenderCode"];
            this.communicationReceiverCode = _data["communicationReceiverCode"];
            this.notificationTo = _data["notificationTo"];
            this.notificationToDiscriminator = _data["notificationToDiscriminator"];
            this.externalReference = _data["externalReference"];
            this.fileName = _data["fileName"];
            this.generatedExternalReference = _data["generatedExternalReference"];
            if (Array.isArray(_data["auditEventDtos"])) {
                this.auditEventDtos = [] as any;
                for (let item of _data["auditEventDtos"])
                    this.auditEventDtos!.push(AuditEventDto.fromJS(item));
            }
            if (Array.isArray(_data["auditEventCategoriesDtos"])) {
                this.auditEventCategoriesDtos = [] as any;
                for (let item of _data["auditEventCategoriesDtos"])
                    this.auditEventCategoriesDtos!.push(AuditEventCategoryDto.fromJS(item));
            }
            if (Array.isArray(_data["connectMessageRelationDtos"])) {
                this.connectMessageRelationDtos = [] as any;
                for (let item of _data["connectMessageRelationDtos"])
                    this.connectMessageRelationDtos!.push(ConnectMessageRelationDto.fromJS(item));
            }
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.id = _data["id"];
            this.communicationProfileExcluded = _data["communicationProfileExcluded"];
            this.applicationContext = _data["applicationContext"];
            this.validFrom = _data["validFrom"] ? new Date(_data["validFrom"].toString()) : <any>undefined;
            this.validTo = _data["validTo"] ? new Date(_data["validTo"].toString()) : <any>undefined;
            this.messageTypeSpecification = _data["messageTypeSpecification"];
            this.isArchived = _data["isArchived"];
        }
    }

    static fromJS(data: any): ConnectMessageDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConnectMessageDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messageIdentifier"] = this.messageIdentifier;
        data["tenant"] = this.tenant;
        data["messageSettingId"] = this.messageSettingId;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        data["senderInternalCode"] = this.senderInternalCode;
        data["receiverInternalCode"] = this.receiverInternalCode;
        data["direction"] = this.direction;
        data["type"] = this.type;
        data["statusCode"] = this.statusCode;
        data["status"] = this.status;
        data["externalProtocol"] = this.externalProtocol;
        data["communicationSenderCode"] = this.communicationSenderCode;
        data["communicationReceiverCode"] = this.communicationReceiverCode;
        data["notificationTo"] = this.notificationTo;
        data["notificationToDiscriminator"] = this.notificationToDiscriminator;
        data["externalReference"] = this.externalReference;
        data["fileName"] = this.fileName;
        data["generatedExternalReference"] = this.generatedExternalReference;
        if (Array.isArray(this.auditEventDtos)) {
            data["auditEventDtos"] = [];
            for (let item of this.auditEventDtos)
                data["auditEventDtos"].push(item.toJSON());
        }
        if (Array.isArray(this.auditEventCategoriesDtos)) {
            data["auditEventCategoriesDtos"] = [];
            for (let item of this.auditEventCategoriesDtos)
                data["auditEventCategoriesDtos"].push(item.toJSON());
        }
        if (Array.isArray(this.connectMessageRelationDtos)) {
            data["connectMessageRelationDtos"] = [];
            for (let item of this.connectMessageRelationDtos)
                data["connectMessageRelationDtos"].push(item.toJSON());
        }
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["id"] = this.id;
        data["communicationProfileExcluded"] = this.communicationProfileExcluded;
        data["applicationContext"] = this.applicationContext;
        data["validFrom"] = this.validFrom ? this.validFrom.toISOString() : <any>undefined;
        data["validTo"] = this.validTo ? this.validTo.toISOString() : <any>undefined;
        data["messageTypeSpecification"] = this.messageTypeSpecification;
        data["isArchived"] = this.isArchived;
        return data;
    }
}

export interface IConnectMessageDetailDto {
    messageIdentifier?: string;
    tenant?: string | undefined;
    messageSettingId?: string | undefined;
    timestamp?: Date;
    senderInternalCode?: string | undefined;
    receiverInternalCode?: string | undefined;
    direction?: string | undefined;
    type?: string | undefined;
    statusCode?: string | undefined;
    status?: string | undefined;
    externalProtocol?: string | undefined;
    communicationSenderCode?: string | undefined;
    communicationReceiverCode?: string | undefined;
    notificationTo?: string | undefined;
    notificationToDiscriminator?: string | undefined;
    externalReference?: string | undefined;
    fileName?: string | undefined;
    generatedExternalReference?: string | undefined;
    auditEventDtos?: AuditEventDto[] | undefined;
    auditEventCategoriesDtos?: AuditEventCategoryDto[] | undefined;
    connectMessageRelationDtos?: ConnectMessageRelationDto[] | undefined;
    createdOn?: Date;
    id?: string | undefined;
    communicationProfileExcluded?: boolean;
    applicationContext?: string | undefined;
    validFrom?: Date | undefined;
    validTo?: Date | undefined;
    messageTypeSpecification?: string | undefined;
    isArchived?: boolean;
}

export class ConnectMessageListItemDto implements IConnectMessageListItemDto {
    id?: string | undefined;
    messageIdentifier?: string;
    tenant?: string | undefined;
    createdOn?: Date;
    senderInternalCode?: string | undefined;
    receiverInternalCode?: string | undefined;
    direction?: string | undefined;
    type?: string | undefined;
    status?: string | undefined;
    externalProtocol?: string | undefined;
    communicationProfileExcluded?: boolean;
    messageTypeSpecification?: string | undefined;
    isReprocessed?: boolean;
    fileName?: string | undefined;

    constructor(data?: IConnectMessageListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.messageIdentifier = _data["messageIdentifier"];
            this.tenant = _data["tenant"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.senderInternalCode = _data["senderInternalCode"];
            this.receiverInternalCode = _data["receiverInternalCode"];
            this.direction = _data["direction"];
            this.type = _data["type"];
            this.status = _data["status"];
            this.externalProtocol = _data["externalProtocol"];
            this.communicationProfileExcluded = _data["communicationProfileExcluded"];
            this.messageTypeSpecification = _data["messageTypeSpecification"];
            this.isReprocessed = _data["isReprocessed"];
            this.fileName = _data["fileName"];
        }
    }

    static fromJS(data: any): ConnectMessageListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConnectMessageListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["messageIdentifier"] = this.messageIdentifier;
        data["tenant"] = this.tenant;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["senderInternalCode"] = this.senderInternalCode;
        data["receiverInternalCode"] = this.receiverInternalCode;
        data["direction"] = this.direction;
        data["type"] = this.type;
        data["status"] = this.status;
        data["externalProtocol"] = this.externalProtocol;
        data["communicationProfileExcluded"] = this.communicationProfileExcluded;
        data["messageTypeSpecification"] = this.messageTypeSpecification;
        data["isReprocessed"] = this.isReprocessed;
        data["fileName"] = this.fileName;
        return data;
    }
}

export interface IConnectMessageListItemDto {
    id?: string | undefined;
    messageIdentifier?: string;
    tenant?: string | undefined;
    createdOn?: Date;
    senderInternalCode?: string | undefined;
    receiverInternalCode?: string | undefined;
    direction?: string | undefined;
    type?: string | undefined;
    status?: string | undefined;
    externalProtocol?: string | undefined;
    communicationProfileExcluded?: boolean;
    messageTypeSpecification?: string | undefined;
    isReprocessed?: boolean;
    fileName?: string | undefined;
}

export class ConnectMessageRelationDto implements IConnectMessageRelationDto {
    connectMessageId?: string | undefined;
    relatedConnectMessageId?: string | undefined;
    relationType?: string | undefined;
    familyType?: string | undefined;
    id?: string | undefined;

    constructor(data?: IConnectMessageRelationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.connectMessageId = _data["connectMessageId"];
            this.relatedConnectMessageId = _data["relatedConnectMessageId"];
            this.relationType = _data["relationType"];
            this.familyType = _data["familyType"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ConnectMessageRelationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConnectMessageRelationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["connectMessageId"] = this.connectMessageId;
        data["relatedConnectMessageId"] = this.relatedConnectMessageId;
        data["relationType"] = this.relationType;
        data["familyType"] = this.familyType;
        data["id"] = this.id;
        return data;
    }
}

export interface IConnectMessageRelationDto {
    connectMessageId?: string | undefined;
    relatedConnectMessageId?: string | undefined;
    relationType?: string | undefined;
    familyType?: string | undefined;
    id?: string | undefined;
}

export class DashboardGatewayStatusListItemDto implements IDashboardGatewayStatusListItemDto {
    type?: string | undefined;
    inTiming?: number;
    outTiming?: number;
    acceptableInTiming?: number;
    acceptableOutTiming?: number;

    constructor(data?: IDashboardGatewayStatusListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.inTiming = _data["inTiming"];
            this.outTiming = _data["outTiming"];
            this.acceptableInTiming = _data["acceptableInTiming"];
            this.acceptableOutTiming = _data["acceptableOutTiming"];
        }
    }

    static fromJS(data: any): DashboardGatewayStatusListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardGatewayStatusListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["inTiming"] = this.inTiming;
        data["outTiming"] = this.outTiming;
        data["acceptableInTiming"] = this.acceptableInTiming;
        data["acceptableOutTiming"] = this.acceptableOutTiming;
        return data;
    }
}

export interface IDashboardGatewayStatusListItemDto {
    type?: string | undefined;
    inTiming?: number;
    outTiming?: number;
    acceptableInTiming?: number;
    acceptableOutTiming?: number;
}

export class DashboardMessageFailStatusDetailListItemDto implements IDashboardMessageFailStatusDetailListItemDto {
    id?: string | undefined;
    tradingPartnerCode?: string | undefined;
    messageTypeCode?: string | undefined;
    direction?: string | undefined;
    messageStatusReasonDescription?: string | undefined;
    errorInfo?: ErrorInfo[] | undefined;
    countTotalMessages?: number;
    tenant?: string | undefined;

    constructor(data?: IDashboardMessageFailStatusDetailListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tradingPartnerCode = _data["tradingPartnerCode"];
            this.messageTypeCode = _data["messageTypeCode"];
            this.direction = _data["direction"];
            this.messageStatusReasonDescription = _data["messageStatusReasonDescription"];
            if (Array.isArray(_data["errorInfo"])) {
                this.errorInfo = [] as any;
                for (let item of _data["errorInfo"])
                    this.errorInfo!.push(ErrorInfo.fromJS(item));
            }
            this.countTotalMessages = _data["countTotalMessages"];
            this.tenant = _data["tenant"];
        }
    }

    static fromJS(data: any): DashboardMessageFailStatusDetailListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardMessageFailStatusDetailListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tradingPartnerCode"] = this.tradingPartnerCode;
        data["messageTypeCode"] = this.messageTypeCode;
        data["direction"] = this.direction;
        data["messageStatusReasonDescription"] = this.messageStatusReasonDescription;
        if (Array.isArray(this.errorInfo)) {
            data["errorInfo"] = [];
            for (let item of this.errorInfo)
                data["errorInfo"].push(item.toJSON());
        }
        data["countTotalMessages"] = this.countTotalMessages;
        data["tenant"] = this.tenant;
        return data;
    }
}

export interface IDashboardMessageFailStatusDetailListItemDto {
    id?: string | undefined;
    tradingPartnerCode?: string | undefined;
    messageTypeCode?: string | undefined;
    direction?: string | undefined;
    messageStatusReasonDescription?: string | undefined;
    errorInfo?: ErrorInfo[] | undefined;
    countTotalMessages?: number;
    tenant?: string | undefined;
}

export class DashboardMessageFailStatusListItemDto implements IDashboardMessageFailStatusListItemDto {
    statusDescription?: string | undefined;
    totalMessages?: number;

    constructor(data?: IDashboardMessageFailStatusListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusDescription = _data["statusDescription"];
            this.totalMessages = _data["totalMessages"];
        }
    }

    static fromJS(data: any): DashboardMessageFailStatusListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardMessageFailStatusListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusDescription"] = this.statusDescription;
        data["totalMessages"] = this.totalMessages;
        return data;
    }
}

export interface IDashboardMessageFailStatusListItemDto {
    statusDescription?: string | undefined;
    totalMessages?: number;
}

export class DashboardMessageStatusListItemDto implements IDashboardMessageStatusListItemDto {
    connectMessageId?: string | undefined;
    messageIdentifier?: string;
    tenantCode?: string | undefined;
    connectMessageStatus?: string | undefined;
    connectMessageStatusReason?: string | undefined;
    createdOn?: Date;

    constructor(data?: IDashboardMessageStatusListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.connectMessageId = _data["connectMessageId"];
            this.messageIdentifier = _data["messageIdentifier"];
            this.tenantCode = _data["tenantCode"];
            this.connectMessageStatus = _data["connectMessageStatus"];
            this.connectMessageStatusReason = _data["connectMessageStatusReason"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DashboardMessageStatusListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardMessageStatusListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["connectMessageId"] = this.connectMessageId;
        data["messageIdentifier"] = this.messageIdentifier;
        data["tenantCode"] = this.tenantCode;
        data["connectMessageStatus"] = this.connectMessageStatus;
        data["connectMessageStatusReason"] = this.connectMessageStatusReason;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IDashboardMessageStatusListItemDto {
    connectMessageId?: string | undefined;
    messageIdentifier?: string;
    tenantCode?: string | undefined;
    connectMessageStatus?: string | undefined;
    connectMessageStatusReason?: string | undefined;
    createdOn?: Date;
}

export class DashboardUnknownMessagesListItemDto implements IDashboardUnknownMessagesListItemDto {
    communicationPartnerDescription?: string | undefined;
    numberOfMessages?: number;

    constructor(data?: IDashboardUnknownMessagesListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.communicationPartnerDescription = _data["communicationPartnerDescription"];
            this.numberOfMessages = _data["numberOfMessages"];
        }
    }

    static fromJS(data: any): DashboardUnknownMessagesListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardUnknownMessagesListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["communicationPartnerDescription"] = this.communicationPartnerDescription;
        data["numberOfMessages"] = this.numberOfMessages;
        return data;
    }
}

export interface IDashboardUnknownMessagesListItemDto {
    communicationPartnerDescription?: string | undefined;
    numberOfMessages?: number;
}

export class DateFilterDto implements IDateFilterDto {
    period?: number | undefined;
    from?: Date | undefined;
    to?: Date | undefined;

    constructor(data?: IDateFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.period = _data["period"];
            this.from = _data["from"] ? new Date(_data["from"].toString()) : <any>undefined;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DateFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new DateFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["period"] = this.period;
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        return data;
    }
}

export interface IDateFilterDto {
    period?: number | undefined;
    from?: Date | undefined;
    to?: Date | undefined;
}

export class DatePeriodDto implements IDatePeriodDto {
    label?: string | undefined;
    value?: number;

    constructor(data?: IDatePeriodDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): DatePeriodDto {
        data = typeof data === 'object' ? data : {};
        let result = new DatePeriodDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["value"] = this.value;
        return data;
    }
}

export interface IDatePeriodDto {
    label?: string | undefined;
    value?: number;
}

export class ErrorInfo implements IErrorInfo {
    errorDetail?: string | undefined;
    count?: number;

    constructor(data?: IErrorInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.errorDetail = _data["errorDetail"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): ErrorInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorDetail"] = this.errorDetail;
        data["count"] = this.count;
        return data;
    }
}

export interface IErrorInfo {
    errorDetail?: string | undefined;
    count?: number;
}

export class FilterDto implements IFilterDto {
    dateFilterDto?: DateFilterDto | undefined;
    senderCodes?: string[] | undefined;
    receiverCodes?: string[] | undefined;
    directions?: string[] | undefined;
    messageTypeCodes?: string[] | undefined;
    messageTypeSpecifications?: string[] | undefined;
    messageStatusCodes?: string[] | undefined;
    messageIdentifier?: string;
    externalProtocolCodes?: string[] | undefined;
    tradingPartnerCodes?: string[] | undefined;
    communicationPartnerCodes?: string[] | undefined;
    externalReference?: string | undefined;
    tenantCodes?: string[] | undefined;
    freeText?: string | undefined;
    removeUnknownMessage?: boolean;
    removeReprocessedMessage?: boolean;
    excludeReprocessedMessages?: boolean;

    constructor(data?: IFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateFilterDto = _data["dateFilterDto"] ? DateFilterDto.fromJS(_data["dateFilterDto"]) : <any>undefined;
            if (Array.isArray(_data["senderCodes"])) {
                this.senderCodes = [] as any;
                for (let item of _data["senderCodes"])
                    this.senderCodes!.push(item);
            }
            if (Array.isArray(_data["receiverCodes"])) {
                this.receiverCodes = [] as any;
                for (let item of _data["receiverCodes"])
                    this.receiverCodes!.push(item);
            }
            if (Array.isArray(_data["directions"])) {
                this.directions = [] as any;
                for (let item of _data["directions"])
                    this.directions!.push(item);
            }
            if (Array.isArray(_data["messageTypeCodes"])) {
                this.messageTypeCodes = [] as any;
                for (let item of _data["messageTypeCodes"])
                    this.messageTypeCodes!.push(item);
            }
            if (Array.isArray(_data["messageTypeSpecifications"])) {
                this.messageTypeSpecifications = [] as any;
                for (let item of _data["messageTypeSpecifications"])
                    this.messageTypeSpecifications!.push(item);
            }
            if (Array.isArray(_data["messageStatusCodes"])) {
                this.messageStatusCodes = [] as any;
                for (let item of _data["messageStatusCodes"])
                    this.messageStatusCodes!.push(item);
            }
            this.messageIdentifier = _data["messageIdentifier"];
            if (Array.isArray(_data["externalProtocolCodes"])) {
                this.externalProtocolCodes = [] as any;
                for (let item of _data["externalProtocolCodes"])
                    this.externalProtocolCodes!.push(item);
            }
            if (Array.isArray(_data["tradingPartnerCodes"])) {
                this.tradingPartnerCodes = [] as any;
                for (let item of _data["tradingPartnerCodes"])
                    this.tradingPartnerCodes!.push(item);
            }
            if (Array.isArray(_data["communicationPartnerCodes"])) {
                this.communicationPartnerCodes = [] as any;
                for (let item of _data["communicationPartnerCodes"])
                    this.communicationPartnerCodes!.push(item);
            }
            this.externalReference = _data["externalReference"];
            if (Array.isArray(_data["tenantCodes"])) {
                this.tenantCodes = [] as any;
                for (let item of _data["tenantCodes"])
                    this.tenantCodes!.push(item);
            }
            this.freeText = _data["freeText"];
            this.removeUnknownMessage = _data["removeUnknownMessage"];
            this.removeReprocessedMessage = _data["removeReprocessedMessage"];
            this.excludeReprocessedMessages = _data["excludeReprocessedMessages"];
        }
    }

    static fromJS(data: any): FilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateFilterDto"] = this.dateFilterDto ? this.dateFilterDto.toJSON() : <any>undefined;
        if (Array.isArray(this.senderCodes)) {
            data["senderCodes"] = [];
            for (let item of this.senderCodes)
                data["senderCodes"].push(item);
        }
        if (Array.isArray(this.receiverCodes)) {
            data["receiverCodes"] = [];
            for (let item of this.receiverCodes)
                data["receiverCodes"].push(item);
        }
        if (Array.isArray(this.directions)) {
            data["directions"] = [];
            for (let item of this.directions)
                data["directions"].push(item);
        }
        if (Array.isArray(this.messageTypeCodes)) {
            data["messageTypeCodes"] = [];
            for (let item of this.messageTypeCodes)
                data["messageTypeCodes"].push(item);
        }
        if (Array.isArray(this.messageTypeSpecifications)) {
            data["messageTypeSpecifications"] = [];
            for (let item of this.messageTypeSpecifications)
                data["messageTypeSpecifications"].push(item);
        }
        if (Array.isArray(this.messageStatusCodes)) {
            data["messageStatusCodes"] = [];
            for (let item of this.messageStatusCodes)
                data["messageStatusCodes"].push(item);
        }
        data["messageIdentifier"] = this.messageIdentifier;
        if (Array.isArray(this.externalProtocolCodes)) {
            data["externalProtocolCodes"] = [];
            for (let item of this.externalProtocolCodes)
                data["externalProtocolCodes"].push(item);
        }
        if (Array.isArray(this.tradingPartnerCodes)) {
            data["tradingPartnerCodes"] = [];
            for (let item of this.tradingPartnerCodes)
                data["tradingPartnerCodes"].push(item);
        }
        if (Array.isArray(this.communicationPartnerCodes)) {
            data["communicationPartnerCodes"] = [];
            for (let item of this.communicationPartnerCodes)
                data["communicationPartnerCodes"].push(item);
        }
        data["externalReference"] = this.externalReference;
        if (Array.isArray(this.tenantCodes)) {
            data["tenantCodes"] = [];
            for (let item of this.tenantCodes)
                data["tenantCodes"].push(item);
        }
        data["freeText"] = this.freeText;
        data["removeUnknownMessage"] = this.removeUnknownMessage;
        data["removeReprocessedMessage"] = this.removeReprocessedMessage;
        data["excludeReprocessedMessages"] = this.excludeReprocessedMessages;
        return data;
    }
}

export interface IFilterDto {
    dateFilterDto?: DateFilterDto | undefined;
    senderCodes?: string[] | undefined;
    receiverCodes?: string[] | undefined;
    directions?: string[] | undefined;
    messageTypeCodes?: string[] | undefined;
    messageTypeSpecifications?: string[] | undefined;
    messageStatusCodes?: string[] | undefined;
    messageIdentifier?: string;
    externalProtocolCodes?: string[] | undefined;
    tradingPartnerCodes?: string[] | undefined;
    communicationPartnerCodes?: string[] | undefined;
    externalReference?: string | undefined;
    tenantCodes?: string[] | undefined;
    freeText?: string | undefined;
    removeUnknownMessage?: boolean;
    removeReprocessedMessage?: boolean;
    excludeReprocessedMessages?: boolean;
}

export class ListDashboardGatewayStatusRequest implements IListDashboardGatewayStatusRequest {
    filterDto?: FilterDto | undefined;

    constructor(data?: IListDashboardGatewayStatusRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filterDto = _data["filterDto"] ? FilterDto.fromJS(_data["filterDto"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ListDashboardGatewayStatusRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ListDashboardGatewayStatusRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filterDto"] = this.filterDto ? this.filterDto.toJSON() : <any>undefined;
        return data;
    }
}

export interface IListDashboardGatewayStatusRequest {
    filterDto?: FilterDto | undefined;
}

export class ListDashboardGatewayStatusResponse implements IListDashboardGatewayStatusResponse {
    dashboardGatewayStatusListItemDtos?: DashboardGatewayStatusListItemDto[] | undefined;

    constructor(data?: IListDashboardGatewayStatusResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["dashboardGatewayStatusListItemDtos"])) {
                this.dashboardGatewayStatusListItemDtos = [] as any;
                for (let item of _data["dashboardGatewayStatusListItemDtos"])
                    this.dashboardGatewayStatusListItemDtos!.push(DashboardGatewayStatusListItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListDashboardGatewayStatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ListDashboardGatewayStatusResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.dashboardGatewayStatusListItemDtos)) {
            data["dashboardGatewayStatusListItemDtos"] = [];
            for (let item of this.dashboardGatewayStatusListItemDtos)
                data["dashboardGatewayStatusListItemDtos"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListDashboardGatewayStatusResponse {
    dashboardGatewayStatusListItemDtos?: DashboardGatewayStatusListItemDto[] | undefined;
}

export class ListDashboardMessagesFailStatusResponse implements IListDashboardMessagesFailStatusResponse {
    dashboardMessageFailStatusDetailListItemDtos?: DashboardMessageFailStatusDetailListItemDto[] | undefined;
    dashboardMessageFailStatusListItemDtos?: DashboardMessageFailStatusListItemDto[] | undefined;

    constructor(data?: IListDashboardMessagesFailStatusResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["dashboardMessageFailStatusDetailListItemDtos"])) {
                this.dashboardMessageFailStatusDetailListItemDtos = [] as any;
                for (let item of _data["dashboardMessageFailStatusDetailListItemDtos"])
                    this.dashboardMessageFailStatusDetailListItemDtos!.push(DashboardMessageFailStatusDetailListItemDto.fromJS(item));
            }
            if (Array.isArray(_data["dashboardMessageFailStatusListItemDtos"])) {
                this.dashboardMessageFailStatusListItemDtos = [] as any;
                for (let item of _data["dashboardMessageFailStatusListItemDtos"])
                    this.dashboardMessageFailStatusListItemDtos!.push(DashboardMessageFailStatusListItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListDashboardMessagesFailStatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ListDashboardMessagesFailStatusResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.dashboardMessageFailStatusDetailListItemDtos)) {
            data["dashboardMessageFailStatusDetailListItemDtos"] = [];
            for (let item of this.dashboardMessageFailStatusDetailListItemDtos)
                data["dashboardMessageFailStatusDetailListItemDtos"].push(item.toJSON());
        }
        if (Array.isArray(this.dashboardMessageFailStatusListItemDtos)) {
            data["dashboardMessageFailStatusListItemDtos"] = [];
            for (let item of this.dashboardMessageFailStatusListItemDtos)
                data["dashboardMessageFailStatusListItemDtos"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListDashboardMessagesFailStatusResponse {
    dashboardMessageFailStatusDetailListItemDtos?: DashboardMessageFailStatusDetailListItemDto[] | undefined;
    dashboardMessageFailStatusListItemDtos?: DashboardMessageFailStatusListItemDto[] | undefined;
}

export class ListDashboardMessagesStatusRequest implements IListDashboardMessagesStatusRequest {
    filterDto?: FilterDto | undefined;

    constructor(data?: IListDashboardMessagesStatusRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filterDto = _data["filterDto"] ? FilterDto.fromJS(_data["filterDto"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ListDashboardMessagesStatusRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ListDashboardMessagesStatusRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filterDto"] = this.filterDto ? this.filterDto.toJSON() : <any>undefined;
        return data;
    }
}

export interface IListDashboardMessagesStatusRequest {
    filterDto?: FilterDto | undefined;
}

export class ListDashboardUnknownMessagesRequest implements IListDashboardUnknownMessagesRequest {
    filterDto?: FilterDto | undefined;

    constructor(data?: IListDashboardUnknownMessagesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filterDto = _data["filterDto"] ? FilterDto.fromJS(_data["filterDto"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ListDashboardUnknownMessagesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ListDashboardUnknownMessagesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filterDto"] = this.filterDto ? this.filterDto.toJSON() : <any>undefined;
        return data;
    }
}

export interface IListDashboardUnknownMessagesRequest {
    filterDto?: FilterDto | undefined;
}

export class ListDashboardUnknownMessagesResponse implements IListDashboardUnknownMessagesResponse {
    dashboardUnknownMessagesListItemDtos?: DashboardUnknownMessagesListItemDto[] | undefined;

    constructor(data?: IListDashboardUnknownMessagesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["dashboardUnknownMessagesListItemDtos"])) {
                this.dashboardUnknownMessagesListItemDtos = [] as any;
                for (let item of _data["dashboardUnknownMessagesListItemDtos"])
                    this.dashboardUnknownMessagesListItemDtos!.push(DashboardUnknownMessagesListItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListDashboardUnknownMessagesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ListDashboardUnknownMessagesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.dashboardUnknownMessagesListItemDtos)) {
            data["dashboardUnknownMessagesListItemDtos"] = [];
            for (let item of this.dashboardUnknownMessagesListItemDtos)
                data["dashboardUnknownMessagesListItemDtos"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListDashboardUnknownMessagesResponse {
    dashboardUnknownMessagesListItemDtos?: DashboardUnknownMessagesListItemDto[] | undefined;
}

export class ListMessagesRequest implements IListMessagesRequest {
    pageDto?: PageDto | undefined;
    sortDto?: SortDto | undefined;
    filterDto?: FilterDto | undefined;

    constructor(data?: IListMessagesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageDto = _data["pageDto"] ? PageDto.fromJS(_data["pageDto"]) : <any>undefined;
            this.sortDto = _data["sortDto"] ? SortDto.fromJS(_data["sortDto"]) : <any>undefined;
            this.filterDto = _data["filterDto"] ? FilterDto.fromJS(_data["filterDto"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ListMessagesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ListMessagesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageDto"] = this.pageDto ? this.pageDto.toJSON() : <any>undefined;
        data["sortDto"] = this.sortDto ? this.sortDto.toJSON() : <any>undefined;
        data["filterDto"] = this.filterDto ? this.filterDto.toJSON() : <any>undefined;
        return data;
    }
}

export interface IListMessagesRequest {
    pageDto?: PageDto | undefined;
    sortDto?: SortDto | undefined;
    filterDto?: FilterDto | undefined;
}

export class ListMessagesResponse implements IListMessagesResponse {
    connectMessageListItemDtos?: ConnectMessageListItemDto[] | undefined;
    totalRecords?: number;

    constructor(data?: IListMessagesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["connectMessageListItemDtos"])) {
                this.connectMessageListItemDtos = [] as any;
                for (let item of _data["connectMessageListItemDtos"])
                    this.connectMessageListItemDtos!.push(ConnectMessageListItemDto.fromJS(item));
            }
            this.totalRecords = _data["totalRecords"];
        }
    }

    static fromJS(data: any): ListMessagesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ListMessagesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.connectMessageListItemDtos)) {
            data["connectMessageListItemDtos"] = [];
            for (let item of this.connectMessageListItemDtos)
                data["connectMessageListItemDtos"].push(item.toJSON());
        }
        data["totalRecords"] = this.totalRecords;
        return data;
    }
}

export interface IListMessagesResponse {
    connectMessageListItemDtos?: ConnectMessageListItemDto[] | undefined;
    totalRecords?: number;
}

export class MessageStatusDto implements IMessageStatusDto {
    id?: string | undefined;
    code?: string | undefined;
    description?: string | undefined;

    constructor(data?: IMessageStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): MessageStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new MessageStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["description"] = this.description;
        return data;
    }
}

export interface IMessageStatusDto {
    id?: string | undefined;
    code?: string | undefined;
    description?: string | undefined;
}

export class PageDto implements IPageDto {
    currentPage?: number;
    pageSize?: number;

    constructor(data?: IPageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPage = _data["currentPage"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): PageDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPage"] = this.currentPage;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IPageDto {
    currentPage?: number;
    pageSize?: number;
}

export enum PeriodCycle {
    Hourly = "Hourly",
    Daily = "Daily",
    Weekly = "Weekly",
    Monthly = "Monthly",
    Yearly = "Yearly",
}

export class SaveAlertConfigurationRequest implements ISaveAlertConfigurationRequest {
    id?: string | undefined;
    numberOfAllowedMessages?: number;
    cycle!: PeriodCycle;
    description?: string | undefined;
    tenantCode!: string;
    activationTimestamp?: Date;
    alertActions?: AlertActionDto[] | undefined;

    constructor(data?: ISaveAlertConfigurationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.numberOfAllowedMessages = _data["numberOfAllowedMessages"];
            this.cycle = _data["cycle"];
            this.description = _data["description"];
            this.tenantCode = _data["tenantCode"];
            this.activationTimestamp = _data["activationTimestamp"] ? new Date(_data["activationTimestamp"].toString()) : <any>undefined;
            if (Array.isArray(_data["alertActions"])) {
                this.alertActions = [] as any;
                for (let item of _data["alertActions"])
                    this.alertActions!.push(AlertActionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SaveAlertConfigurationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveAlertConfigurationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["numberOfAllowedMessages"] = this.numberOfAllowedMessages;
        data["cycle"] = this.cycle;
        data["description"] = this.description;
        data["tenantCode"] = this.tenantCode;
        data["activationTimestamp"] = this.activationTimestamp ? this.activationTimestamp.toISOString() : <any>undefined;
        if (Array.isArray(this.alertActions)) {
            data["alertActions"] = [];
            for (let item of this.alertActions)
                data["alertActions"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISaveAlertConfigurationRequest {
    id?: string | undefined;
    numberOfAllowedMessages?: number;
    cycle: PeriodCycle;
    description?: string | undefined;
    tenantCode: string;
    activationTimestamp?: Date;
    alertActions?: AlertActionDto[] | undefined;
}

export enum SortDirection {
    Ascending = "Ascending",
    Descending = "Descending",
}

export class SortDto implements ISortDto {
    field?: string | undefined;
    sortDirection?: SortDirection;

    constructor(data?: ISortDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.field = _data["field"];
            this.sortDirection = _data["sortDirection"];
        }
    }

    static fromJS(data: any): SortDto {
        data = typeof data === 'object' ? data : {};
        let result = new SortDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["field"] = this.field;
        data["sortDirection"] = this.sortDirection;
        return data;
    }
}

export interface ISortDto {
    field?: string | undefined;
    sortDirection?: SortDirection;
}

export class ReprocessMessageResponse implements IReprocessMessageResponse {

    constructor(data?: IReprocessMessageResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): ReprocessMessageResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ReprocessMessageResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IReprocessMessageResponse {
}

export class ResendMessageResponse implements IResendMessageResponse {

    constructor(data?: IResendMessageResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): ResendMessageResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResendMessageResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IResendMessageResponse {
}

export enum CommunicationProfileFileTransferStatusType {
    Success = "Success",
    Failed = "Failed",
}

export enum Capability {
    Bidirectional = "Bidirectional",
    Sending = "Sending",
    Receiving = "Receiving",
}

export class CheckActiveCommunicationProfilesRequest implements ICheckActiveCommunicationProfilesRequest {
    partnerId?: string | undefined;
    validTo?: Date;
    isCommunicationPartner?: boolean;

    constructor(data?: ICheckActiveCommunicationProfilesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partnerId = _data["partnerId"];
            this.validTo = _data["validTo"] ? new Date(_data["validTo"].toString()) : <any>undefined;
            this.isCommunicationPartner = _data["isCommunicationPartner"];
        }
    }

    static fromJS(data: any): CheckActiveCommunicationProfilesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CheckActiveCommunicationProfilesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partnerId"] = this.partnerId;
        data["validTo"] = this.validTo ? this.validTo.toISOString() : <any>undefined;
        data["isCommunicationPartner"] = this.isCommunicationPartner;
        return data;
    }
}

export interface ICheckActiveCommunicationProfilesRequest {
    partnerId?: string | undefined;
    validTo?: Date;
    isCommunicationPartner?: boolean;
}

export class CheckActiveMessageSettingsRequest implements ICheckActiveMessageSettingsRequest {
    partnerId?: string | undefined;
    validTo?: Date;
    isTradingPartner?: boolean;

    constructor(data?: ICheckActiveMessageSettingsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partnerId = _data["partnerId"];
            this.validTo = _data["validTo"] ? new Date(_data["validTo"].toString()) : <any>undefined;
            this.isTradingPartner = _data["isTradingPartner"];
        }
    }

    static fromJS(data: any): CheckActiveMessageSettingsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CheckActiveMessageSettingsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partnerId"] = this.partnerId;
        data["validTo"] = this.validTo ? this.validTo.toISOString() : <any>undefined;
        data["isTradingPartner"] = this.isTradingPartner;
        return data;
    }
}

export interface ICheckActiveMessageSettingsRequest {
    partnerId?: string | undefined;
    validTo?: Date;
    isTradingPartner?: boolean;
}

export class CodeTranslationDto implements ICodeTranslationDto {
    entityTypeId?: string | undefined;
    tenantId?: string | undefined;
    displayName?: string | undefined;
    internalCode?: string | undefined;
    externalCode?: string | undefined;
    codingType?: string | undefined;
    isDeleted?: boolean;
    id?: string | undefined;

    constructor(data?: ICodeTranslationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityTypeId = _data["entityTypeId"];
            this.tenantId = _data["tenantId"];
            this.displayName = _data["displayName"];
            this.internalCode = _data["internalCode"];
            this.externalCode = _data["externalCode"];
            this.codingType = _data["codingType"];
            this.isDeleted = _data["isDeleted"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CodeTranslationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CodeTranslationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityTypeId"] = this.entityTypeId;
        data["tenantId"] = this.tenantId;
        data["displayName"] = this.displayName;
        data["internalCode"] = this.internalCode;
        data["externalCode"] = this.externalCode;
        data["codingType"] = this.codingType;
        data["isDeleted"] = this.isDeleted;
        data["id"] = this.id;
        return data;
    }
}

export interface ICodeTranslationDto {
    entityTypeId?: string | undefined;
    tenantId?: string | undefined;
    displayName?: string | undefined;
    internalCode?: string | undefined;
    externalCode?: string | undefined;
    codingType?: string | undefined;
    isDeleted?: boolean;
    id?: string | undefined;
}

export class CommunicationProfileDto implements ICommunicationProfileDto {
    name?: string | undefined;
    retryStrategyId?: string | undefined;
    capability?: Capability;
    backupCommunicationProfileId?: string | undefined;
    communicationPartnerId?: string | undefined;
    communicationPartnerConnectCode?: string | undefined;
    validationDates?: ValidityDatesDto2 | undefined;
    communicationProtocolCode?: string | undefined;
    id?: string | undefined;
    implementationParameters?: ImplementationParameterDto[] | undefined;
    queueName?: string | undefined;
    messageEnvelope?: string | undefined;
    transportType?: string | undefined;
    deliveryUri?: string | undefined;
    userName?: string | undefined;
    password?: string | undefined;
    signatureAlgorithm?: SignatureAlgorithm | undefined;
    encryptionAlgorithm?: EncryptionAlgorithm | undefined;
    mgf1HashAlgorithm?: HashAlgorithm | undefined;
    rsaHashAlgorithm?: HashAlgorithm | undefined;
    secretFunctionalities?: SecretFunctionalityDto[] | undefined;
    partnerAs2Reference?: string | undefined;
    selfAs2Reference?: string | undefined;
    mdnRequired?: boolean;
    specifyActualContentType?: boolean;
    useFilename?: boolean;
    forceSendBinaryContentTransferEncoding?: boolean;
    sendCompressedPayload?: boolean;
    useOAEP?: boolean;
    deliveryFolder?: string | undefined;
    deliveryUploadFolder?: string | undefined;
    receiptFolder?: string | undefined;
    receiptArchiveFolder?: string | undefined;
    port?: number;
    sslMode?: SslMode;
    isPassive?: boolean;
    prependFolderName?: boolean;
    enablePolling?: boolean;
    enablePollingHistoryFilter?: boolean;
    pollingInterval?: number | undefined;
    isReliable?: boolean;
    implementationType?: SoapImplementationType;
    clientCredentialType?: SoapClientCredentialType;
    securityModeType?: SoapSecurityModeType;
    applicationId?: string | undefined;
    libraryId?: string | undefined;
    destinationLocation?: string | undefined;
    authorityUrl?: string | undefined;
    hostUri?: string | undefined;
    restProtocolAuthorization?: RestProtocolAuthorization;
    oAuthConfigurationDto?: OAuthConfigurationDto | undefined;
    staticHeader?: string | undefined;

    constructor(data?: ICommunicationProfileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.retryStrategyId = _data["retryStrategyId"];
            this.capability = _data["capability"];
            this.backupCommunicationProfileId = _data["backupCommunicationProfileId"];
            this.communicationPartnerId = _data["communicationPartnerId"];
            this.communicationPartnerConnectCode = _data["communicationPartnerConnectCode"];
            this.validationDates = _data["validationDates"] ? ValidityDatesDto2.fromJS(_data["validationDates"]) : <any>undefined;
            this.communicationProtocolCode = _data["communicationProtocolCode"];
            this.id = _data["id"];
            if (Array.isArray(_data["implementationParameters"])) {
                this.implementationParameters = [] as any;
                for (let item of _data["implementationParameters"])
                    this.implementationParameters!.push(ImplementationParameterDto.fromJS(item));
            }
            this.queueName = _data["queueName"];
            this.messageEnvelope = _data["messageEnvelope"];
            this.transportType = _data["transportType"];
            this.deliveryUri = _data["deliveryUri"];
            this.userName = _data["userName"];
            this.password = _data["password"];
            this.signatureAlgorithm = _data["signatureAlgorithm"];
            this.encryptionAlgorithm = _data["encryptionAlgorithm"];
            this.mgf1HashAlgorithm = _data["mgf1HashAlgorithm"];
            this.rsaHashAlgorithm = _data["rsaHashAlgorithm"];
            if (Array.isArray(_data["secretFunctionalities"])) {
                this.secretFunctionalities = [] as any;
                for (let item of _data["secretFunctionalities"])
                    this.secretFunctionalities!.push(SecretFunctionalityDto.fromJS(item));
            }
            this.partnerAs2Reference = _data["partnerAs2Reference"];
            this.selfAs2Reference = _data["selfAs2Reference"];
            this.mdnRequired = _data["mdnRequired"];
            this.specifyActualContentType = _data["specifyActualContentType"];
            this.useFilename = _data["useFilename"];
            this.forceSendBinaryContentTransferEncoding = _data["forceSendBinaryContentTransferEncoding"];
            this.sendCompressedPayload = _data["sendCompressedPayload"];
            this.useOAEP = _data["useOAEP"];
            this.deliveryFolder = _data["deliveryFolder"];
            this.deliveryUploadFolder = _data["deliveryUploadFolder"];
            this.receiptFolder = _data["receiptFolder"];
            this.receiptArchiveFolder = _data["receiptArchiveFolder"];
            this.port = _data["port"];
            this.sslMode = _data["sslMode"];
            this.isPassive = _data["isPassive"];
            this.prependFolderName = _data["prependFolderName"];
            this.enablePolling = _data["enablePolling"];
            this.enablePollingHistoryFilter = _data["enablePollingHistoryFilter"];
            this.pollingInterval = _data["pollingInterval"];
            this.isReliable = _data["isReliable"];
            this.implementationType = _data["implementationType"];
            this.clientCredentialType = _data["clientCredentialType"];
            this.securityModeType = _data["securityModeType"];
            this.applicationId = _data["applicationId"];
            this.libraryId = _data["libraryId"];
            this.destinationLocation = _data["destinationLocation"];
            this.authorityUrl = _data["authorityUrl"];
            this.hostUri = _data["hostUri"];
            this.restProtocolAuthorization = _data["restProtocolAuthorization"];
            this.oAuthConfigurationDto = _data["oAuthConfigurationDto"] ? OAuthConfigurationDto.fromJS(_data["oAuthConfigurationDto"]) : <any>undefined;
            this.staticHeader = _data["staticHeader"];
        }
    }

    static fromJS(data: any): CommunicationProfileDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommunicationProfileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["retryStrategyId"] = this.retryStrategyId;
        data["capability"] = this.capability;
        data["backupCommunicationProfileId"] = this.backupCommunicationProfileId;
        data["communicationPartnerId"] = this.communicationPartnerId;
        data["communicationPartnerConnectCode"] = this.communicationPartnerConnectCode;
        data["validationDates"] = this.validationDates ? this.validationDates.toJSON() : <any>undefined;
        data["communicationProtocolCode"] = this.communicationProtocolCode;
        data["id"] = this.id;
        if (Array.isArray(this.implementationParameters)) {
            data["implementationParameters"] = [];
            for (let item of this.implementationParameters)
                data["implementationParameters"].push(item.toJSON());
        }
        data["queueName"] = this.queueName;
        data["messageEnvelope"] = this.messageEnvelope;
        data["transportType"] = this.transportType;
        data["deliveryUri"] = this.deliveryUri;
        data["userName"] = this.userName;
        data["password"] = this.password;
        data["signatureAlgorithm"] = this.signatureAlgorithm;
        data["encryptionAlgorithm"] = this.encryptionAlgorithm;
        data["mgf1HashAlgorithm"] = this.mgf1HashAlgorithm;
        data["rsaHashAlgorithm"] = this.rsaHashAlgorithm;
        if (Array.isArray(this.secretFunctionalities)) {
            data["secretFunctionalities"] = [];
            for (let item of this.secretFunctionalities)
                data["secretFunctionalities"].push(item.toJSON());
        }
        data["partnerAs2Reference"] = this.partnerAs2Reference;
        data["selfAs2Reference"] = this.selfAs2Reference;
        data["mdnRequired"] = this.mdnRequired;
        data["specifyActualContentType"] = this.specifyActualContentType;
        data["useFilename"] = this.useFilename;
        data["forceSendBinaryContentTransferEncoding"] = this.forceSendBinaryContentTransferEncoding;
        data["sendCompressedPayload"] = this.sendCompressedPayload;
        data["useOAEP"] = this.useOAEP;
        data["deliveryFolder"] = this.deliveryFolder;
        data["deliveryUploadFolder"] = this.deliveryUploadFolder;
        data["receiptFolder"] = this.receiptFolder;
        data["receiptArchiveFolder"] = this.receiptArchiveFolder;
        data["port"] = this.port;
        data["sslMode"] = this.sslMode;
        data["isPassive"] = this.isPassive;
        data["prependFolderName"] = this.prependFolderName;
        data["enablePolling"] = this.enablePolling;
        data["enablePollingHistoryFilter"] = this.enablePollingHistoryFilter;
        data["pollingInterval"] = this.pollingInterval;
        data["isReliable"] = this.isReliable;
        data["implementationType"] = this.implementationType;
        data["clientCredentialType"] = this.clientCredentialType;
        data["securityModeType"] = this.securityModeType;
        data["applicationId"] = this.applicationId;
        data["libraryId"] = this.libraryId;
        data["destinationLocation"] = this.destinationLocation;
        data["authorityUrl"] = this.authorityUrl;
        data["hostUri"] = this.hostUri;
        data["restProtocolAuthorization"] = this.restProtocolAuthorization;
        data["oAuthConfigurationDto"] = this.oAuthConfigurationDto ? this.oAuthConfigurationDto.toJSON() : <any>undefined;
        data["staticHeader"] = this.staticHeader;
        return data;
    }
}

export interface ICommunicationProfileDto {
    name?: string | undefined;
    retryStrategyId?: string | undefined;
    capability?: Capability;
    backupCommunicationProfileId?: string | undefined;
    communicationPartnerId?: string | undefined;
    communicationPartnerConnectCode?: string | undefined;
    validationDates?: ValidityDatesDto2 | undefined;
    communicationProtocolCode?: string | undefined;
    id?: string | undefined;
    implementationParameters?: ImplementationParameterDto[] | undefined;
    queueName?: string | undefined;
    messageEnvelope?: string | undefined;
    transportType?: string | undefined;
    deliveryUri?: string | undefined;
    userName?: string | undefined;
    password?: string | undefined;
    signatureAlgorithm?: SignatureAlgorithm | undefined;
    encryptionAlgorithm?: EncryptionAlgorithm | undefined;
    mgf1HashAlgorithm?: HashAlgorithm | undefined;
    rsaHashAlgorithm?: HashAlgorithm | undefined;
    secretFunctionalities?: SecretFunctionalityDto[] | undefined;
    partnerAs2Reference?: string | undefined;
    selfAs2Reference?: string | undefined;
    mdnRequired?: boolean;
    specifyActualContentType?: boolean;
    useFilename?: boolean;
    forceSendBinaryContentTransferEncoding?: boolean;
    sendCompressedPayload?: boolean;
    useOAEP?: boolean;
    deliveryFolder?: string | undefined;
    deliveryUploadFolder?: string | undefined;
    receiptFolder?: string | undefined;
    receiptArchiveFolder?: string | undefined;
    port?: number;
    sslMode?: SslMode;
    isPassive?: boolean;
    prependFolderName?: boolean;
    enablePolling?: boolean;
    enablePollingHistoryFilter?: boolean;
    pollingInterval?: number | undefined;
    isReliable?: boolean;
    implementationType?: SoapImplementationType;
    clientCredentialType?: SoapClientCredentialType;
    securityModeType?: SoapSecurityModeType;
    applicationId?: string | undefined;
    libraryId?: string | undefined;
    destinationLocation?: string | undefined;
    authorityUrl?: string | undefined;
    hostUri?: string | undefined;
    restProtocolAuthorization?: RestProtocolAuthorization;
    oAuthConfigurationDto?: OAuthConfigurationDto | undefined;
    staticHeader?: string | undefined;
}

export class CommunicationProfileListItemDto implements ICommunicationProfileListItemDto {
    name?: string | undefined;
    validityDates?: ValidityDatesDto2 | undefined;
    capability?: Capability;
    communicationProtocolCode?: string | undefined;
    isActive?: boolean;
    communicationPartnerId?: string | undefined;
    communicationPartnerName?: string | undefined;
    communicationPartnerConnectCode?: string | undefined;
    id?: string | undefined;
    processingModeDtos?: ProcessingModeDto2[] | undefined;

    constructor(data?: ICommunicationProfileListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.validityDates = _data["validityDates"] ? ValidityDatesDto2.fromJS(_data["validityDates"]) : <any>undefined;
            this.capability = _data["capability"];
            this.communicationProtocolCode = _data["communicationProtocolCode"];
            this.isActive = _data["isActive"];
            this.communicationPartnerId = _data["communicationPartnerId"];
            this.communicationPartnerName = _data["communicationPartnerName"];
            this.communicationPartnerConnectCode = _data["communicationPartnerConnectCode"];
            this.id = _data["id"];
            if (Array.isArray(_data["processingModeDtos"])) {
                this.processingModeDtos = [] as any;
                for (let item of _data["processingModeDtos"])
                    this.processingModeDtos!.push(ProcessingModeDto2.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CommunicationProfileListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommunicationProfileListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["validityDates"] = this.validityDates ? this.validityDates.toJSON() : <any>undefined;
        data["capability"] = this.capability;
        data["communicationProtocolCode"] = this.communicationProtocolCode;
        data["isActive"] = this.isActive;
        data["communicationPartnerId"] = this.communicationPartnerId;
        data["communicationPartnerName"] = this.communicationPartnerName;
        data["communicationPartnerConnectCode"] = this.communicationPartnerConnectCode;
        data["id"] = this.id;
        if (Array.isArray(this.processingModeDtos)) {
            data["processingModeDtos"] = [];
            for (let item of this.processingModeDtos)
                data["processingModeDtos"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICommunicationProfileListItemDto {
    name?: string | undefined;
    validityDates?: ValidityDatesDto2 | undefined;
    capability?: Capability;
    communicationProtocolCode?: string | undefined;
    isActive?: boolean;
    communicationPartnerId?: string | undefined;
    communicationPartnerName?: string | undefined;
    communicationPartnerConnectCode?: string | undefined;
    id?: string | undefined;
    processingModeDtos?: ProcessingModeDto2[] | undefined;
}

export class CommunicationProtocolDto implements ICommunicationProtocolDto {
    code?: string | undefined;
    id?: string | undefined;

    constructor(data?: ICommunicationProtocolDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CommunicationProtocolDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommunicationProtocolDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["id"] = this.id;
        return data;
    }
}

export interface ICommunicationProtocolDto {
    code?: string | undefined;
    id?: string | undefined;
}

export class DeleteSecretRequest implements IDeleteSecretRequest {
    id?: string | undefined;

    constructor(data?: IDeleteSecretRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DeleteSecretRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteSecretRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IDeleteSecretRequest {
    id?: string | undefined;
}

export enum EncryptionAlgorithm {
    ThreeDES = "ThreeDES",
    AES128GCM = "AES128GCM",
    AES256GCM = "AES256GCM",
    AESCBC128 = "AESCBC128",
    AESCBC192 = "AESCBC192",
    AESCBC256 = "AESCBC256",
    DES = "DES",
}

export class GetCommunicationProfileRequest implements IGetCommunicationProfileRequest {
    id?: string | undefined;

    constructor(data?: IGetCommunicationProfileRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetCommunicationProfileRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetCommunicationProfileRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IGetCommunicationProfileRequest {
    id?: string | undefined;
}

export class GetCommunicationProfileResponse implements IGetCommunicationProfileResponse {
    communicationProfileDto?: CommunicationProfileDto | undefined;

    constructor(data?: IGetCommunicationProfileResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.communicationProfileDto = _data["communicationProfileDto"] ? CommunicationProfileDto.fromJS(_data["communicationProfileDto"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCommunicationProfileResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCommunicationProfileResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["communicationProfileDto"] = this.communicationProfileDto ? this.communicationProfileDto.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetCommunicationProfileResponse {
    communicationProfileDto?: CommunicationProfileDto | undefined;
}

export class GetMessageSettingDetailRequest implements IGetMessageSettingDetailRequest {
    id?: string | undefined;

    constructor(data?: IGetMessageSettingDetailRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetMessageSettingDetailRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetMessageSettingDetailRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IGetMessageSettingDetailRequest {
    id?: string | undefined;
}

export class GetMessageSettingDetailResponse implements IGetMessageSettingDetailResponse {
    messageSettingDto?: MessageSettingDto | undefined;

    constructor(data?: IGetMessageSettingDetailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messageSettingDto = _data["messageSettingDto"] ? MessageSettingDto.fromJS(_data["messageSettingDto"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetMessageSettingDetailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMessageSettingDetailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messageSettingDto"] = this.messageSettingDto ? this.messageSettingDto.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetMessageSettingDetailResponse {
    messageSettingDto?: MessageSettingDto | undefined;
}

export class GetPartnerDetailRequest implements IGetPartnerDetailRequest {
    id?: string | undefined;
    partnerConnectCode?: string | undefined;
    tenantsFilter?: string[] | undefined;

    constructor(data?: IGetPartnerDetailRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.partnerConnectCode = _data["partnerConnectCode"];
            if (Array.isArray(_data["tenantsFilter"])) {
                this.tenantsFilter = [] as any;
                for (let item of _data["tenantsFilter"])
                    this.tenantsFilter!.push(item);
            }
        }
    }

    static fromJS(data: any): GetPartnerDetailRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetPartnerDetailRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["partnerConnectCode"] = this.partnerConnectCode;
        if (Array.isArray(this.tenantsFilter)) {
            data["tenantsFilter"] = [];
            for (let item of this.tenantsFilter)
                data["tenantsFilter"].push(item);
        }
        return data;
    }
}

export interface IGetPartnerDetailRequest {
    id?: string | undefined;
    partnerConnectCode?: string | undefined;
    tenantsFilter?: string[] | undefined;
}

export class GetSecretResponse implements IGetSecretResponse {
    secretDto?: SecretDto | undefined;

    constructor(data?: IGetSecretResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.secretDto = _data["secretDto"] ? SecretDto.fromJS(_data["secretDto"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetSecretResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSecretResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["secretDto"] = this.secretDto ? this.secretDto.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSecretResponse {
    secretDto?: SecretDto | undefined;
}

export enum HashAlgorithm {
    Sha1 = "Sha1",
    Sha224 = "Sha224",
    Sha256 = "Sha256",
    Sha384 = "Sha384",
    Sha512 = "Sha512",
}

export class ImplementationParameterDto implements IImplementationParameterDto {
    id!: string;
    value?: string | undefined;
    type!: string;

    constructor(data?: IImplementationParameterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.value = _data["value"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): ImplementationParameterDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImplementationParameterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["value"] = this.value;
        data["type"] = this.type;
        return data;
    }
}

export interface IImplementationParameterDto {
    id: string;
    value?: string | undefined;
    type: string;
}

export class ListCodeTranslationsRequest implements IListCodeTranslationsRequest {
    entityTypeId?: string | undefined;
    tenantCodes?: string[] | undefined;

    constructor(data?: IListCodeTranslationsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityTypeId = _data["entityTypeId"];
            if (Array.isArray(_data["tenantCodes"])) {
                this.tenantCodes = [] as any;
                for (let item of _data["tenantCodes"])
                    this.tenantCodes!.push(item);
            }
        }
    }

    static fromJS(data: any): ListCodeTranslationsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ListCodeTranslationsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityTypeId"] = this.entityTypeId;
        if (Array.isArray(this.tenantCodes)) {
            data["tenantCodes"] = [];
            for (let item of this.tenantCodes)
                data["tenantCodes"].push(item);
        }
        return data;
    }
}

export interface IListCodeTranslationsRequest {
    entityTypeId?: string | undefined;
    tenantCodes?: string[] | undefined;
}

export class ListCodeTranslationsResponse implements IListCodeTranslationsResponse {
    codeTranslationDtos?: CodeTranslationDto[] | undefined;

    constructor(data?: IListCodeTranslationsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["codeTranslationDtos"])) {
                this.codeTranslationDtos = [] as any;
                for (let item of _data["codeTranslationDtos"])
                    this.codeTranslationDtos!.push(CodeTranslationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListCodeTranslationsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ListCodeTranslationsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.codeTranslationDtos)) {
            data["codeTranslationDtos"] = [];
            for (let item of this.codeTranslationDtos)
                data["codeTranslationDtos"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListCodeTranslationsResponse {
    codeTranslationDtos?: CodeTranslationDto[] | undefined;
}

export class ListCommunicationProfileResponse implements IListCommunicationProfileResponse {
    communicationProfileListItemDtos?: CommunicationProfileListItemDto[] | undefined;

    constructor(data?: IListCommunicationProfileResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["communicationProfileListItemDtos"])) {
                this.communicationProfileListItemDtos = [] as any;
                for (let item of _data["communicationProfileListItemDtos"])
                    this.communicationProfileListItemDtos!.push(CommunicationProfileListItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListCommunicationProfileResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ListCommunicationProfileResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.communicationProfileListItemDtos)) {
            data["communicationProfileListItemDtos"] = [];
            for (let item of this.communicationProfileListItemDtos)
                data["communicationProfileListItemDtos"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListCommunicationProfileResponse {
    communicationProfileListItemDtos?: CommunicationProfileListItemDto[] | undefined;
}

export class ListExpiringSecretsResponse implements IListExpiringSecretsResponse {
    expired?: SecretExpirationListItemDto[] | undefined;
    expiringIn3Days?: SecretExpirationListItemDto[] | undefined;
    expiringIn14Days?: SecretExpirationListItemDto[] | undefined;

    constructor(data?: IListExpiringSecretsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["expired"])) {
                this.expired = [] as any;
                for (let item of _data["expired"])
                    this.expired!.push(SecretExpirationListItemDto.fromJS(item));
            }
            if (Array.isArray(_data["expiringIn3Days"])) {
                this.expiringIn3Days = [] as any;
                for (let item of _data["expiringIn3Days"])
                    this.expiringIn3Days!.push(SecretExpirationListItemDto.fromJS(item));
            }
            if (Array.isArray(_data["expiringIn14Days"])) {
                this.expiringIn14Days = [] as any;
                for (let item of _data["expiringIn14Days"])
                    this.expiringIn14Days!.push(SecretExpirationListItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListExpiringSecretsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ListExpiringSecretsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.expired)) {
            data["expired"] = [];
            for (let item of this.expired)
                data["expired"].push(item.toJSON());
        }
        if (Array.isArray(this.expiringIn3Days)) {
            data["expiringIn3Days"] = [];
            for (let item of this.expiringIn3Days)
                data["expiringIn3Days"].push(item.toJSON());
        }
        if (Array.isArray(this.expiringIn14Days)) {
            data["expiringIn14Days"] = [];
            for (let item of this.expiringIn14Days)
                data["expiringIn14Days"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListExpiringSecretsResponse {
    expired?: SecretExpirationListItemDto[] | undefined;
    expiringIn3Days?: SecretExpirationListItemDto[] | undefined;
    expiringIn14Days?: SecretExpirationListItemDto[] | undefined;
}

export class ListMessageIdentificationSettingsRequest implements IListMessageIdentificationSettingsRequest {
    messageTypeCode?: string | undefined;

    constructor(data?: IListMessageIdentificationSettingsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messageTypeCode = _data["messageTypeCode"];
        }
    }

    static fromJS(data: any): ListMessageIdentificationSettingsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ListMessageIdentificationSettingsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messageTypeCode"] = this.messageTypeCode;
        return data;
    }
}

export interface IListMessageIdentificationSettingsRequest {
    messageTypeCode?: string | undefined;
}

export class ListMessageIdentificationSettingsResponse implements IListMessageIdentificationSettingsResponse {
    messageIdentificationSettingDtos?: MessageIdentificationSettingDto[] | undefined;

    constructor(data?: IListMessageIdentificationSettingsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messageIdentificationSettingDtos"])) {
                this.messageIdentificationSettingDtos = [] as any;
                for (let item of _data["messageIdentificationSettingDtos"])
                    this.messageIdentificationSettingDtos!.push(MessageIdentificationSettingDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListMessageIdentificationSettingsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ListMessageIdentificationSettingsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messageIdentificationSettingDtos)) {
            data["messageIdentificationSettingDtos"] = [];
            for (let item of this.messageIdentificationSettingDtos)
                data["messageIdentificationSettingDtos"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListMessageIdentificationSettingsResponse {
    messageIdentificationSettingDtos?: MessageIdentificationSettingDto[] | undefined;
}

export class ListMessageSettingsResponse implements IListMessageSettingsResponse {
    messageSettingListItemDtos?: MessageSettingListItemDto[] | undefined;

    constructor(data?: IListMessageSettingsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messageSettingListItemDtos"])) {
                this.messageSettingListItemDtos = [] as any;
                for (let item of _data["messageSettingListItemDtos"])
                    this.messageSettingListItemDtos!.push(MessageSettingListItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListMessageSettingsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ListMessageSettingsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messageSettingListItemDtos)) {
            data["messageSettingListItemDtos"] = [];
            for (let item of this.messageSettingListItemDtos)
                data["messageSettingListItemDtos"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListMessageSettingsResponse {
    messageSettingListItemDtos?: MessageSettingListItemDto[] | undefined;
}

export class ListPartnerCodeTranslationsResponse implements IListPartnerCodeTranslationsResponse {
    partnerCodeTranslationDtos?: PartnerCodeTranslationDto[] | undefined;

    constructor(data?: IListPartnerCodeTranslationsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["partnerCodeTranslationDtos"])) {
                this.partnerCodeTranslationDtos = [] as any;
                for (let item of _data["partnerCodeTranslationDtos"])
                    this.partnerCodeTranslationDtos!.push(PartnerCodeTranslationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListPartnerCodeTranslationsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ListPartnerCodeTranslationsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.partnerCodeTranslationDtos)) {
            data["partnerCodeTranslationDtos"] = [];
            for (let item of this.partnerCodeTranslationDtos)
                data["partnerCodeTranslationDtos"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListPartnerCodeTranslationsResponse {
    partnerCodeTranslationDtos?: PartnerCodeTranslationDto[] | undefined;
}

export class ListSecretResponse implements IListSecretResponse {
    secretListItemDtos?: SecretListItemDto[] | undefined;

    constructor(data?: IListSecretResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["secretListItemDtos"])) {
                this.secretListItemDtos = [] as any;
                for (let item of _data["secretListItemDtos"])
                    this.secretListItemDtos!.push(SecretListItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListSecretResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ListSecretResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.secretListItemDtos)) {
            data["secretListItemDtos"] = [];
            for (let item of this.secretListItemDtos)
                data["secretListItemDtos"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListSecretResponse {
    secretListItemDtos?: SecretListItemDto[] | undefined;
}

export class MapExtensionDto implements IMapExtensionDto {
    id!: string;
    value?: string | undefined;
    type!: string;

    constructor(data?: IMapExtensionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.value = _data["value"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): MapExtensionDto {
        data = typeof data === 'object' ? data : {};
        let result = new MapExtensionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["value"] = this.value;
        data["type"] = this.type;
        return data;
    }
}

export interface IMapExtensionDto {
    id: string;
    value?: string | undefined;
    type: string;
}

export class MessageEnvelopeDto implements IMessageEnvelopeDto {
    name?: string | undefined;

    constructor(data?: IMessageEnvelopeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): MessageEnvelopeDto {
        data = typeof data === 'object' ? data : {};
        let result = new MessageEnvelopeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface IMessageEnvelopeDto {
    name?: string | undefined;
}

export class MessageIdentificationSettingDto implements IMessageIdentificationSettingDto {
    id?: string | undefined;
    versionStrategyTypeId?: VersionStrategyType;
    messageIdentificationFormat?: string | undefined;
    messageTypeCodeRegex?: string | undefined;
    senderInternalCodeRegex?: string | undefined;
    receiverInternalCodeRegex?: string | undefined;
    validFrom?: Date;
    validTo?: Date;

    constructor(data?: IMessageIdentificationSettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.versionStrategyTypeId = _data["versionStrategyTypeId"];
            this.messageIdentificationFormat = _data["messageIdentificationFormat"];
            this.messageTypeCodeRegex = _data["messageTypeCodeRegex"];
            this.senderInternalCodeRegex = _data["senderInternalCodeRegex"];
            this.receiverInternalCodeRegex = _data["receiverInternalCodeRegex"];
            this.validFrom = _data["validFrom"] ? new Date(_data["validFrom"].toString()) : <any>undefined;
            this.validTo = _data["validTo"] ? new Date(_data["validTo"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MessageIdentificationSettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new MessageIdentificationSettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["versionStrategyTypeId"] = this.versionStrategyTypeId;
        data["messageIdentificationFormat"] = this.messageIdentificationFormat;
        data["messageTypeCodeRegex"] = this.messageTypeCodeRegex;
        data["senderInternalCodeRegex"] = this.senderInternalCodeRegex;
        data["receiverInternalCodeRegex"] = this.receiverInternalCodeRegex;
        data["validFrom"] = this.validFrom ? this.validFrom.toISOString() : <any>undefined;
        data["validTo"] = this.validTo ? this.validTo.toISOString() : <any>undefined;
        return data;
    }
}

export interface IMessageIdentificationSettingDto {
    id?: string | undefined;
    versionStrategyTypeId?: VersionStrategyType;
    messageIdentificationFormat?: string | undefined;
    messageTypeCodeRegex?: string | undefined;
    senderInternalCodeRegex?: string | undefined;
    receiverInternalCodeRegex?: string | undefined;
    validFrom?: Date;
    validTo?: Date;
}

export class MessageSettingDto implements IMessageSettingDto {
    messageTypeSpecificationId!: string;
    senderPartnerId!: string;
    receiverPartnerId!: string;
    receiverCommunicationProfileId?: string | undefined;
    messageTypeCode!: string;
    direction!: string;
    maximumDelayDelivery?: number;
    requireAcknowledgement?: boolean;
    maximumDelayAcknowledgement?: number | undefined;
    excluded?: boolean;
    validFrom!: Date;
    validTo!: Date;
    senderCodingType!: string;
    receiverCodingType!: string;
    comSenderCodingType!: string;
    comReceiverCodingType!: string;
    internalShipperAccountCodingType!: string;
    externalShipperAccountCodingType!: string;
    connectionPointCodingType!: string;
    messageIdentificationSettingId?: string | undefined;
    id?: string | undefined;
    mapExtensions?: MapExtensionDto[] | undefined;
    processExtensions?: ProcessExtensionDto[] | undefined;
    processingModeId?: string | undefined;

    constructor(data?: IMessageSettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messageTypeSpecificationId = _data["messageTypeSpecificationId"];
            this.senderPartnerId = _data["senderPartnerId"];
            this.receiverPartnerId = _data["receiverPartnerId"];
            this.receiverCommunicationProfileId = _data["receiverCommunicationProfileId"];
            this.messageTypeCode = _data["messageTypeCode"];
            this.direction = _data["direction"];
            this.maximumDelayDelivery = _data["maximumDelayDelivery"];
            this.requireAcknowledgement = _data["requireAcknowledgement"];
            this.maximumDelayAcknowledgement = _data["maximumDelayAcknowledgement"];
            this.excluded = _data["excluded"];
            this.validFrom = _data["validFrom"] ? new Date(_data["validFrom"].toString()) : <any>undefined;
            this.validTo = _data["validTo"] ? new Date(_data["validTo"].toString()) : <any>undefined;
            this.senderCodingType = _data["senderCodingType"];
            this.receiverCodingType = _data["receiverCodingType"];
            this.comSenderCodingType = _data["comSenderCodingType"];
            this.comReceiverCodingType = _data["comReceiverCodingType"];
            this.internalShipperAccountCodingType = _data["internalShipperAccountCodingType"];
            this.externalShipperAccountCodingType = _data["externalShipperAccountCodingType"];
            this.connectionPointCodingType = _data["connectionPointCodingType"];
            this.messageIdentificationSettingId = _data["messageIdentificationSettingId"];
            this.id = _data["id"];
            if (Array.isArray(_data["mapExtensions"])) {
                this.mapExtensions = [] as any;
                for (let item of _data["mapExtensions"])
                    this.mapExtensions!.push(MapExtensionDto.fromJS(item));
            }
            if (Array.isArray(_data["processExtensions"])) {
                this.processExtensions = [] as any;
                for (let item of _data["processExtensions"])
                    this.processExtensions!.push(ProcessExtensionDto.fromJS(item));
            }
            this.processingModeId = _data["processingModeId"];
        }
    }

    static fromJS(data: any): MessageSettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new MessageSettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messageTypeSpecificationId"] = this.messageTypeSpecificationId;
        data["senderPartnerId"] = this.senderPartnerId;
        data["receiverPartnerId"] = this.receiverPartnerId;
        data["receiverCommunicationProfileId"] = this.receiverCommunicationProfileId;
        data["messageTypeCode"] = this.messageTypeCode;
        data["direction"] = this.direction;
        data["maximumDelayDelivery"] = this.maximumDelayDelivery;
        data["requireAcknowledgement"] = this.requireAcknowledgement;
        data["maximumDelayAcknowledgement"] = this.maximumDelayAcknowledgement;
        data["excluded"] = this.excluded;
        data["validFrom"] = this.validFrom ? this.validFrom.toISOString() : <any>undefined;
        data["validTo"] = this.validTo ? this.validTo.toISOString() : <any>undefined;
        data["senderCodingType"] = this.senderCodingType;
        data["receiverCodingType"] = this.receiverCodingType;
        data["comSenderCodingType"] = this.comSenderCodingType;
        data["comReceiverCodingType"] = this.comReceiverCodingType;
        data["internalShipperAccountCodingType"] = this.internalShipperAccountCodingType;
        data["externalShipperAccountCodingType"] = this.externalShipperAccountCodingType;
        data["connectionPointCodingType"] = this.connectionPointCodingType;
        data["messageIdentificationSettingId"] = this.messageIdentificationSettingId;
        data["id"] = this.id;
        if (Array.isArray(this.mapExtensions)) {
            data["mapExtensions"] = [];
            for (let item of this.mapExtensions)
                data["mapExtensions"].push(item.toJSON());
        }
        if (Array.isArray(this.processExtensions)) {
            data["processExtensions"] = [];
            for (let item of this.processExtensions)
                data["processExtensions"].push(item.toJSON());
        }
        data["processingModeId"] = this.processingModeId;
        return data;
    }
}

export interface IMessageSettingDto {
    messageTypeSpecificationId: string;
    senderPartnerId: string;
    receiverPartnerId: string;
    receiverCommunicationProfileId?: string | undefined;
    messageTypeCode: string;
    direction: string;
    maximumDelayDelivery?: number;
    requireAcknowledgement?: boolean;
    maximumDelayAcknowledgement?: number | undefined;
    excluded?: boolean;
    validFrom: Date;
    validTo: Date;
    senderCodingType: string;
    receiverCodingType: string;
    comSenderCodingType: string;
    comReceiverCodingType: string;
    internalShipperAccountCodingType: string;
    externalShipperAccountCodingType: string;
    connectionPointCodingType: string;
    messageIdentificationSettingId?: string | undefined;
    id?: string | undefined;
    mapExtensions?: MapExtensionDto[] | undefined;
    processExtensions?: ProcessExtensionDto[] | undefined;
    processingModeId?: string | undefined;
}

export class MessageSettingListItemDto implements IMessageSettingListItemDto {
    messageTypeSpecification?: string | undefined;
    senderPartner?: string | undefined;
    senderPartnerConnectCode?: string | undefined;
    receiverPartner?: string | undefined;
    receiverPartnerConnectCode?: string | undefined;
    receiverCommunicationProfile?: string | undefined;
    messageTypeCode?: string | undefined;
    direction?: string | undefined;
    validFrom?: Date;
    validTo?: Date;
    isActive?: boolean;
    hasExtensionParameters?: boolean;
    extensionParameters?: string[] | undefined;
    id?: string | undefined;
    tenantCode?: string | undefined;
    originalCorrespondentCode?: string | undefined;
    translatedCorrespondentCode?: string | undefined;
    correspondentName?: string | undefined;
    isExcluded?: boolean;
    senderPartnerId?: number;
    receiverPartnerId?: number;
    receiverCommunicationProfileId?: string | undefined;
    receiverCommunicationProfileProtocolCode?: string | undefined;
    processingModeId?: string | undefined;

    constructor(data?: IMessageSettingListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messageTypeSpecification = _data["messageTypeSpecification"];
            this.senderPartner = _data["senderPartner"];
            this.senderPartnerConnectCode = _data["senderPartnerConnectCode"];
            this.receiverPartner = _data["receiverPartner"];
            this.receiverPartnerConnectCode = _data["receiverPartnerConnectCode"];
            this.receiverCommunicationProfile = _data["receiverCommunicationProfile"];
            this.messageTypeCode = _data["messageTypeCode"];
            this.direction = _data["direction"];
            this.validFrom = _data["validFrom"] ? new Date(_data["validFrom"].toString()) : <any>undefined;
            this.validTo = _data["validTo"] ? new Date(_data["validTo"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
            this.hasExtensionParameters = _data["hasExtensionParameters"];
            if (Array.isArray(_data["extensionParameters"])) {
                this.extensionParameters = [] as any;
                for (let item of _data["extensionParameters"])
                    this.extensionParameters!.push(item);
            }
            this.id = _data["id"];
            this.tenantCode = _data["tenantCode"];
            this.originalCorrespondentCode = _data["originalCorrespondentCode"];
            this.translatedCorrespondentCode = _data["translatedCorrespondentCode"];
            this.correspondentName = _data["correspondentName"];
            this.isExcluded = _data["isExcluded"];
            this.senderPartnerId = _data["senderPartnerId"];
            this.receiverPartnerId = _data["receiverPartnerId"];
            this.receiverCommunicationProfileId = _data["receiverCommunicationProfileId"];
            this.receiverCommunicationProfileProtocolCode = _data["receiverCommunicationProfileProtocolCode"];
            this.processingModeId = _data["processingModeId"];
        }
    }

    static fromJS(data: any): MessageSettingListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new MessageSettingListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messageTypeSpecification"] = this.messageTypeSpecification;
        data["senderPartner"] = this.senderPartner;
        data["senderPartnerConnectCode"] = this.senderPartnerConnectCode;
        data["receiverPartner"] = this.receiverPartner;
        data["receiverPartnerConnectCode"] = this.receiverPartnerConnectCode;
        data["receiverCommunicationProfile"] = this.receiverCommunicationProfile;
        data["messageTypeCode"] = this.messageTypeCode;
        data["direction"] = this.direction;
        data["validFrom"] = this.validFrom ? this.validFrom.toISOString() : <any>undefined;
        data["validTo"] = this.validTo ? this.validTo.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        data["hasExtensionParameters"] = this.hasExtensionParameters;
        if (Array.isArray(this.extensionParameters)) {
            data["extensionParameters"] = [];
            for (let item of this.extensionParameters)
                data["extensionParameters"].push(item);
        }
        data["id"] = this.id;
        data["tenantCode"] = this.tenantCode;
        data["originalCorrespondentCode"] = this.originalCorrespondentCode;
        data["translatedCorrespondentCode"] = this.translatedCorrespondentCode;
        data["correspondentName"] = this.correspondentName;
        data["isExcluded"] = this.isExcluded;
        data["senderPartnerId"] = this.senderPartnerId;
        data["receiverPartnerId"] = this.receiverPartnerId;
        data["receiverCommunicationProfileId"] = this.receiverCommunicationProfileId;
        data["receiverCommunicationProfileProtocolCode"] = this.receiverCommunicationProfileProtocolCode;
        data["processingModeId"] = this.processingModeId;
        return data;
    }
}

export interface IMessageSettingListItemDto {
    messageTypeSpecification?: string | undefined;
    senderPartner?: string | undefined;
    senderPartnerConnectCode?: string | undefined;
    receiverPartner?: string | undefined;
    receiverPartnerConnectCode?: string | undefined;
    receiverCommunicationProfile?: string | undefined;
    messageTypeCode?: string | undefined;
    direction?: string | undefined;
    validFrom?: Date;
    validTo?: Date;
    isActive?: boolean;
    hasExtensionParameters?: boolean;
    extensionParameters?: string[] | undefined;
    id?: string | undefined;
    tenantCode?: string | undefined;
    originalCorrespondentCode?: string | undefined;
    translatedCorrespondentCode?: string | undefined;
    correspondentName?: string | undefined;
    isExcluded?: boolean;
    senderPartnerId?: number;
    receiverPartnerId?: number;
    receiverCommunicationProfileId?: string | undefined;
    receiverCommunicationProfileProtocolCode?: string | undefined;
    processingModeId?: string | undefined;
}

export class MessageTypeDto implements IMessageTypeDto {
    code?: string | undefined;
    messageGroupName?: string | undefined;
    description?: string | undefined;
    id?: string | undefined;

    constructor(data?: IMessageTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.messageGroupName = _data["messageGroupName"];
            this.description = _data["description"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MessageTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new MessageTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["messageGroupName"] = this.messageGroupName;
        data["description"] = this.description;
        data["id"] = this.id;
        return data;
    }
}

export interface IMessageTypeDto {
    code?: string | undefined;
    messageGroupName?: string | undefined;
    description?: string | undefined;
    id?: string | undefined;
}

export class OAuthConfigurationDto implements IOAuthConfigurationDto {
    id?: string | undefined;
    communicationProfileId?: number;
    clientId?: string | undefined;
    audience?: string | undefined;
    scope?: string | undefined;
    keyName?: string | undefined;
    authenticationEndpoint?: string | undefined;

    constructor(data?: IOAuthConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.communicationProfileId = _data["communicationProfileId"];
            this.clientId = _data["clientId"];
            this.audience = _data["audience"];
            this.scope = _data["scope"];
            this.keyName = _data["keyName"];
            this.authenticationEndpoint = _data["authenticationEndpoint"];
        }
    }

    static fromJS(data: any): OAuthConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new OAuthConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["communicationProfileId"] = this.communicationProfileId;
        data["clientId"] = this.clientId;
        data["audience"] = this.audience;
        data["scope"] = this.scope;
        data["keyName"] = this.keyName;
        data["authenticationEndpoint"] = this.authenticationEndpoint;
        return data;
    }
}

export interface IOAuthConfigurationDto {
    id?: string | undefined;
    communicationProfileId?: number;
    clientId?: string | undefined;
    audience?: string | undefined;
    scope?: string | undefined;
    keyName?: string | undefined;
    authenticationEndpoint?: string | undefined;
}

export class ParseCertificateResponse implements IParseCertificateResponse {
    parsedCertificate?: ParsedCertificate | undefined;

    constructor(data?: IParseCertificateResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parsedCertificate = _data["parsedCertificate"] ? ParsedCertificate.fromJS(_data["parsedCertificate"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ParseCertificateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ParseCertificateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parsedCertificate"] = this.parsedCertificate ? this.parsedCertificate.toJSON() : <any>undefined;
        return data;
    }
}

export interface IParseCertificateResponse {
    parsedCertificate?: ParsedCertificate | undefined;
}

export class ParsedCertificate implements IParsedCertificate {
    validityDatesDto?: ValidityDatesDto2 | undefined;
    serialNumber?: string | undefined;
    keyModulus?: string | undefined;
    keyExponent?: string | undefined;
    certificateData?: string | undefined;
    subjectName?: string | undefined;
    keyName?: string | undefined;
    algorithm?: string | undefined;
    digestAlgorithm?: string | undefined;

    constructor(data?: IParsedCertificate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.validityDatesDto = _data["validityDatesDto"] ? ValidityDatesDto2.fromJS(_data["validityDatesDto"]) : <any>undefined;
            this.serialNumber = _data["serialNumber"];
            this.keyModulus = _data["keyModulus"];
            this.keyExponent = _data["keyExponent"];
            this.certificateData = _data["certificateData"];
            this.subjectName = _data["subjectName"];
            this.keyName = _data["keyName"];
            this.algorithm = _data["algorithm"];
            this.digestAlgorithm = _data["digestAlgorithm"];
        }
    }

    static fromJS(data: any): ParsedCertificate {
        data = typeof data === 'object' ? data : {};
        let result = new ParsedCertificate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["validityDatesDto"] = this.validityDatesDto ? this.validityDatesDto.toJSON() : <any>undefined;
        data["serialNumber"] = this.serialNumber;
        data["keyModulus"] = this.keyModulus;
        data["keyExponent"] = this.keyExponent;
        data["certificateData"] = this.certificateData;
        data["subjectName"] = this.subjectName;
        data["keyName"] = this.keyName;
        data["algorithm"] = this.algorithm;
        data["digestAlgorithm"] = this.digestAlgorithm;
        return data;
    }
}

export interface IParsedCertificate {
    validityDatesDto?: ValidityDatesDto2 | undefined;
    serialNumber?: string | undefined;
    keyModulus?: string | undefined;
    keyExponent?: string | undefined;
    certificateData?: string | undefined;
    subjectName?: string | undefined;
    keyName?: string | undefined;
    algorithm?: string | undefined;
    digestAlgorithm?: string | undefined;
}

export class PartnerCodeDto implements IPartnerCodeDto {
    id?: string | undefined;
    tenantId?: string | undefined;
    code?: string | undefined;
    isDeleted?: boolean;

    constructor(data?: IPartnerCodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.code = _data["code"];
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): PartnerCodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerCodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["code"] = this.code;
        data["isDeleted"] = this.isDeleted;
        return data;
    }
}

export interface IPartnerCodeDto {
    id?: string | undefined;
    tenantId?: string | undefined;
    code?: string | undefined;
    isDeleted?: boolean;
}

export class PartnerCodeTranslationDto implements IPartnerCodeTranslationDto {
    id?: string | undefined;
    name?: string | undefined;
    code?: string | undefined;
    usage?: string | undefined;
    tenant?: string | undefined;
    type?: string | undefined;

    constructor(data?: IPartnerCodeTranslationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.usage = _data["usage"];
            this.tenant = _data["tenant"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): PartnerCodeTranslationDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerCodeTranslationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        data["usage"] = this.usage;
        data["tenant"] = this.tenant;
        data["type"] = this.type;
        return data;
    }
}

export interface IPartnerCodeTranslationDto {
    id?: string | undefined;
    name?: string | undefined;
    code?: string | undefined;
    usage?: string | undefined;
    tenant?: string | undefined;
    type?: string | undefined;
}

export class PartnerCommunicationProfileDto implements IPartnerCommunicationProfileDto {
    id?: string | undefined;
    name?: string | undefined;

    constructor(data?: IPartnerCommunicationProfileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): PartnerCommunicationProfileDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerCommunicationProfileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IPartnerCommunicationProfileDto {
    id?: string | undefined;
    name?: string | undefined;
}

export class PartnerContactDto implements IPartnerContactDto {
    id?: string | undefined;
    name?: string | undefined;
    telephone?: string | undefined;
    email?: string | undefined;
    isDeleted?: boolean;

    constructor(data?: IPartnerContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.telephone = _data["telephone"];
            this.email = _data["email"];
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): PartnerContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["telephone"] = this.telephone;
        data["email"] = this.email;
        data["isDeleted"] = this.isDeleted;
        return data;
    }
}

export interface IPartnerContactDto {
    id?: string | undefined;
    name?: string | undefined;
    telephone?: string | undefined;
    email?: string | undefined;
    isDeleted?: boolean;
}

export class PartnerDto implements IPartnerDto {
    id?: string | undefined;
    name?: string | undefined;
    connectCode?: string | undefined;
    hasRoleTrading?: boolean | undefined;
    hasRoleCommunication?: boolean | undefined;
    belongsToEaseeGasGroup?: boolean;
    validFrom?: Date;
    validTo?: Date;
    partnerContactDtos?: PartnerContactDto[] | undefined;
    partnerCodeDtos?: PartnerCodeDto[] | undefined;
    partnerTranslationCodeDtos?: PartnerTranslationCodeDto[] | undefined;
    tenantsForActiveMessageSettings?: PartnerTenantsDto[] | undefined;
    partnerCommunicationProfileDtos?: PartnerCommunicationProfileDto[] | undefined;
    isValid?: boolean;
    isActive?: boolean;

    constructor(data?: IPartnerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.connectCode = _data["connectCode"];
            this.hasRoleTrading = _data["hasRoleTrading"];
            this.hasRoleCommunication = _data["hasRoleCommunication"];
            this.belongsToEaseeGasGroup = _data["belongsToEaseeGasGroup"];
            this.validFrom = _data["validFrom"] ? new Date(_data["validFrom"].toString()) : <any>undefined;
            this.validTo = _data["validTo"] ? new Date(_data["validTo"].toString()) : <any>undefined;
            if (Array.isArray(_data["partnerContactDtos"])) {
                this.partnerContactDtos = [] as any;
                for (let item of _data["partnerContactDtos"])
                    this.partnerContactDtos!.push(PartnerContactDto.fromJS(item));
            }
            if (Array.isArray(_data["partnerCodeDtos"])) {
                this.partnerCodeDtos = [] as any;
                for (let item of _data["partnerCodeDtos"])
                    this.partnerCodeDtos!.push(PartnerCodeDto.fromJS(item));
            }
            if (Array.isArray(_data["partnerTranslationCodeDtos"])) {
                this.partnerTranslationCodeDtos = [] as any;
                for (let item of _data["partnerTranslationCodeDtos"])
                    this.partnerTranslationCodeDtos!.push(PartnerTranslationCodeDto.fromJS(item));
            }
            if (Array.isArray(_data["tenantsForActiveMessageSettings"])) {
                this.tenantsForActiveMessageSettings = [] as any;
                for (let item of _data["tenantsForActiveMessageSettings"])
                    this.tenantsForActiveMessageSettings!.push(PartnerTenantsDto.fromJS(item));
            }
            if (Array.isArray(_data["partnerCommunicationProfileDtos"])) {
                this.partnerCommunicationProfileDtos = [] as any;
                for (let item of _data["partnerCommunicationProfileDtos"])
                    this.partnerCommunicationProfileDtos!.push(PartnerCommunicationProfileDto.fromJS(item));
            }
            this.isValid = _data["isValid"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): PartnerDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["connectCode"] = this.connectCode;
        data["hasRoleTrading"] = this.hasRoleTrading;
        data["hasRoleCommunication"] = this.hasRoleCommunication;
        data["belongsToEaseeGasGroup"] = this.belongsToEaseeGasGroup;
        data["validFrom"] = this.validFrom ? this.validFrom.toISOString() : <any>undefined;
        data["validTo"] = this.validTo ? this.validTo.toISOString() : <any>undefined;
        if (Array.isArray(this.partnerContactDtos)) {
            data["partnerContactDtos"] = [];
            for (let item of this.partnerContactDtos)
                data["partnerContactDtos"].push(item.toJSON());
        }
        if (Array.isArray(this.partnerCodeDtos)) {
            data["partnerCodeDtos"] = [];
            for (let item of this.partnerCodeDtos)
                data["partnerCodeDtos"].push(item.toJSON());
        }
        if (Array.isArray(this.partnerTranslationCodeDtos)) {
            data["partnerTranslationCodeDtos"] = [];
            for (let item of this.partnerTranslationCodeDtos)
                data["partnerTranslationCodeDtos"].push(item.toJSON());
        }
        if (Array.isArray(this.tenantsForActiveMessageSettings)) {
            data["tenantsForActiveMessageSettings"] = [];
            for (let item of this.tenantsForActiveMessageSettings)
                data["tenantsForActiveMessageSettings"].push(item.toJSON());
        }
        if (Array.isArray(this.partnerCommunicationProfileDtos)) {
            data["partnerCommunicationProfileDtos"] = [];
            for (let item of this.partnerCommunicationProfileDtos)
                data["partnerCommunicationProfileDtos"].push(item.toJSON());
        }
        data["isValid"] = this.isValid;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IPartnerDto {
    id?: string | undefined;
    name?: string | undefined;
    connectCode?: string | undefined;
    hasRoleTrading?: boolean | undefined;
    hasRoleCommunication?: boolean | undefined;
    belongsToEaseeGasGroup?: boolean;
    validFrom?: Date;
    validTo?: Date;
    partnerContactDtos?: PartnerContactDto[] | undefined;
    partnerCodeDtos?: PartnerCodeDto[] | undefined;
    partnerTranslationCodeDtos?: PartnerTranslationCodeDto[] | undefined;
    tenantsForActiveMessageSettings?: PartnerTenantsDto[] | undefined;
    partnerCommunicationProfileDtos?: PartnerCommunicationProfileDto[] | undefined;
    isValid?: boolean;
    isActive?: boolean;
}

export class PartnerListItemDto implements IPartnerListItemDto {
    isActive?: boolean;
    name?: string | undefined;
    connectCode?: string | undefined;
    hasRoleTrading?: boolean;
    hasRoleCommunication?: boolean;
    belongsToEaseeGasGroup?: boolean;
    roles?: string[] | undefined;
    partnerCodes?: string[] | undefined;
    isTenant?: boolean;
    id?: string | undefined;

    constructor(data?: IPartnerListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isActive = _data["isActive"];
            this.name = _data["name"];
            this.connectCode = _data["connectCode"];
            this.hasRoleTrading = _data["hasRoleTrading"];
            this.hasRoleCommunication = _data["hasRoleCommunication"];
            this.belongsToEaseeGasGroup = _data["belongsToEaseeGasGroup"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            if (Array.isArray(_data["partnerCodes"])) {
                this.partnerCodes = [] as any;
                for (let item of _data["partnerCodes"])
                    this.partnerCodes!.push(item);
            }
            this.isTenant = _data["isTenant"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PartnerListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isActive"] = this.isActive;
        data["name"] = this.name;
        data["connectCode"] = this.connectCode;
        data["hasRoleTrading"] = this.hasRoleTrading;
        data["hasRoleCommunication"] = this.hasRoleCommunication;
        data["belongsToEaseeGasGroup"] = this.belongsToEaseeGasGroup;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        if (Array.isArray(this.partnerCodes)) {
            data["partnerCodes"] = [];
            for (let item of this.partnerCodes)
                data["partnerCodes"].push(item);
        }
        data["isTenant"] = this.isTenant;
        data["id"] = this.id;
        return data;
    }
}

export interface IPartnerListItemDto {
    isActive?: boolean;
    name?: string | undefined;
    connectCode?: string | undefined;
    hasRoleTrading?: boolean;
    hasRoleCommunication?: boolean;
    belongsToEaseeGasGroup?: boolean;
    roles?: string[] | undefined;
    partnerCodes?: string[] | undefined;
    isTenant?: boolean;
    id?: string | undefined;
}

export class PartnerTenantsDto implements IPartnerTenantsDto {
    id?: string | undefined;
    name?: string | undefined;

    constructor(data?: IPartnerTenantsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): PartnerTenantsDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerTenantsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IPartnerTenantsDto {
    id?: string | undefined;
    name?: string | undefined;
}

export class PartnerTranslationCodeDto implements IPartnerTranslationCodeDto {
    id?: string | undefined;
    codingType?: string | undefined;
    code?: string | undefined;
    isDeleted?: boolean;

    constructor(data?: IPartnerTranslationCodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.codingType = _data["codingType"];
            this.code = _data["code"];
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): PartnerTranslationCodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerTranslationCodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["codingType"] = this.codingType;
        data["code"] = this.code;
        data["isDeleted"] = this.isDeleted;
        return data;
    }
}

export interface IPartnerTranslationCodeDto {
    id?: string | undefined;
    codingType?: string | undefined;
    code?: string | undefined;
    isDeleted?: boolean;
}

export class ProcessExtensionDto implements IProcessExtensionDto {
    id!: string;
    type!: string;
    communicationProfileId?: string | undefined;
    receiverPartnerId?: string | undefined;
    data?: string | undefined;

    constructor(data?: IProcessExtensionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.communicationProfileId = _data["communicationProfileId"];
            this.receiverPartnerId = _data["receiverPartnerId"];
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): ProcessExtensionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessExtensionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["communicationProfileId"] = this.communicationProfileId;
        data["receiverPartnerId"] = this.receiverPartnerId;
        data["data"] = this.data;
        return data;
    }
}

export interface IProcessExtensionDto {
    id: string;
    type: string;
    communicationProfileId?: string | undefined;
    receiverPartnerId?: string | undefined;
    data?: string | undefined;
}

export class ProcessingModeDto2 implements IProcessingModeDto2 {
    id?: string | undefined;
    description?: string | undefined;
    communicationProfileId?: string | undefined;

    constructor(data?: IProcessingModeDto2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.communicationProfileId = _data["communicationProfileId"];
        }
    }

    static fromJS(data: any): ProcessingModeDto2 {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessingModeDto2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["communicationProfileId"] = this.communicationProfileId;
        return data;
    }
}

export interface IProcessingModeDto2 {
    id?: string | undefined;
    description?: string | undefined;
    communicationProfileId?: string | undefined;
}

export enum RestProtocolAuthorization {
    NoAuth = "NoAuth",
    OAuth = "OAuth",
    OAuth2 = "OAuth2",
}

export class SaveCodeTranslationsRequest implements ISaveCodeTranslationsRequest {
    codeTranslationDto?: CodeTranslationDto | undefined;

    constructor(data?: ISaveCodeTranslationsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codeTranslationDto = _data["codeTranslationDto"] ? CodeTranslationDto.fromJS(_data["codeTranslationDto"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SaveCodeTranslationsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveCodeTranslationsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codeTranslationDto"] = this.codeTranslationDto ? this.codeTranslationDto.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISaveCodeTranslationsRequest {
    codeTranslationDto?: CodeTranslationDto | undefined;
}

export class SaveCodeTranslationsResponse implements ISaveCodeTranslationsResponse {
    codeTranslationDto?: CodeTranslationDto | undefined;

    constructor(data?: ISaveCodeTranslationsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codeTranslationDto = _data["codeTranslationDto"] ? CodeTranslationDto.fromJS(_data["codeTranslationDto"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SaveCodeTranslationsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SaveCodeTranslationsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codeTranslationDto"] = this.codeTranslationDto ? this.codeTranslationDto.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISaveCodeTranslationsResponse {
    codeTranslationDto?: CodeTranslationDto | undefined;
}

export class SaveCommunicationProfileRequest implements ISaveCommunicationProfileRequest {
    communicationProfileDto?: CommunicationProfileDto | undefined;

    constructor(data?: ISaveCommunicationProfileRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.communicationProfileDto = _data["communicationProfileDto"] ? CommunicationProfileDto.fromJS(_data["communicationProfileDto"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SaveCommunicationProfileRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveCommunicationProfileRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["communicationProfileDto"] = this.communicationProfileDto ? this.communicationProfileDto.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISaveCommunicationProfileRequest {
    communicationProfileDto?: CommunicationProfileDto | undefined;
}

export class SaveMessageSettingDetailRequest implements ISaveMessageSettingDetailRequest {
    messageSettingDto?: MessageSettingDto | undefined;

    constructor(data?: ISaveMessageSettingDetailRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messageSettingDto = _data["messageSettingDto"] ? MessageSettingDto.fromJS(_data["messageSettingDto"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SaveMessageSettingDetailRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveMessageSettingDetailRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messageSettingDto"] = this.messageSettingDto ? this.messageSettingDto.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISaveMessageSettingDetailRequest {
    messageSettingDto?: MessageSettingDto | undefined;
}

export class SaveMessageSettingDetailResponse implements ISaveMessageSettingDetailResponse {
    messageSettingDto?: MessageSettingDto | undefined;

    constructor(data?: ISaveMessageSettingDetailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messageSettingDto = _data["messageSettingDto"] ? MessageSettingDto.fromJS(_data["messageSettingDto"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SaveMessageSettingDetailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SaveMessageSettingDetailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messageSettingDto"] = this.messageSettingDto ? this.messageSettingDto.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISaveMessageSettingDetailResponse {
    messageSettingDto?: MessageSettingDto | undefined;
}

export class SavePartnerDetailRequest implements ISavePartnerDetailRequest {
    partnerDto?: PartnerDto | undefined;

    constructor(data?: ISavePartnerDetailRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partnerDto = _data["partnerDto"] ? PartnerDto.fromJS(_data["partnerDto"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SavePartnerDetailRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SavePartnerDetailRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partnerDto"] = this.partnerDto ? this.partnerDto.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISavePartnerDetailRequest {
    partnerDto?: PartnerDto | undefined;
}

export class SavePartnerDetailResponse implements ISavePartnerDetailResponse {
    partnerDto?: PartnerDto | undefined;

    constructor(data?: ISavePartnerDetailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partnerDto = _data["partnerDto"] ? PartnerDto.fromJS(_data["partnerDto"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SavePartnerDetailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SavePartnerDetailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partnerDto"] = this.partnerDto ? this.partnerDto.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISavePartnerDetailResponse {
    partnerDto?: PartnerDto | undefined;
}

export class SaveSecretRequest implements ISaveSecretRequest {
    secretDto?: SecretDto | undefined;

    constructor(data?: ISaveSecretRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.secretDto = _data["secretDto"] ? SecretDto.fromJS(_data["secretDto"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SaveSecretRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveSecretRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["secretDto"] = this.secretDto ? this.secretDto.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISaveSecretRequest {
    secretDto?: SecretDto | undefined;
}

export class SaveSecretResponse implements ISaveSecretResponse {
    secretDto?: SecretDto | undefined;

    constructor(data?: ISaveSecretResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.secretDto = _data["secretDto"] ? SecretDto.fromJS(_data["secretDto"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SaveSecretResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SaveSecretResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["secretDto"] = this.secretDto ? this.secretDto.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISaveSecretResponse {
    secretDto?: SecretDto | undefined;
}

export class SecretDto implements ISecretDto {
    partnerId?: string | undefined;
    secretType?: SecretType2;
    secretSubType?: SecretSubType2;
    name?: string | undefined;
    content?: string | undefined;
    comment?: string | undefined;
    validFrom?: Date;
    validTo?: Date;
    revoked?: boolean;
    id?: string | undefined;
    passPhrase?: string | undefined;

    constructor(data?: ISecretDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partnerId = _data["partnerId"];
            this.secretType = _data["secretType"];
            this.secretSubType = _data["secretSubType"];
            this.name = _data["name"];
            this.content = _data["content"];
            this.comment = _data["comment"];
            this.validFrom = _data["validFrom"] ? new Date(_data["validFrom"].toString()) : <any>undefined;
            this.validTo = _data["validTo"] ? new Date(_data["validTo"].toString()) : <any>undefined;
            this.revoked = _data["revoked"];
            this.id = _data["id"];
            this.passPhrase = _data["passPhrase"];
        }
    }

    static fromJS(data: any): SecretDto {
        data = typeof data === 'object' ? data : {};
        let result = new SecretDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partnerId"] = this.partnerId;
        data["secretType"] = this.secretType;
        data["secretSubType"] = this.secretSubType;
        data["name"] = this.name;
        data["content"] = this.content;
        data["comment"] = this.comment;
        data["validFrom"] = this.validFrom ? this.validFrom.toISOString() : <any>undefined;
        data["validTo"] = this.validTo ? this.validTo.toISOString() : <any>undefined;
        data["revoked"] = this.revoked;
        data["id"] = this.id;
        data["passPhrase"] = this.passPhrase;
        return data;
    }
}

export interface ISecretDto {
    partnerId?: string | undefined;
    secretType?: SecretType2;
    secretSubType?: SecretSubType2;
    name?: string | undefined;
    content?: string | undefined;
    comment?: string | undefined;
    validFrom?: Date;
    validTo?: Date;
    revoked?: boolean;
    id?: string | undefined;
    passPhrase?: string | undefined;
}

export class SecretExpirationListItemDto implements ISecretExpirationListItemDto {
    secretType?: SecretType2;
    secretSubType?: SecretSubType2;
    owner?: string | undefined;
    serialNumber?: string | undefined;
    comment?: string | undefined;
    validFrom?: Date;
    validTo?: Date;
    revoked?: boolean;
    id?: string | undefined;
    passPhrase?: string | undefined;
    communicationProfileIds?: string[] | undefined;

    constructor(data?: ISecretExpirationListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.secretType = _data["secretType"];
            this.secretSubType = _data["secretSubType"];
            this.owner = _data["owner"];
            this.serialNumber = _data["serialNumber"];
            this.comment = _data["comment"];
            this.validFrom = _data["validFrom"] ? new Date(_data["validFrom"].toString()) : <any>undefined;
            this.validTo = _data["validTo"] ? new Date(_data["validTo"].toString()) : <any>undefined;
            this.revoked = _data["revoked"];
            this.id = _data["id"];
            this.passPhrase = _data["passPhrase"];
            if (Array.isArray(_data["communicationProfileIds"])) {
                this.communicationProfileIds = [] as any;
                for (let item of _data["communicationProfileIds"])
                    this.communicationProfileIds!.push(item);
            }
        }
    }

    static fromJS(data: any): SecretExpirationListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new SecretExpirationListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["secretType"] = this.secretType;
        data["secretSubType"] = this.secretSubType;
        data["owner"] = this.owner;
        data["serialNumber"] = this.serialNumber;
        data["comment"] = this.comment;
        data["validFrom"] = this.validFrom ? this.validFrom.toISOString() : <any>undefined;
        data["validTo"] = this.validTo ? this.validTo.toISOString() : <any>undefined;
        data["revoked"] = this.revoked;
        data["id"] = this.id;
        data["passPhrase"] = this.passPhrase;
        if (Array.isArray(this.communicationProfileIds)) {
            data["communicationProfileIds"] = [];
            for (let item of this.communicationProfileIds)
                data["communicationProfileIds"].push(item);
        }
        return data;
    }
}

export interface ISecretExpirationListItemDto {
    secretType?: SecretType2;
    secretSubType?: SecretSubType2;
    owner?: string | undefined;
    serialNumber?: string | undefined;
    comment?: string | undefined;
    validFrom?: Date;
    validTo?: Date;
    revoked?: boolean;
    id?: string | undefined;
    passPhrase?: string | undefined;
    communicationProfileIds?: string[] | undefined;
}

export class SecretFunctionalityDto implements ISecretFunctionalityDto {
    name?: string | undefined;
    secretUsage?: SecretUsage2;
    secretType?: SecretType2;
    secretSubType?: SecretSubType2;
    secretId?: string | undefined;
    validityDates?: ValidityDatesDto2 | undefined;

    constructor(data?: ISecretFunctionalityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.secretUsage = _data["secretUsage"];
            this.secretType = _data["secretType"];
            this.secretSubType = _data["secretSubType"];
            this.secretId = _data["secretId"];
            this.validityDates = _data["validityDates"] ? ValidityDatesDto2.fromJS(_data["validityDates"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SecretFunctionalityDto {
        data = typeof data === 'object' ? data : {};
        let result = new SecretFunctionalityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["secretUsage"] = this.secretUsage;
        data["secretType"] = this.secretType;
        data["secretSubType"] = this.secretSubType;
        data["secretId"] = this.secretId;
        data["validityDates"] = this.validityDates ? this.validityDates.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISecretFunctionalityDto {
    name?: string | undefined;
    secretUsage?: SecretUsage2;
    secretType?: SecretType2;
    secretSubType?: SecretSubType2;
    secretId?: string | undefined;
    validityDates?: ValidityDatesDto2 | undefined;
}

export class SecretListItemDto implements ISecretListItemDto {
    secretType?: SecretType2;
    secretSubType?: SecretSubType2;
    owner?: string | undefined;
    serialNumber?: string | undefined;
    comment?: string | undefined;
    validFrom?: Date;
    validTo?: Date;
    revoked?: boolean;
    id?: string | undefined;
    passPhrase?: string | undefined;

    constructor(data?: ISecretListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.secretType = _data["secretType"];
            this.secretSubType = _data["secretSubType"];
            this.owner = _data["owner"];
            this.serialNumber = _data["serialNumber"];
            this.comment = _data["comment"];
            this.validFrom = _data["validFrom"] ? new Date(_data["validFrom"].toString()) : <any>undefined;
            this.validTo = _data["validTo"] ? new Date(_data["validTo"].toString()) : <any>undefined;
            this.revoked = _data["revoked"];
            this.id = _data["id"];
            this.passPhrase = _data["passPhrase"];
        }
    }

    static fromJS(data: any): SecretListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new SecretListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["secretType"] = this.secretType;
        data["secretSubType"] = this.secretSubType;
        data["owner"] = this.owner;
        data["serialNumber"] = this.serialNumber;
        data["comment"] = this.comment;
        data["validFrom"] = this.validFrom ? this.validFrom.toISOString() : <any>undefined;
        data["validTo"] = this.validTo ? this.validTo.toISOString() : <any>undefined;
        data["revoked"] = this.revoked;
        data["id"] = this.id;
        data["passPhrase"] = this.passPhrase;
        return data;
    }
}

export interface ISecretListItemDto {
    secretType?: SecretType2;
    secretSubType?: SecretSubType2;
    owner?: string | undefined;
    serialNumber?: string | undefined;
    comment?: string | undefined;
    validFrom?: Date;
    validTo?: Date;
    revoked?: boolean;
    id?: string | undefined;
    passPhrase?: string | undefined;
}

export enum SecretSubType2 {
    Private = "Private",
    Public = "Public",
}

export enum SecretType2 {
    PGP = "PGP",
    SSH = "SSH",
    Certificate = "Certificate",
    EDDSA = "EDDSA",
    ECDSA = "ECDSA",
}

export enum SecretUsage2 {
    Authentication = "Authentication",
    Encryption = "Encryption",
}

export enum SignatureAlgorithm {
    Sha1 = "Sha1",
    Sha224 = "Sha224",
    Sha256 = "Sha256",
    Sha384 = "Sha384",
    Sha512 = "Sha512",
    Md5 = "Md5",
}

export enum SoapClientCredentialType {
    None = "None",
    Basic = "Basic",
    Windows = "Windows",
    Certificate = "Certificate",
    Digest = "Digest",
    Ntlm = "Ntlm",
}

export enum SoapImplementationType {
    ApSapCallSoap = "ApSapCallSoap",
    DesequilibreGRTGazCallSoap = "DesequilibreGRTGazCallSoap",
    FluxImpliciteGRTGazCallSoap = "FluxImpliciteGRTGazCallSoap",
    ZefirGRTGazCallSoap = "ZefirGRTGazCallSoap",
    EnagasCallSoap = "EnagasCallSoap",
}

export enum SoapSecurityModeType {
    None = "None",
    Message = "Message",
    Transport = "Transport",
    TransportCredentialOnly = "TransportCredentialOnly",
    TransportWithMessageCredential = "TransportWithMessageCredential",
}

export enum SslMode {
    None = "None",
    Implicit = "Implicit",
    Explicit = "Explicit",
}

export class TenantListItemDto implements ITenantListItemDto {
    name?: string | undefined;
    code?: string | undefined;
    id?: string | undefined;

    constructor(data?: ITenantListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.code = _data["code"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TenantListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["code"] = this.code;
        data["id"] = this.id;
        return data;
    }
}

export interface ITenantListItemDto {
    name?: string | undefined;
    code?: string | undefined;
    id?: string | undefined;
}

export class TransportTypeDto implements ITransportTypeDto {
    name?: string | undefined;

    constructor(data?: ITransportTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): TransportTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransportTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface ITransportTypeDto {
    name?: string | undefined;
}

export class ValidityDatesDto2 implements IValidityDatesDto2 {
    from?: Date;
    to?: Date;

    constructor(data?: IValidityDatesDto2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"] ? new Date(_data["from"].toString()) : <any>undefined;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ValidityDatesDto2 {
        data = typeof data === 'object' ? data : {};
        let result = new ValidityDatesDto2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        return data;
    }
}

export interface IValidityDatesDto2 {
    from?: Date;
    to?: Date;
}

export enum VersionStrategyType {
    None = "None",
    Continuous = "Continuous",
    Integrated = "Integrated",
    Separated = "Separated",
}

export class DateDto implements IDateDto {
    dateTime?: Date;
    day?: number;
    month?: number;
    year?: number;
    dayOfYear?: number;
    dayOfWeek?: DayOfWeek;

    constructor(data?: IDateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateTime = _data["dateTime"] ? new Date(_data["dateTime"].toString()) : <any>undefined;
            this.day = _data["day"];
            this.month = _data["month"];
            this.year = _data["year"];
            this.dayOfYear = _data["dayOfYear"];
            this.dayOfWeek = _data["dayOfWeek"];
        }
    }

    static fromJS(data: any): DateDto {
        data = typeof data === 'object' ? data : {};
        let result = new DateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateTime"] = this.dateTime ? this.dateTime.toISOString() : <any>undefined;
        data["day"] = this.day;
        data["month"] = this.month;
        data["year"] = this.year;
        data["dayOfYear"] = this.dayOfYear;
        data["dayOfWeek"] = this.dayOfWeek;
        return data;
    }
}

export interface IDateDto {
    dateTime?: Date;
    day?: number;
    month?: number;
    year?: number;
    dayOfYear?: number;
    dayOfWeek?: DayOfWeek;
}

export class DateAndTime implements IDateAndTime {
    gasDay?: GasDay | undefined;
    gasDayHour?: GasDayHour | undefined;
    isEndOfTime?: boolean;

    constructor(data?: IDateAndTime) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gasDay = _data["gasDay"] ? GasDay.fromJS(_data["gasDay"]) : <any>undefined;
            this.gasDayHour = _data["gasDayHour"] ? GasDayHour.fromJS(_data["gasDayHour"]) : <any>undefined;
            this.isEndOfTime = _data["isEndOfTime"];
        }
    }

    static fromJS(data: any): DateAndTime {
        data = typeof data === 'object' ? data : {};
        let result = new DateAndTime();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gasDay"] = this.gasDay ? this.gasDay.toJSON() : <any>undefined;
        data["gasDayHour"] = this.gasDayHour ? this.gasDayHour.toJSON() : <any>undefined;
        data["isEndOfTime"] = this.isEndOfTime;
        return data;
    }
}

export interface IDateAndTime {
    gasDay?: GasDay | undefined;
    gasDayHour?: GasDayHour | undefined;
    isEndOfTime?: boolean;
}

export class DateAndTimeRange implements IDateAndTimeRange {
    begin?: DateAndTime | undefined;
    end?: DateAndTime | undefined;

    constructor(data?: IDateAndTimeRange) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.begin = _data["begin"] ? DateAndTime.fromJS(_data["begin"]) : <any>undefined;
            this.end = _data["end"] ? DateAndTime.fromJS(_data["end"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DateAndTimeRange {
        data = typeof data === 'object' ? data : {};
        let result = new DateAndTimeRange();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["begin"] = this.begin ? this.begin.toJSON() : <any>undefined;
        data["end"] = this.end ? this.end.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDateAndTimeRange {
    begin?: DateAndTime | undefined;
    end?: DateAndTime | undefined;
}

export enum DayOfWeek {
    Sunday = "Sunday",
    Monday = "Monday",
    Tuesday = "Tuesday",
    Wednesday = "Wednesday",
    Thursday = "Thursday",
    Friday = "Friday",
    Saturday = "Saturday",
}

export enum DayType {
    Unknown = "Unknown",
    Short = "Short",
    Normal = "Normal",
    Long = "Long",
}

export class GasDay implements IGasDay {
    firstHour?: GasDayHour | undefined;
    lastHour?: GasDayHour | undefined;
    numberOfHours?: number;
    date?: DateDto | undefined;
    type?: DayType;
    timeZone?: TimeZoneInfo | undefined;

    constructor(data?: IGasDay) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstHour = _data["firstHour"] ? GasDayHour.fromJS(_data["firstHour"]) : <any>undefined;
            this.lastHour = _data["lastHour"] ? GasDayHour.fromJS(_data["lastHour"]) : <any>undefined;
            this.numberOfHours = _data["numberOfHours"];
            this.date = _data["date"] ? DateDto.fromJS(_data["date"]) : <any>undefined;
            this.type = _data["type"];
            this.timeZone = _data["timeZone"] ? TimeZoneInfo.fromJS(_data["timeZone"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GasDay {
        data = typeof data === 'object' ? data : {};
        let result = new GasDay();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstHour"] = this.firstHour ? this.firstHour.toJSON() : <any>undefined;
        data["lastHour"] = this.lastHour ? this.lastHour.toJSON() : <any>undefined;
        data["numberOfHours"] = this.numberOfHours;
        data["date"] = this.date ? this.date.toJSON() : <any>undefined;
        data["type"] = this.type;
        data["timeZone"] = this.timeZone ? this.timeZone.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGasDay {
    firstHour?: GasDayHour | undefined;
    lastHour?: GasDayHour | undefined;
    numberOfHours?: number;
    date?: DateDto | undefined;
    type?: DayType;
    timeZone?: TimeZoneInfo | undefined;
}

export class GasDayHour implements IGasDayHour {
    gasDay?: GasDay | undefined;
    hourNumber?: number;
    displayLabel?: string | undefined;
    displayStartTimeLabel?: string | undefined;
    timeZone?: TimeZoneInfo | undefined;

    constructor(data?: IGasDayHour) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gasDay = _data["gasDay"] ? GasDay.fromJS(_data["gasDay"]) : <any>undefined;
            this.hourNumber = _data["hourNumber"];
            this.displayLabel = _data["displayLabel"];
            this.displayStartTimeLabel = _data["displayStartTimeLabel"];
            this.timeZone = _data["timeZone"] ? TimeZoneInfo.fromJS(_data["timeZone"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GasDayHour {
        data = typeof data === 'object' ? data : {};
        let result = new GasDayHour();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gasDay"] = this.gasDay ? this.gasDay.toJSON() : <any>undefined;
        data["hourNumber"] = this.hourNumber;
        data["displayLabel"] = this.displayLabel;
        data["displayStartTimeLabel"] = this.displayStartTimeLabel;
        data["timeZone"] = this.timeZone ? this.timeZone.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGasDayHour {
    gasDay?: GasDay | undefined;
    hourNumber?: number;
    displayLabel?: string | undefined;
    displayStartTimeLabel?: string | undefined;
    timeZone?: TimeZoneInfo | undefined;
}

export class MessageIdentificationContextDto implements IMessageIdentificationContextDto {
    id?: string | undefined;
    messageTypeCode?: string | undefined;
    senderInternalCode?: string | undefined;
    receiverInternalCode?: string | undefined;
    applicationContext?: string | undefined;
    validFrom?: Date;
    validTo?: Date;
    isNewContext?: boolean;
    messageIdentificationDetailDtos?: MessageIdentificationDetailDto[] | undefined;
    messageIdentificationWithHighestAllottedNumber?: MessageIdentificationDetailDto | undefined;
    messageIdentificationWithHighestVersionNumber?: MessageIdentificationDetailDto | undefined;
    validityPeriod?: DateAndTimeRange | undefined;

    constructor(data?: IMessageIdentificationContextDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.messageTypeCode = _data["messageTypeCode"];
            this.senderInternalCode = _data["senderInternalCode"];
            this.receiverInternalCode = _data["receiverInternalCode"];
            this.applicationContext = _data["applicationContext"];
            this.validFrom = _data["validFrom"] ? new Date(_data["validFrom"].toString()) : <any>undefined;
            this.validTo = _data["validTo"] ? new Date(_data["validTo"].toString()) : <any>undefined;
            this.isNewContext = _data["isNewContext"];
            if (Array.isArray(_data["messageIdentificationDetailDtos"])) {
                this.messageIdentificationDetailDtos = [] as any;
                for (let item of _data["messageIdentificationDetailDtos"])
                    this.messageIdentificationDetailDtos!.push(MessageIdentificationDetailDto.fromJS(item));
            }
            this.messageIdentificationWithHighestAllottedNumber = _data["messageIdentificationWithHighestAllottedNumber"] ? MessageIdentificationDetailDto.fromJS(_data["messageIdentificationWithHighestAllottedNumber"]) : <any>undefined;
            this.messageIdentificationWithHighestVersionNumber = _data["messageIdentificationWithHighestVersionNumber"] ? MessageIdentificationDetailDto.fromJS(_data["messageIdentificationWithHighestVersionNumber"]) : <any>undefined;
            this.validityPeriod = _data["validityPeriod"] ? DateAndTimeRange.fromJS(_data["validityPeriod"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MessageIdentificationContextDto {
        data = typeof data === 'object' ? data : {};
        let result = new MessageIdentificationContextDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["messageTypeCode"] = this.messageTypeCode;
        data["senderInternalCode"] = this.senderInternalCode;
        data["receiverInternalCode"] = this.receiverInternalCode;
        data["applicationContext"] = this.applicationContext;
        data["validFrom"] = this.validFrom ? this.validFrom.toISOString() : <any>undefined;
        data["validTo"] = this.validTo ? this.validTo.toISOString() : <any>undefined;
        data["isNewContext"] = this.isNewContext;
        if (Array.isArray(this.messageIdentificationDetailDtos)) {
            data["messageIdentificationDetailDtos"] = [];
            for (let item of this.messageIdentificationDetailDtos)
                data["messageIdentificationDetailDtos"].push(item.toJSON());
        }
        data["messageIdentificationWithHighestAllottedNumber"] = this.messageIdentificationWithHighestAllottedNumber ? this.messageIdentificationWithHighestAllottedNumber.toJSON() : <any>undefined;
        data["messageIdentificationWithHighestVersionNumber"] = this.messageIdentificationWithHighestVersionNumber ? this.messageIdentificationWithHighestVersionNumber.toJSON() : <any>undefined;
        data["validityPeriod"] = this.validityPeriod ? this.validityPeriod.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMessageIdentificationContextDto {
    id?: string | undefined;
    messageTypeCode?: string | undefined;
    senderInternalCode?: string | undefined;
    receiverInternalCode?: string | undefined;
    applicationContext?: string | undefined;
    validFrom?: Date;
    validTo?: Date;
    isNewContext?: boolean;
    messageIdentificationDetailDtos?: MessageIdentificationDetailDto[] | undefined;
    messageIdentificationWithHighestAllottedNumber?: MessageIdentificationDetailDto | undefined;
    messageIdentificationWithHighestVersionNumber?: MessageIdentificationDetailDto | undefined;
    validityPeriod?: DateAndTimeRange | undefined;
}

export class MessageIdentificationDetailDto implements IMessageIdentificationDetailDto {
    id?: string | undefined;
    messageIdentificationContextId?: number;
    messageVersionNumber?: number;
    messageIdentification?: string | undefined;
    allottedNumber?: number;

    constructor(data?: IMessageIdentificationDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.messageIdentificationContextId = _data["messageIdentificationContextId"];
            this.messageVersionNumber = _data["messageVersionNumber"];
            this.messageIdentification = _data["messageIdentification"];
            this.allottedNumber = _data["allottedNumber"];
        }
    }

    static fromJS(data: any): MessageIdentificationDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new MessageIdentificationDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["messageIdentificationContextId"] = this.messageIdentificationContextId;
        data["messageVersionNumber"] = this.messageVersionNumber;
        data["messageIdentification"] = this.messageIdentification;
        data["allottedNumber"] = this.allottedNumber;
        return data;
    }
}

export interface IMessageIdentificationDetailDto {
    id?: string | undefined;
    messageIdentificationContextId?: number;
    messageVersionNumber?: number;
    messageIdentification?: string | undefined;
    allottedNumber?: number;
}

export class TimeSpan implements ITimeSpan {
    ticks?: number;
    days?: number;
    hours?: number;
    milliseconds?: number;
    minutes?: number;
    seconds?: number;
    totalDays?: number;
    totalHours?: number;
    totalMilliseconds?: number;
    totalMinutes?: number;
    totalSeconds?: number;

    constructor(data?: ITimeSpan) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ticks = _data["ticks"];
            this.days = _data["days"];
            this.hours = _data["hours"];
            this.milliseconds = _data["milliseconds"];
            this.minutes = _data["minutes"];
            this.seconds = _data["seconds"];
            this.totalDays = _data["totalDays"];
            this.totalHours = _data["totalHours"];
            this.totalMilliseconds = _data["totalMilliseconds"];
            this.totalMinutes = _data["totalMinutes"];
            this.totalSeconds = _data["totalSeconds"];
        }
    }

    static fromJS(data: any): TimeSpan {
        data = typeof data === 'object' ? data : {};
        let result = new TimeSpan();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ticks"] = this.ticks;
        data["days"] = this.days;
        data["hours"] = this.hours;
        data["milliseconds"] = this.milliseconds;
        data["minutes"] = this.minutes;
        data["seconds"] = this.seconds;
        data["totalDays"] = this.totalDays;
        data["totalHours"] = this.totalHours;
        data["totalMilliseconds"] = this.totalMilliseconds;
        data["totalMinutes"] = this.totalMinutes;
        data["totalSeconds"] = this.totalSeconds;
        return data;
    }
}

export interface ITimeSpan {
    ticks?: number;
    days?: number;
    hours?: number;
    milliseconds?: number;
    minutes?: number;
    seconds?: number;
    totalDays?: number;
    totalHours?: number;
    totalMilliseconds?: number;
    totalMinutes?: number;
    totalSeconds?: number;
}

export class TimeZoneInfo implements ITimeZoneInfo {
    id?: string | undefined;
    hasIanaId?: boolean;
    displayName?: string | undefined;
    standardName?: string | undefined;
    daylightName?: string | undefined;
    baseUtcOffset?: TimeSpan | undefined;
    supportsDaylightSavingTime?: boolean;

    constructor(data?: ITimeZoneInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.hasIanaId = _data["hasIanaId"];
            this.displayName = _data["displayName"];
            this.standardName = _data["standardName"];
            this.daylightName = _data["daylightName"];
            this.baseUtcOffset = _data["baseUtcOffset"] ? TimeSpan.fromJS(_data["baseUtcOffset"]) : <any>undefined;
            this.supportsDaylightSavingTime = _data["supportsDaylightSavingTime"];
        }
    }

    static fromJS(data: any): TimeZoneInfo {
        data = typeof data === 'object' ? data : {};
        let result = new TimeZoneInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["hasIanaId"] = this.hasIanaId;
        data["displayName"] = this.displayName;
        data["standardName"] = this.standardName;
        data["daylightName"] = this.daylightName;
        data["baseUtcOffset"] = this.baseUtcOffset ? this.baseUtcOffset.toJSON() : <any>undefined;
        data["supportsDaylightSavingTime"] = this.supportsDaylightSavingTime;
        return data;
    }
}

export interface ITimeZoneInfo {
    id?: string | undefined;
    hasIanaId?: boolean;
    displayName?: string | undefined;
    standardName?: string | undefined;
    daylightName?: string | undefined;
    baseUtcOffset?: TimeSpan | undefined;
    supportsDaylightSavingTime?: boolean;
}

export class TenantDto implements ITenantDto {
    code?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    id?: string | undefined;
    maintenanceMode?: boolean;

    constructor(data?: ITenantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.id = _data["id"];
            this.maintenanceMode = _data["maintenanceMode"];
        }
    }

    static fromJS(data: any): TenantDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["description"] = this.description;
        data["id"] = this.id;
        data["maintenanceMode"] = this.maintenanceMode;
        return data;
    }
}

export interface ITenantDto {
    code?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    id?: string | undefined;
    maintenanceMode?: boolean;
}

export enum Direction {
    In = "In",
    Out = "Out",
}

export enum ExternalProtocolCode {
    Unspecified = "Unspecified",
    As2 = "As2",
    Ftps = "Ftps",
    Soap = "Soap",
    Excluded = "Excluded",
    Http = "Http",
    Sftp = "Sftp",
    As4 = "As4",
    Amqp = "Amqp",
    BulkInjector = "BulkInjector",
    Sharepoint = "Sharepoint",
    Rest = "Rest",
}

export enum MapStage {
    Original = "Original",
    Intermediate = "Intermediate",
    Mapped = "Mapped",
    Email = "Email",
    MappedEncrypted = "MappedEncrypted",
}

export enum DimensionRange {
    ALL = "ALL",
    LIMITED = "LIMITED",
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export class Body implements IBody {
    file?: string;
    isForEntsogPublicCertificate?: boolean;

    [key: string]: any;

    constructor(data?: IBody) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.file = _data["File"];
            this.isForEntsogPublicCertificate = _data["IsForEntsogPublicCertificate"];
        }
    }

    static fromJS(data: any): Body {
        data = typeof data === 'object' ? data : {};
        let result = new Body();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["File"] = this.file;
        data["IsForEntsogPublicCertificate"] = this.isForEntsogPublicCertificate;
        return data;
    }
}

export interface IBody {
    file?: string;
    isForEntsogPublicCertificate?: boolean;

    [key: string]: any;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}